import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { collection, query as firestoreQuery, where, getDocs, doc, updateDoc, getDoc, writeBatch, deleteDoc, addDoc, arrayUnion, arrayRemove, increment, orderBy } from "firebase/firestore";
import { firestore } from '../firebase.js';
import { usePremium } from '../util/PremiumFilter.js';
import axios from 'axios';
import { sortCommentsByUserPremium } from '../util/userUtils.js';
import { cleanProfanity } from '../util/filterProfanity';


import BoardThree from '../components/WorkingChessLogic/3Board.jsx';
import ControlsThree from '../components/WorkingChessLogic/3Controls.jsx';
import MovesThree from '../components/WorkingChessLogic/3Moves.jsx';
import SetupDefaults from '../components/WorkingChessLogic/SetupDefaults.js';
import { useGameState } from '../components/WorkingChessLogic/GameStateContext.js';
import useGameLogic from '../components/WorkingChessLogic/UseGameState.js';
import { createStartPosition } from '../util/PositionData';

import useStockfishAnalysisManager from '../hooks/useStockfishAnalysisManager';

import ScreamSkeleton from '../util/ScreamSkeleton.js';

import BrilliantGray from '../images/FooterIcons/Brilliance2.png';
import BrilliantBlue from '../images/FooterIcons/Brilliance4.png';

import { connect } from 'react-redux';
import { getScreams } from '../redux/actions/dataActions.js';
import Board from '../components/ArchivedChess/Board.jsx';
import { Chess } from 'chess.js';
import Controls from '../components/ArchivedChess/Controls.jsx';
import {
  fetchGame,
  fetchNextGame,
  fetchPrevGame,
  putGame,
} from '../util/api/game.js';
import {
  getFlippedBoardOrientation,
  getMove,
  onNextMove,
  onPrevMove,
  updateCommentIdInMoves,
  parseMove,
  getPrevMoveNotation,
  isMoveValid,
  getLines,
  destructureLine,
  isVariationMove,
  getTurnInFen,

} from '../util/Chess.js';
import { filterInPlace } from '../util/helpers.js';
import AddComment from '../components/WorkingChessLogic/AddComment2.jsx';
import { checkRateLimit } from '../util/rateLimiter';
import { getRateLimit, buildRateKey } from '../util/rateLimitConfig';
import { ChessSocialContext } from '../util/ChessSocialContext.js';
import NewGameAccessModal from '../components/modals/NewGameAccessModal.js';
import { TAGS } from "../util/constants.js"
import constants from "../util/constants.js";
import GameTitle from './Components/123GameTitle.js';

import StockfishAnalysisPanel from '../components/ArchivedChess/StockfishAnalysisPanel.jsx';

// import Stockfish from '../components/Chess2/Stockfish.js';
import StockfishEval from '../components/ArchivedChess/StockfishEval.js'; // Added StockfishEval import
import ShareGameModal from '../components/modals/ShareGameModal.js';
import BookmarkModal from '../components/modals/BookmarkModal.js';
import ReportCommentModal from '../components/modals/ReportCommentModal.js';
import GameSettingsPopup from '../components/modals/GameSettingsPopup.js';
import UndoConfirmModal from '../components/modals/UndoConfirmModal.jsx';
import RateLimitModal from '../components/modals/RateLimitModal.js';
import ChessAnalysisWrapper from '../util/ChessAnalysisWrapper.jsx'; // Import ChessAnalysisWrapper
import { useChessAnalysis } from '../util/ChessAnalysisContext.js'; // Import useChessAnalysis hook
import stockfishEngine from '../util/StockfishEngine.js'; // Import stockfishEngine singleton
import { getCurrentBoardPosition } from '../components/WorkingChessLogic/UseGameState.js';

// Global variable to track if we're in the games section
let isInGamesSection = false;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewGame2 = (props) => {
  // Add a render counter for debugging
  const renderCount = useRef(0);
  useEffect(() => {
    renderCount.current += 1;
    
  }, []);

  // Add the context state
const { state, dispatch } = useGameState();
const { 
  moves: contextMoves, 
  currentMove: contextCurrentMove, 
  orientation: contextOrientation,
  starredMoves: contextStarredMoves,
  rootFEN: contextRootFEN
} = state;

// Create dispatch wrappers for state updates
const setContextMoves = (newMoves) => dispatch({ type: 'SET_MOVES', payload: newMoves });
const setContextOrientation = (newOrientation) => dispatch({ type: 'SET_ORIENTATION', payload: newOrientation });

// Helper function to check if two moves are within the same variation path
const isWithinSameVariation = (currentMove, targetMove) => {
  const currentStr = String(currentMove);
  const targetStr = String(targetMove);
  
  // Extract variation paths for comparison
  // THIS MAY NEED ADJUUSTMENTS after nested variations are permitted.
  const getVariationPath = (moveStr) => {
    if (!moveStr || moveStr === '-1') return null;
    const parts = moveStr.split('|');
    return parts.length > 1 ? parts[0] : null; // Return parent move index if in variation
  };

  const currentVariationPath = getVariationPath(currentStr);
  const targetVariationPath = getVariationPath(targetStr);
  
  // Both moves must be in variations and have the same parent path
  return currentVariationPath && targetVariationPath && currentVariationPath === targetVariationPath;
};

const goToContextMove = (moveId) => {
  

  // If no active comment variation, allow navigation immediately
  if (!isVariationActive || !variationToComment) {
    
    return dispatch({ type: 'GOTO_MOVE', payload: moveId });
  }

  // Allow navigation within the same comment variation
  if (isWithinSameVariation(currentMoveIdx, moveId)) {
    
    return dispatch({ type: 'GOTO_MOVE', payload: moveId });
  }

  // Bypass confirmation during undo operations
  if (isUndoOperationRef.current) {
    
    return dispatch({ type: 'GOTO_MOVE', payload: moveId });
  }

  // User is trying to leave the active comment variation - show confirmation dialog
  
  setPendingTargetMove(moveId);
  setPendingAction('navigate');
  setShowVariationDeleteConfirm(true);
  
  // Return false to indicate navigation was blocked
  return false;
};

const toggleStarredMove = (moveId) => dispatch({ type: 'TOGGLE_STAR_MOVE', payload: moveId });
const setContextFEN = (fen) => dispatch({ type: 'SET_FEN', payload: fen });

// Use context values consistently instead of creating local copies
// This comment helps identify where we're using context directly
const moves = contextMoves;
const currentMove = contextCurrentMove;
const orientation = contextOrientation;
const starredMoves = contextStarredMoves;
const rootFEN = contextRootFEN || 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

// Add the game logic functions
const { 
  goToMove, 
  prevMove: contextPrevMove, 
  nextMove: contextNextMove, 
  jumpToLast: contextJumpToLast, 
  undoMove: contextUndoMove 
} = useGameLogic();

  // Add premium context
  const { isPremiumUser, premiumTier, PREMIUM_TIERS } = usePremium();

  const location = useLocation(); // Use the hook here
  const query = useQuery();
  const history = useHistory();
  const ctx = query.get('ctx');
  const orderByParam = query.get('orderBy');
  const tag = query.get('tag');
  const userId = query.get('userId');
  const fromBookmark = query.get('fromBookmark') === 'true';
  const folderName = query.get('folderName');
  const folderIndex = query.get('folderIndex') ? parseInt(query.get('folderIndex')) : null;

  // Add new URL parameters for profile navigation context
  const fromProfile = query.get('fromProfile') === 'true';
  const profileUserId = query.get('profileUserId');

  // Add URL parameters for ALL GAMES navigation from profile
  const fromAllGames = query.get('fromAllGames') === 'true';
  const creatorId = query.get('creatorId');
  const gameIndex = query.get('gameIndex') ? parseInt(query.get('gameIndex')) : null;

  const { renderUserWithBadge } = usePremium();
  // Show modal only when ctx=newGame parameter is present
  const [showNewGameModal, setShowNewGameModal] = useState(ctx === 'newGame');

  // Replace constant with state to ensure it updates when data loads
  const [postCreator, setPostCreator] = useState(null);

  const [commentCaption, setCommentCaption] = useState("");
  const [variationContent, setVariationContent] = useState("");

  // NEW: State to track when comment inputs are focused (to disable keyboard hotkeys)
  const [isCommentInputFocused, setIsCommentInputFocused] = useState(false);

  // Rate limit modal state
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);

  // Helper function to show rate limit modal
  const showRateLimitError = () => {
    setShowRateLimitModal(true);
  };

  const [commentPreviewMoves, setCommentPreviewMoves] = useState({
    parentMove: null,
    variationMove: null,
    commentId: null
  });




  // Set up the control panel tooltips styling
  useEffect(() => {
    const styleEl = document.createElement('style');
    styleEl.id = 'engine-panel-tooltip-styles';
    styleEl.textContent = `
      .engine-panel-btn .engine-panel-tooltip {
        visibility: hidden;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -30px;
        background-color: rgba(0, 0, 0, 0.8);
        color: gold;
        text-align: center;
        border-radius: 4px;
        padding: 5px 8px;
        white-space: nowrap;
        z-index: 200;
        font-size: 12px;
        opacity: 0;
        transition: opacity 0.3s;
      }
      
      .engine-panel-btn:hover .engine-panel-tooltip {
        visibility: visible;
        opacity: 1;
      }
    `;
    document.head.appendChild(styleEl);

    return () => {
      if (document.getElementById('engine-panel-tooltip-styles')) {
        document.head.removeChild(styleEl);
      }
    };
  }, []);

  // Update postCreator when gameMetadata changes
  useEffect(() => {
    if (props?.gameMetadata?.creatorHandle) {
      setPostCreator(props.gameMetadata.creatorHandle);

    }
  }, [props.gameMetadata]);

  // Add state to track if we've already cleaned the URL
  const [urlCleaned, setUrlCleaned] = useState(false);

  // Get chess analysis context
  const { setCurrentPosition, setEngineReady, isAnalyzing: chessAnalysisIsAnalyzing } = useChessAnalysis();

  // State to track if Stockfish is initialized
  const [stockfishInitialized, setStockfishInitialized] = useState(false);

  // FEN tracking state for StockfishAnalysisPanel
  const [currentFen, setCurrentFen] = useState('');
  const lastFenRef = useRef(''); // Track the last FEN to prevent loops

  // Add state to track cached analysis and analyzing status (like 2AddGame.js)
  const [hasAnalysisCache, setHasAnalysisCache] = useState(false);
  const [currentAnalysisCache, setCurrentAnalysisCache] = useState(null);

  // Clean up URL on initial load if ctx=newGame is present
  useEffect(() => {
    if (ctx === 'newGame' && !urlCleaned) {
      // We'll clean the URL but keep the modal state as true
      const cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
      setUrlCleaned(true);
    }
  }, [ctx, urlCleaned]);

  // Add a ref to track stockfish initialization status
  const stockfishInitializedRef = useRef(false);
  
  // Initialize Stockfish when the component mounts
  useEffect(() => {
    const initializeStockfish = async () => {
      // Skip if already initialized
      if (stockfishInitializedRef.current) {
        return;
      }
      
      try {
        await stockfishEngine.init();
        setStockfishInitialized(true);
        stockfishInitializedRef.current = true;
        setEngineReady(true);
        isInGamesSection = true;
      } catch (error) {
        console.error('Failed to initialize Stockfish:', error);
        setStockfishInitialized(false);
        stockfishInitializedRef.current = false;
      }
    };

    // Initialize Stockfish if not already done
    initializeStockfish();

    // Listen for route changes to maintain Stockfish state
    const unlisten = history.listen((location) => {
      if (location.pathname.includes('/games/')) {
        // Still in games section, ensure Stockfish is initialized
        isInGamesSection = true;
        if (!stockfishInitializedRef.current) {
          initializeStockfish();
        }
      } else {
        // Leaving games section
        isInGamesSection = false;
      }
    });

    // Cleanup function
    return () => {
      unlisten();
      // Only clean up Stockfish when navigating away from games routes
      if (!history.location.pathname.includes('/games/')) {
        stockfishEngine.destroy();
        isInGamesSection = false;
        setStockfishInitialized(false);
        stockfishInitializedRef.current = false;
        setEngineReady(false);
      }
    };
  }, [history, setEngineReady]); // Removed stockfishInitialized from dependencies

  const containerRef = useRef(null);
  const [boardSize, setBoardSize] = useState(500);

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const viewportWidth = window.innerWidth;
        const availableWidth = viewportWidth - 875;

        // Now container and board will be same size
        const containerSize = Math.min(availableWidth, 900);
        const boardSize = Math.max(containerSize, 500);

        setBoardSize(boardSize);
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const {
    isSidebarCollapsed,
    showStockfish,
    setShowStockfish,
    showEmoji,
    setShowEmoji,
    showStockfishIcons,
    setShowStockfishIcons,
    showArrows,
    setShowArrows,
    evaluation,
    showStockfishEval,
    setShowStockfishEval
  } = useContext(ChessSocialContext);
  // Initialize fetchingGame as false to allow initial fetch
  const [fetchingGame, setFetchingGame] = useState(false);

  const [game, setGame] = useState();
  const [gameMetadata, setGameMetadata] = useState();

  // const gameId =
  //   props.location.pathname === '/' ? '<first>' : props?.match?.params?.gameId;

  // With this more robust version:
const pathParts = location.pathname.split('/');
const gameIdFromPath = pathParts[pathParts.length - 1]; // Get last segment of path
const gameId = location.pathname === '/' ? '<first>' : gameIdFromPath;


  // const [starredMoves, setStarredMoves] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showBookmarkModal, setShowBookmarkModal] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [likedComments, setLikedComments] = useState(new Set());
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportingComment, setReportingComment] = useState(null);
  const [openModalType, setOpenModalType] = useState('');
  const [expandedAnnotation, setExpandedAnnotation] = useState(false);
  const [expandedAnnotationContent, setExpandedAnnotationContent] = useState('');
  const authenticatedUserHandle = props?.user?.credentials?.handle; // Current logged-in user's handle

  const [tempCommentIndex, setTempCommentIndex] = useState(null);
  const [tempGameId, setTempGameId] = useState(null);

  // Add these state variables near other state variables
  const [boardStartingTurn, setBoardStartingTurn] = useState('w');

  // Replace the merged effects with a more streamlined version
  useEffect(() => {
    if (gameMetadata && gameMetadata.fen) {
      const newFen = gameMetadata.fen;
      
      // Only update FEN if it's changed
      if (rootFEN !== newFen) {
        
        dispatch({ type: 'SET_ROOT_FEN', payload: newFen });
        
        try {
          // Extract turn from FEN
          const fenTurn = getTurnInFen(newFen);
          setBoardStartingTurn(fenTurn || 'w');
        } catch (error) {
          console.error('Error parsing FEN for turn:', error);
          setBoardStartingTurn('w'); // Default to white if there's an error
        }
      }
    }
  }, [gameMetadata, dispatch, rootFEN]);

  
  const [folderGames, setFolderGames] = useState([]);
  const [currentFolderIndex, setCurrentFolderIndex] = useState(null);

  // Add state for ALL GAMES navigation
  const [creatorGames, setCreatorGames] = useState([]);
  const [currentCreatorGameIndex, setCurrentCreatorGameIndex] = useState(null);

  const [isAuthenticatedUser, setIsAuthenticatedUser] = useState(!!props.user?.credentials?.userId);
  // Add state for variation detection
  const [hasVisibleVariations, setHasVisibleVariations] = useState(false);

  // Add state for GameSettingsPopup visibility
  const [showGameSettings, setShowGameSettings] = useState(false);
  // Add state to track if the settings was opened manually
  const [manualSettingsOpen, setManualSettingsOpen] = useState(false);
  // Add state to track if current game is a puzzle or challenge
  const [gameHasPuzzleTag, setGameHasPuzzleTag] = useState(false);
  const [gameHasChallengeTag, setGameHasChallengeTag] = useState(false);
  // State to track puzzle status
  const [puzzleState, setPuzzleState] = useState('incorrect'); // 'incorrect' or 'completed'
  const [isProveMeWrongMode, setIsProveMeWrongMode] = useState(false);
  
  // Set window.isPuzzleMode for Board component to detect puzzle mode
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.isPuzzleMode = gameHasPuzzleTag && puzzleState !== 'completed';
    }
    // Cleanup when component unmounts
    return () => {
      if (typeof window !== 'undefined') {
        window.isPuzzleMode = false;
      }
    };
  }, [gameHasPuzzleTag, puzzleState]);

  // State to track which moves have been revealed in puzzle mode
  const [revealedMoves, setRevealedMoves] = useState([]);
  // Add state to track the most recently revealed move for animation
  const [lastRevealedMove, setLastRevealedMove] = useState(null);
  // Add state for UndoConfirmModal
  const [showUndoConfirmModal, setShowUndoConfirmModal] = useState(false);
  
  // Add ref to bypass delete confirmation during undo operations (using ref for immediate updates)
  const isUndoOperationRef = useRef(false);

  // Add state for tab management
  const [expandedTab, setExpandedTab] = useState('gameInfo'); // 'gameInfo' or 'social'
  const [commentPreview, setCommentPreview] = useState([]);
  const [isVariationActive, setIsVariationActive] = useState(false);
  const [variationToComment, setVariationToComment] = useState(null);
  const [newComment, setNewComment] = useState(''); // Add state for standard comments
    const [linkToMove, setLinkToMove] = useState(false); // NEW: State for move-linking checkbox
  const [moveFocusedSorting, setMoveFocusedSorting] = useState(null); // NEW: State for move-focused comment sorting

  // NEW: Function to capture current move data for move-linked comments
  const captureMoveData = () => {
    if (!linkToMove) return null;

    try {
      // Special handling for start position (-1)
      if (currentMoveIdx === '-1') {
        return {
          moveIndex: '-1',
          moveNotation: 'Start Position',
          moveFEN: window.currentFEN || '',
          moveFromSquare: '', // No move squares for start position
          moveToSquare: '',
          parentMoveIndex: '-1' // No parent for start position
        };
      }

      // Get current move notation and details
      const currentMoveObj = getMoveObject(currentMoveIdx);
      const moveNotation = currentMoveObj?.notation || '';
      
      // Get current FEN from the board state
      const moveFEN = window.currentFEN || '';
      
      // Get move squares for highlighting
      const moveFromSquare = currentMoveObj?.from || '';
      const moveToSquare = currentMoveObj?.to || '';
      
      // Get parent move index for variations
      const parentMoveIndex = currentMoveIdx.includes('|') 
        ? currentMoveIdx.split('|')[0] 
        : (parseInt(currentMoveIdx) > 0 ? String(parseInt(currentMoveIdx) - 1) : '-1');
      
      return {
        moveIndex: currentMoveIdx,
        moveNotation: moveNotation,
        moveFEN: moveFEN,
        moveFromSquare: moveFromSquare,
        moveToSquare: moveToSquare,
        parentMoveIndex: parentMoveIndex
      };
    } catch (error) {
      console.error('[ViewGame] Error capturing move data:', error);
      return null;
    }
  };
  
    // Add state for storing premium data of comment users
  const [commentUserPremiumData, setCommentUserPremiumData] = useState({});
  
  // State for login prompt visibility
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

  // COMMENTED OUT - FEN tracking useEffect accesses currentMoveIdx before declaration
  // // FEN TRACKING - Connect currentFen to existing game state (placed after game state declaration)
  // useEffect(() => {
  //   if (game) {
  //     const newFen = game.fen();
  //     if (newFen !== currentFen) {
  //       setCurrentFen(newFen);
  //       // Update global window.currentFEN for compatibility
  //       window.currentFEN = newFen;
  //     }
  //   }
  // }, [game, currentMoveIdx, currentFen]);

  /**
   * Get a sorted list of comments based on the context
   * @returns {Array} - Sorted array of comments
   */
  const getSortedComments = () => {
    // Early return if there's no data
    if (!gameMetadata || !gameMetadata.comments) return [];

    let enrichedComments = [...gameMetadata.comments].map(comment => {
      // Enhanced recursive function to find comment moves in nested variations
      const findCommentMovesRecursive = (movesArray) => {
        if (!movesArray || !movesArray.length) return false;
        
        const scanForCommentMoves = (moves, path = "") => {
          if (!moves || !moves.length) return false;
          
          for (let moveIndex = 0; moveIndex < moves.length; moveIndex++) {
            const move = moves[moveIndex];
            
            // Check if this move is a comment move with matching ID
            if (move?.creator?.type === 'COMMENT' && move?.creator?.id === comment.id) {
              return true;
            }
            
            // Recursively check variations
            if (move.variations && move.variations.length) {
              for (let varIndex = 0; varIndex < move.variations.length; varIndex++) {
                const variation = move.variations[varIndex];
                if (scanForCommentMoves(variation, `${path}${moveIndex}|${varIndex}:`)) {
                  return true;
                }
              }
            }
          }
          return false;
        };
        
        return scanForCommentMoves(movesArray);
      };
      
      // Check for moves associated with this comment using recursive search
      const hasVariationMoves = findCommentMovesRecursive(moves);
      
      // NEW: Check if this is a move-linked comment (has moveIndex field)
      const isMoveLinked = comment.moveIndex !== undefined && comment.moveIndex !== null;

      // Enrich with premium data and likes count
      return {
        ...comment,
        userPremium: commentUserPremiumData[comment.username] || 0,
        likesCount: comment.likes ? comment.likes.length : 0,
        hasMoves: hasVariationMoves || isMoveLinked // Treat move-linked comments as having moves
      };
    });

    // For the expanded social tab, we use a more complex sorting
    if (expandedTab === 'social') {
      // NEW: Move-focused sorting takes priority
      if (moveFocusedSorting) {
        // console.log('[ViewGame] Applying move-focused sorting for move:', moveFocusedSorting);
        
        // 1. Move-linked comments for the focused move (simple text comments)
        const focusedMoveLinked = enrichedComments.filter(comment => 
          comment.moveIndex === moveFocusedSorting
        );
        
        // 2. Variation comments that branch from the focused move
        const focusedVariations = enrichedComments.filter(comment => {
          if (comment.moveIndex === moveFocusedSorting) return false; // Already in group 1
          
          // Check if this comment has variation moves that branch from the focused move
          const findCommentVariationsFromParent = (movesArray, targetParentIndex) => {
            if (!movesArray || !movesArray.length) return false;
            
            // Convert targetParentIndex to number for comparison
            const parentIndex = parseInt(targetParentIndex, 10);
            if (isNaN(parentIndex) || parentIndex < 0 || parentIndex >= movesArray.length) {
              return false;
            }
            
            // Check the specific parent move for variations containing this comment
            const parentMove = movesArray[parentIndex];
            if (!parentMove?.variations) return false;
            
            // Look through all variations of the parent move
            for (const variation of parentMove.variations) {
              // Check if this variation contains comment moves by this comment's creator
              const hasCommentByThisUser = variation.some(varMove => 
                varMove?.creator?.type === 'COMMENT' && 
                varMove?.creator?.id === comment.id
              );
              
              if (hasCommentByThisUser) {
                return true;
              }
            }
            
            return false;
          };
          
          return findCommentVariationsFromParent(moves, moveFocusedSorting);
        });
        
        // 3. All other comments with moves
        const otherWithMoves = enrichedComments.filter(comment => 
          comment.hasMoves && 
          comment.moveIndex !== moveFocusedSorting &&
          !focusedVariations.includes(comment)
        );
        
        // 4. Regular text comments
        const withoutMoves = enrichedComments.filter(comment => !comment.hasMoves);

        // Sort each group by premium status
        const sortedFocusedMoveLinked = sortCommentsByUserPremium(focusedMoveLinked);
        const sortedFocusedVariations = sortCommentsByUserPremium(focusedVariations);
        const sortedOtherWithMoves = sortCommentsByUserPremium(otherWithMoves);
        const sortedWithoutMoves = sortCommentsByUserPremium(withoutMoves);

        // Combine all sorted arrays with new priority
        return [...sortedFocusedMoveLinked, ...sortedFocusedVariations, ...sortedOtherWithMoves, ...sortedWithoutMoves];
      }
      
      // Default sorting (when not in move-focused mode)
      // First sort by hasMoves flag (true first)
      const withMoves = enrichedComments.filter(comment => comment.hasMoves);
      const withoutMoves = enrichedComments.filter(comment => !comment.hasMoves);

      // Then sort each group by premium status
      const sortedWithMoves = sortCommentsByUserPremium(withMoves);
      const sortedWithoutMoves = sortCommentsByUserPremium(withoutMoves);

      // Combine the two sorted arrays
      return [...sortedWithMoves, ...sortedWithoutMoves];
    } else {
      // For Game Tab expanded or Social Tab collapsed, just sort by premium status
      // We also limit to 2 comments in collapsed view
      const sorted = sortCommentsByUserPremium(enrichedComments);
      return expandedTab === 'game' ? sorted : sorted.slice(0, 2);
    }
  };

  // Function to fetch premium data for comment users
  const fetchCommentUserPremiumData = async (usernames) => {
    if (!usernames || usernames.length === 0) return;
    
    try {
      // Filter out usernames we already have data for
      const usernamesToFetch = usernames.filter(
        username => commentUserPremiumData[username] === undefined
      );
      
      if (usernamesToFetch.length === 0) return;
      
      // Fetch premium data for each username
      const promises = usernamesToFetch.map(username => 
        axios.get(`/user/${username}`)
          .then(response => {
            if (response.data && response.data.user) {
              return { username, premium: response.data.user.premium };
            }
            return { username, premium: 0 };
          })
          .catch(() => ({ username, premium: 0 }))
      );
      
      const results = await Promise.all(promises);
      
      // Update premium data state
      setCommentUserPremiumData(prev => {
        const updatedData = { ...prev };
        results.forEach(result => {
          updatedData[result.username] = result.premium;
        });
        return updatedData;
      });
    } catch (error) {
      console.error('Error fetching comment user premium data:', error);
    }
  };

  // Add useEffect to fetch premium data for comment users when gameMetadata changes
  useEffect(() => {
    if (gameMetadata?.comments && gameMetadata.comments.length > 0) {
      // Extract unique usernames from comments
      const commentUsernames = gameMetadata.comments
        .map(comment => comment.username)
        .filter((username, index, self) => 
          username && self.indexOf(username) === index
        );
      
      // Fetch premium data for these usernames
      fetchCommentUserPremiumData(commentUsernames);
    }
  }, [gameMetadata]);

  const [loginPrompt, setLoginPrompt] = useState(false);
  const [reportReason, setReportReason] = useState('');

  // State for variation deletion confirmation
  const [showVariationDeleteConfirm, setShowVariationDeleteConfirm] = useState(false);
  const [pendingTargetMove, setPendingTargetMove] = useState(null);
  const [pendingAction, setPendingAction] = useState(null); // 'delete' or 'navigate'
  const [pendingTabSwitch, setPendingTabSwitch] = useState(null); // NEW: Track pending tab switches

  // State for the chess-board icon control panel
  const [showControlPanel, setShowControlPanel] = useState(false);
  const boardIconRef = useRef(null);
  const controlPanelRef = useRef(null);
  const boardRef = useRef(null);

  // State to track if player panels are expanded
  const [playerPanelsExpanded, setPlayerPanelsExpanded] = useState(false);

  // Check panel state periodically
  useEffect(() => {
    const checkPanelState = () => {
      if (boardRef.current && boardRef.current.areBothPlayerPanelsExpanded) {
        setPlayerPanelsExpanded(boardRef.current.areBothPlayerPanelsExpanded());
      }
    };

    // Check immediately and then set up an interval
    checkPanelState();
    const interval = setInterval(checkPanelState, 200);

    return () => clearInterval(interval);
  }, []);

  // Close the control panel when clicking outside
  useEffect(() => {
    if (showControlPanel) {
      const handleClickOutside = (event) => {
        if (
          controlPanelRef.current &&
          !controlPanelRef.current.contains(event.target) &&
          boardIconRef.current &&
          !boardIconRef.current.contains(event.target)
        ) {
          setShowControlPanel(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showControlPanel]);

  // Function to determine the robot icon color based on active features
  const getRobotColor = () => {
    return (showStockfishEval || showStockfish) ? 'rgb(76, 175, 80)' : '#ff0050';
  };

  // Handler for player info click from GameTitle
  const handlePlayerInfoClick = () => {
    if (boardRef.current) {
      // If both panels are expanded, close them; otherwise open them
      if (boardRef.current.areBothPlayerPanelsExpanded && boardRef.current.areBothPlayerPanelsExpanded()) {
        boardRef.current.closeBothPlayerPanels();
      } else if (boardRef.current.forceOpenBothPlayerPanels) {
        boardRef.current.forceOpenBothPlayerPanels();
      }
    }
  };

  // Add handler functions for the control panel buttons
  const handleStockfishToggle = () => {
    // If user is not premium, redirect to premium page CHANGED THIS MANUALLY JUNE 5
    // if (!isPremiumUser) {
    //   window.open('/Premium', '_blank');
    //   return;
    // }

    // Only allow premium users to toggle the engine
    const newValue = !showStockfish;
    setShowStockfish(newValue);
    localStorage.setItem('viewGame_showStockfish', JSON.stringify(newValue));

  };

  const handleStockfishEvalToggle = () => {
    const newValue = !showStockfishEval;
    setShowStockfishEval(newValue);
    localStorage.setItem('viewGame_showStockfishEval', JSON.stringify(newValue));
  };

  const handleArrowsToggle = () => {
    const newValue = !showArrows;
    setShowArrows(newValue);
    localStorage.setItem('viewGame_showArrows', JSON.stringify(newValue));

  };

  const handleStockfishIconsToggle = () => {
    const newValue = !showStockfishIcons;
    setShowStockfishIcons(newValue);
    localStorage.setItem('viewGame_showStockfishIcons', JSON.stringify(newValue));
  };

  // State to track the current game mode (for Stockfish auto-response)
  const [gameMode, setGameMode] = useState(() => {
    return localStorage.getItem('gameMode') || 'manual'; // Default to manual mode
  });

  // State to track the current engine difficulty level
  const [engineDifficulty, setEngineDifficulty] = useState(() => {
    return parseInt(localStorage.getItem('engineDifficulty') || '5'); // Default to level 5
  });

  // Ref to track if we're currently processing a Stockfish response
  // This prevents multiple responses from triggering
  const isProcessingStockfishResponse = useRef(false);

  // First, add a state variable for gameResultInfo
  // Place this with the other state declarations at the top of the component
  const [gameResultInfo, setGameResultInfo] = useState({
    result: null, // "draw", "checkmate", "normal", etc.
    winner: null, // "white", "black"
    reason: null  // Specific reason like "stalemate", "insufficient material", etc.
  });

  // Then add a function to detect and set the game result info 
  // Add this function near other game-related functions
  const determineGameResult = useCallback(() => {
    // Default result info
    let result = {
      result: null,
      winner: null,
      reason: null
    };

    // Check if we have moves and game data
    if (!props.data.scream || !moves || moves.length === 0) {
      setGameResultInfo(result);
      return;
    }

    const screamData = props.data.scream;

    // Check for checkmate (last move has a # symbol)
    const lastMove = moves[moves.length - 1];
    if (lastMove && lastMove.notation && lastMove.notation.includes('#')) {
      result.result = 'checkmate';
      // Determine winner based on whose turn it would be after the checkmate
      const lastMoveColor = (moves.length % 2 === 0) ? 'black' : 'white';
      result.winner = lastMoveColor;
      result.reason = 'checkmate';

    }
    // Check for draw (if available in game data)
    else if (screamData.result === 'draw' ||
      (screamData.gameResult && screamData.gameResult.result === 'draw')) {
      result.result = 'draw';
      result.reason = screamData.gameResult?.reason || 'agreement';

    }

    // Store the result
    setGameResultInfo(result);

  }, [props.data.scream, moves]);

  // Call the function to determine result when relevant data changes
  useEffect(() => {
    determineGameResult();
  }, [determineGameResult]);

  // Add listener for sidebar state changes to trigger layout adjustments
  useEffect(() => {
    // This function will force a layout adjustment when sidebar state changes
    const handleSidebarStateChange = () => {
      // Force a re-render to update the layout
      // This is a small hack to ensure containers adjust to the new sidebar width
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);
    };

    // Listen for the custom sidebar state change event
    document.addEventListener('sidebarStateChanged', handleSidebarStateChange);

    // Cleanup
    return () => {
      document.removeEventListener('sidebarStateChanged', handleSidebarStateChange);
    };
  }, []);

  // Function to handle when a user tries to click away from their variation
  const handleVariationNavigation = (targetMoveIdx) => {
    

    // Helper function to check if a move notation is related to a comment
    const isCommentVariation = (moveNotation) => {
      if (!moveNotation) return false;

      // Parse the move notation
      const parts = moveNotation.split('|');
      if (parts.length < 2) return false;

      // Check the move at this index to see if it has a variation with a comment
      const moveIndex = parseInt(parts[0]);
      const variationIndex = parseInt(parts[1].split(':')[0]);

      if (isNaN(moveIndex) || isNaN(variationIndex)) return false;

      const move = moves[moveIndex];
      if (!move || !move.variations || !move.variations[variationIndex]) return false;

      // Check if any move in this variation is a comment
      return move.variations[variationIndex].some(
        varMove => varMove?.creator?.type === 'COMMENT'
      );
    };

    // Check if we're navigating to or from a comment variation
    const isTargetCommentVariation = isCommentVariation(targetMoveIdx);
    const isCurrentCommentVariation = isCommentVariation(currentMoveIdx);

    

    if (isVariationActive) {
      // Check if the target move is within the same variation path
      const { prefix: currentPrefix } = parseMove(currentMoveIdx);
      const { prefix: targetPrefix } = parseMove(targetMoveIdx);

     

      // Allow navigation if prefixes match (clicking within the same temp variation)
      if (currentPrefix === targetPrefix) {
        return true;
      }

      // User has an active, unsaved variation and clicked OUTSIDE it
      setPendingTargetMove(targetMoveIdx);
      setPendingAction('navigate');
      setShowVariationDeleteConfirm(true);
      return false; // Prevent navigation for now
    }
    return true; // Allow navigation if not in an active variation
  };

  // Dialog prompt component for variation delete confirmation
  const VariationDeleteConfirmDialog = () => (
    <div className="modal-background" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }}>
      <div className="modal-content" style={{
        backgroundColor: '#222',
        border: '2px solid #3066be',
        borderRadius: '8px',
        padding: '20px',
        width: '350px',
        maxWidth: '90%',
        color: 'white',
        textAlign: 'center'
      }}>
        <h3 style={{ margin: '0 0 15px', color: '#ff0050' }}>Delete Variation?</h3>
        <p style={{ margin: '0 0 20px', color: '#ccc' }}>
          {pendingAction === 'delete'
            ? 'Are you sure you want to delete this variation?'
            : pendingAction === 'tabSwitch'
            ? 'You have unsaved comment moves. Delete them to switch tabs?'
            : 'You have an unsaved variation. Delete it and continue?'}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={() => {
              setShowVariationDeleteConfirm(false);
              setPendingTargetMove(null);
              setPendingAction(null);
              setPendingTabSwitch(null); // NEW: Clear pending tab switch
            }}
            style={{
              padding: '8px 15px',
              backgroundColor: '#333',
              color: 'white',
              border: '1px solid #555',
              borderRadius: '4px',
              cursor: 'pointer',
              flex: 1,
              marginRight: '10px',
              fontSize: '14px'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (pendingAction === 'delete') {
                handleDeleteCurrentCommentLine();
              } else if (pendingAction === 'navigate' && pendingTargetMove) {
                // First delete the variation
                handleDeleteCurrentCommentLine();
                // Then navigate to the target move
                setCurrentMoveIdx(pendingTargetMove);
              } else if (pendingAction === 'tabSwitch' && pendingTabSwitch) {
                // NEW: Handle tab switch after deleting variation
                handleDeleteCurrentCommentLine();
                // Then switch to the target tab
                setExpandedTab('social');
              }
              setShowVariationDeleteConfirm(false);
              setPendingTargetMove(null);
              setPendingAction(null);
              setPendingTabSwitch(null); // NEW: Clear pending tab switch
            }}
            style={{
              padding: '8px 15px',
              backgroundColor: '#ff0050',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              flex: 1,
              fontSize: '14px'
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );

  // Add tab transition styles
  useEffect(() => {
    // Create styles for tab transitions if they don't exist
    if (!document.getElementById('tab-transition-styles')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'tab-transition-styles';
      styleEl.innerHTML = `
        .game-info-tab, .social-media-tab {
          transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;
          overflow: hidden;
        }
        
        .game-info-tab.expanded {
          height: calc(100% - 150px);
          opacity: 1;
        }
        
        .game-info-tab.collapsed {
          height: 300px;
          opacity: 0.9;
        }
        
        .social-media-tab.expanded {
          height: calc(100% - 150px);
          opacity: 1;
        }
        
        .social-media-tab.collapsed {
          height: 150px;
          opacity: 0.9;
        }
        
        .newly-revealed-move {
          animation: highlightRevealedMove 1.5s ease-out;
        }
        
        @keyframes highlightRevealedMove {
          0% { background-color: gold; color: black; }
          70% { background-color: gold; color: black; }
          100% { background-color: transparent; }
        }
        
        /* Comment hover effects */
        .comment-container {
          transition: background-color 0.2s ease;
        }
        .comment-container:hover {
          background-color: rgba(48, 102, 190, 0.1);
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Cleanup on unmount
    return () => {
      const styleEl = document.getElementById('tab-transition-styles');
      if (styleEl) styleEl.remove();
    };
  }, []);

  // Add a login prompt component for non-authenticated users
  const LoginPrompt = () => (
    <div className="login-prompt" style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.9)',
      color: 'white',
      padding: '20px 25px',
      borderRadius: '5px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '15px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
    }}>
      <button 
        onClick={() => setShowLoginPrompt(false)}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '16px',
          cursor: 'pointer'
        }}
      >
        ✕
      </button>
      <span style={{ fontSize: '16px', marginBottom: '5px', fontWeight: 'bold' }}>Sign in to access this feature</span>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <Link to="/signup" target="_blank" style={{
          background: '#ff0050',
          color: 'black',
        padding: '8px 20px',
        borderRadius: '3px',
        textDecoration: 'none',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100px'
      }}>
        Sign Up
      </Link>
      <Link to="/login" target="_blank" style={{
        background: 'gold',
        color: 'black',
        padding: '8px 20px',
        borderRadius: '3px',
        textDecoration: 'none',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100px'
      }}>
        Login
      </Link>
</div>
    </div>
  );

  // Helper function to check if user is authenticated
  const isUserAuthenticated = () => {
    return !!props.user?.credentials?.userId;
  };

  // Check authentication status on component mount and when user prop changes
  useEffect(() => {
    const authenticated = isUserAuthenticated();
    
    setIsAuthenticatedUser(authenticated);
  }, [props.user?.credentials?.userId]);

  useEffect(() => {
    const populatePosts = async () => {
      // Check if we should skip fetching
      if (fetchingGame === true) {
        
        return;
      }
      
      // More robust check for already loaded game
      if (gameMetadata && gameId) {
        const currentGameId = gameMetadata.id || gameMetadata.gameId;
        if (currentGameId === gameId) {
          
          return;
        }
      }
      
      // Exit if no gameId
      if (!gameId) {
        
        return;
      }
      
      
      setFetchingGame(true);
      
      try {
        
        const gameData = await fetchGame(gameId);
        
        
        if (!gameData) {
          console.error("Failed to load game - API returned empty response");
          return;
        }
        
        if (gameData.error) {
          console.error("Failed to load game:", gameData.error);
          return;
        }
        
        if (gameData) {
          // Create Chess instance first
          const newGame = new Chess(gameData.fen);
          
          // Apply moves to the chess instance if they exist
          if (gameData.moves && Array.isArray(gameData.moves)) {
            gameData.moves.forEach((move) => {
              try {
                if (move.notation) newGame.move(move.notation);
              } catch (e) {
                console.error('Error applying move:', move.notation, e);
              }
            });
          }
          
          // Set the game instance
          setGame(newGame);

          // Consolidated all game state initialization into a single dispatch
          
          
          // Ensure all values are defined and safe
          // Parse starting position with backwards compatibility for encoded variations
          let startPosition = gameData?.startPosition || createStartPosition(gameData?.fen);
          
          // Check for encoded variations in metadata field (new format)
          if (startPosition._variationsData) {
            try {
              const variationsData = JSON.parse(startPosition._variationsData);
              startPosition = {
                ...startPosition,
                variations: variationsData
              };
              // Remove the metadata field to keep startPosition clean
              delete startPosition._variationsData;
              // console.log('✅ Restored starting position variations from metadata field:', variationsData);
            } catch (err) {
              console.error('Error parsing encoded starting position variations from metadata:', err);
            }
          }
          // Legacy support: Check if variations are encoded in the content field (backwards compatibility)
          else if (startPosition.content && startPosition.content.includes('[VARIATIONS_DATA:')) {
            try {
              const match = startPosition.content.match(/\[VARIATIONS_DATA:(.*?)\]/);
              if (match) {
                const variationsData = JSON.parse(match[1]);
                startPosition = {
                  ...startPosition,
                  variations: variationsData,
                  content: startPosition.content.replace(/\[VARIATIONS_DATA:.*?\]/, '').trim()
                };
                // console.log('✅ Restored starting position variations from legacy content format:', variationsData);
              }
            } catch (err) {
              console.error('Error parsing encoded starting position variations from content:', err);
            }
          }

          const safeGameData = {
            fen: gameData?.fen || 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
            orientation: gameData?.pov === undefined || gameData?.pov ? 'white' : 'black',
            moves: Array.isArray(gameData?.moves) ? gameData.moves : [],
            starredMoves: Array.isArray(gameData?.starredMoves) ? gameData.starredMoves : [],
            startPosition: startPosition
          };
          
          dispatch({ 
            type: 'INITIALIZE_GAME', 
            payload: safeGameData
          });

          // Ensure consistent creatorHandle property
          let processedGame = { ...gameData };

          // Always make sure creatorHandle exists
          if (!processedGame.creatorHandle) {
            // If creator exists and is a string (not a userId), use it as handle
            if (processedGame.creator && typeof processedGame.creator === 'string' && !processedGame.creator.includes(' ')) {
              processedGame.creatorHandle = processedGame.creator;
            } else {
              // Default fallback
              processedGame.creatorHandle = 'Anonymous';
            }
          }

          // Set initial like/dislike state based on user ID
          const userId = props?.user?.credentials?.userId;
          if (userId) {
            setIsLiked(processedGame.likes?.includes(userId) || false);
            setIsDisliked(processedGame.dislikes?.includes(userId) || false);
          }

          // Update state with processed game data, ensuring creatorHandle is included
          setGameMetadata((oldMetadata) => ({
            ...oldMetadata,
            ...processedGame,
            creatorHandle: processedGame.creatorHandle // Explicitly set creatorHandle
          }));

          // Check if the game has puzzle or challenge tags
          const hasPuzzleTag = checkForTag(processedGame, 'PUZZLE');
          const hasChallengeTag = checkForTag(processedGame, 'CHALLENGE');

          setGameHasPuzzleTag(hasPuzzleTag);
          setGameHasChallengeTag(hasChallengeTag);

          // Reset revealed moves for puzzles
          if (hasPuzzleTag) {
            setRevealedMoves([]);
            setPuzzleState('incorrect'); // Also reset puzzle state
          }

          // Auto-open settings popup for challenges
          if (hasChallengeTag) {
            setTimeout(() => setShowGameSettings(true), 500); // Slight delay to ensure game is fully loaded
          }
        }
      } catch (error) {
        console.error("Error in populatePosts:", error);
      } finally {
        // Always ensure fetchingGame gets reset to false
        setFetchingGame(false);
      }
    };

    populatePosts();
  }, [gameId, dispatch, fetchingGame, gameMetadata]);

  // Initialize likedComments based on gameMetadata when it loads
  useEffect(() => {
    if (gameMetadata?.comments && props?.user?.credentials?.userId) {
      const userId = props.user.credentials.userId;
      const newLikedComments = new Set();
      
      // Loop through comments and check if current user has liked each one - use comment IDs instead of indices
      gameMetadata.comments.forEach((comment) => {
        if (comment.likes && Array.isArray(comment.likes) && comment.likes.includes(userId)) {
          newLikedComments.add(comment.id);
        }
      });
      
      setLikedComments(newLikedComments);
    }
  }, [gameMetadata?.comments, props?.user?.credentials?.userId]);

  // Helper function to check for tags in different formats
  const checkForTag = (game, tagToCheck) => {
    // Check if tags exist as an array
    if (Array.isArray(game?.tags)) {
      if (game.tags.some(tag => typeof tag === 'string' && tag.toUpperCase() === tagToCheck)) {
        return true;
      }
    }

    // Check if game.tag exists (singular)
    if (typeof game?.tag === 'string' && game.tag.toUpperCase() === tagToCheck) {
      return true;
    }

    // Check gameId for tag identifiers
    if (game?.id && game.id.toUpperCase().includes(tagToCheck)) {
      return true;
    }

    // Check title for tag identifiers
    if (game?.title && game.title.toUpperCase().includes(tagToCheck)) {
      return true;
    }

    // Check URL for query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const urlTag = urlParams.get('tag');
    if (urlTag && urlTag.toUpperCase() === tagToCheck) {
      return true;
    }

    return false;
  };

  // Helper function to calculate puzzle progress (player moves only)
  const calculatePuzzleProgress = (currentMoveIdx, moves) => {
    if (!moves || moves.length === 0) return { current: 0, total: 0 };
    
    // Get current move index
    let currentMoveIndex = -1;
    if (currentMoveIdx !== '-1' && !currentMoveIdx.includes('|')) {
      currentMoveIndex = parseInt(currentMoveIdx);
    }
    
    // Count total puzzle moves (even-indexed moves: 0, 2, 4, 6... - player's moves)
    const totalPuzzleMoves = Math.ceil(moves.length / 2);
    
    // Count current puzzle moves completed
    let currentPuzzleMoves = 0;
    for (let i = 0; i < moves.length; i += 2) { // Only check even indices (player's moves)
      if (i <= currentMoveIndex) {
        currentPuzzleMoves++;
      }
    }
    
    return {
      current: currentPuzzleMoves,
      total: totalPuzzleMoves
    };
  };

  useEffect(() => {
    const fetchFolderGames = async () => {
      

      // Handle navigation from bookmarks page
      if (fromBookmark && folderName && props.user?.credentials?.userId) {
        try {
          const userId = props.user.credentials.userId;

          // Query Firestore for the bookmark folder
          const folderQuery = firestoreQuery(
            collection(firestore, "bookmarkFolders"),
            where("userId", "==", userId),
            where("folderName", "==", folderName)
          );

          const folderSnapshot = await getDocs(folderQuery);

          if (!folderSnapshot.empty) {
            const folderDoc = folderSnapshot.docs[0];
            const folderData = folderDoc.data();


            // Get games array and sort by index
            const games = folderData.games || [];
            games.sort((a, b) => a.index - b.index);


            setFolderGames(games);

            // Find current game index in folder
            const currentGameIndex = games.findIndex(game => game.gameId === gameId);

            if (currentGameIndex !== -1) {
              setCurrentFolderIndex(currentGameIndex);
            }
          }
        } catch (error) {
          console.error("Error fetching folder games:", error);
        }
      }

      // Add new handling for navigation from profile page
      else if (fromProfile && folderName && profileUserId) {
        try {


          // Query Firestore for the public bookmark folder of the profile user
          const folderQuery = firestoreQuery(
            collection(firestore, "bookmarkFolders"),
            where("userId", "==", profileUserId),
            where("folderName", "==", folderName),
            where("isPrivate", "==", false) // Ensure we only get public folders from profiles
          );

          const folderSnapshot = await getDocs(folderQuery);

          if (!folderSnapshot.empty) {
            const folderDoc = folderSnapshot.docs[0];
            const folderData = folderDoc.data();


            // Get games array and sort by index
            const games = folderData.games || [];
            games.sort((a, b) => a.index - b.index);


            setFolderGames(games);

            // Find current game index in folder
            const currentGameIndex = games.findIndex(game => game.gameId === gameId);

            if (currentGameIndex !== -1) {
              setCurrentFolderIndex(currentGameIndex);
            } else if (folderIndex !== null && folderIndex >= 0 && folderIndex < games.length) {
              // If we can't find the game by ID but we have a valid folderIndex, use that
              setCurrentFolderIndex(folderIndex);
            }
          }
        } catch (error) {
          console.error("Error fetching profile folder games:", error);
        }
      }
    };

    fetchFolderGames();
  }, [fromBookmark, fromProfile, folderName, gameId, profileUserId, props.user]);

  // Function to fetch all games by a creator
  useEffect(() => {
    const fetchCreatorGames = async () => {
    

      // Only proceed if we have both fromAllGames=true and a valid creatorId
      if (fromAllGames && creatorId) {
        try {


          // Create a query to get all games ordered by creation date (newest first)
          const gamesQuery = firestoreQuery(
            collection(firestore, "games"),
            where("createdAt", "!=", null),
            orderBy("createdAt", "desc")
          );

          const gamesSnapshot = await getDocs(gamesQuery);
          const allGames = [];

          gamesSnapshot.forEach(doc => {
            allGames.push({
              id: doc.id,
              ...doc.data()
            });
          });



          // Filter games to only include those with matching creatorHandle (case-insensitive)
          const normalizedHandle = creatorId.toLowerCase();
          const filteredGames = allGames.filter(game =>
            game.creatorHandle && game.creatorHandle.toLowerCase() === normalizedHandle
          );



          

          // Check for missing createdAt
          const missingCreatedAt = filteredGames.filter(game => !game.createdAt);
          // if (missingCreatedAt.length > 0) {
          //   console.log("[DEBUG] Warning: Some games are missing createdAt property:",
          //     missingCreatedAt.map(g => g.id));

          //   // Add default createdAt for games missing it
          //   missingCreatedAt.forEach(game => {
          //     game.createdAt = 0; // Default timestamp
          //   });
          // }



          try {
            // Sort the filtered results by createdAt in descending order
            const sortedGames = filteredGames.sort((a, b) => {
              // Safe comparison that handles undefined/null values
              const dateA = a.createdAt || 0;
              const dateB = b.createdAt || 0;
              return dateB - dateA;
            });



            // Log all the game IDs in the sorted array

            // Find current game index in creator's games
            const foundGameIndex = sortedGames.findIndex(game => game.id === gameId);


            // Log information about next and previous games
            if (foundGameIndex > 0) {

            } else {

            }

            if (foundGameIndex < sortedGames.length - 1) {

            } else {

            }

            // Store the sorted games in state
            setCreatorGames(sortedGames);

            // Set the current index in the creator's games collection
            if (foundGameIndex !== -1) {
              setCurrentCreatorGameIndex(foundGameIndex);
            } else if (gameIndex !== null && gameIndex >= 0 && gameIndex < sortedGames.length) {
              // If we can't find the game by ID but we have a valid gameIndex, use that
              setCurrentCreatorGameIndex(gameIndex);
            }
          } catch (sortError) {
            console.error("[DEBUG] Error during sorting or processing:", sortError);
          }
        } catch (error) {
          console.error("Error fetching creator games:", error);
        }
      }
    };

    fetchCreatorGames();
  }, [fromAllGames, creatorId, gameId, gameIndex]);

  useEffect(() => {
    const getNextPostDetails = async () => {
      if (!gameId) {
        return;
      }

      // Directly use location.state for TRENDING context
      const origin = location.state?.origin;
      const gameIds = location.state?.gameIds;





      // Priority 1: TRENDING navigation context
      if (origin === 'TRENDING' && Array.isArray(gameIds) && gameIds.length > 0) {
        const currentIndex = gameIds.indexOf(gameId);
        if (currentIndex !== -1 && currentIndex < gameIds.length - 1) {
          const nextGameId = gameIds[currentIndex + 1];

          setGameMetadata((metadata) => ({
            ...metadata,
            nextGameId: nextGameId,
            // No need to store context in metadata, we read it from location.state
          }));
        } else {
          setGameMetadata((metadata) => ({ ...metadata, nextGameId: null }));
        }
      }
      // Check for FOLLOWING tab origin
      else if (origin === 'FOLLOWING' && Array.isArray(gameIds) && gameIds.length > 0) {
        const currentIndex = gameIds.indexOf(gameId);
        if (currentIndex >= 0 && currentIndex < gameIds.length - 1) {
          const nextGameId = gameIds[currentIndex + 1];

          setGameMetadata((metadata) => ({
            ...metadata,
            nextGameId: nextGameId,
            // No need to store context in metadata
          }));
        } else {
          setGameMetadata((metadata) => ({ ...metadata, nextGameId: null }));
        }
      }
      // If navigating within ALL GAMES of a creator
      else if (fromAllGames && creatorId && creatorGames.length > 0 && currentCreatorGameIndex !== null) {
        // Check if there's a next game in the creator's games
        if (currentCreatorGameIndex < creatorGames.length - 1) {
          const nextGameInCreatorGames = creatorGames[currentCreatorGameIndex + 1];

          setGameMetadata((metadata) => {
            const newState = {
              ...metadata,
              nextGameId: nextGameInCreatorGames.id,
              // Remove nextGameAllGamesInfo again
            };
            return newState;
          });
        } else {
          // No next game in creator's games

          setGameMetadata((metadata) => ({
            ...metadata,
            nextGameId: null
          }));
        }
      }
      // If navigating within a bookmark folder or profile folder
      else if ((fromBookmark || fromProfile) && folderName && folderGames.length > 0 && currentFolderIndex !== null) {
        // Check if there's a next game in the folder
        if (currentFolderIndex < folderGames.length - 1) {
          const nextGameInFolder = folderGames[currentFolderIndex + 1];

          setGameMetadata((metadata) => ({
            ...metadata,
            nextGameId: nextGameInFolder.gameId,
            nextGameBookmarkInfo: {
              fromBookmark: fromBookmark,
              fromProfile: fromProfile,
              folderName: folderName,
              profileUserId: profileUserId,
              folderIndex: currentFolderIndex + 1
            }
          }));
        } else {
          // No next game in folder

          setGameMetadata((metadata) => ({
            ...metadata,
            nextGameId: null
          }));
        }
      } else {
        // Default behavior - fetch next game chronologically
        const nextGame = await fetchNextGame(gameId, orderByParam, userId, tag);
        setGameMetadata((metadata) => ({
          ...metadata,
          nextGameId: nextGame?.id,
          // nextGameTrendingInfo: null // REMOVED - No longer storing in metadata
        }));
      }
    };

    getNextPostDetails();
  }, [gameId, location.state, orderByParam, userId, tag, fromBookmark, fromProfile, folderName, profileUserId, folderGames, currentFolderIndex, fromAllGames, creatorId, creatorGames, currentCreatorGameIndex]); // Depend on location.state directly

  useEffect(() => {
    const getPrevPostDetails = async () => {
      if (!gameId) {
        return;
      }

      // Directly use location.state for TRENDING context
      const origin = location.state?.origin;
      const gameIds = location.state?.gameIds;





      // Priority 1: TRENDING navigation context
      if (origin === 'TRENDING' && Array.isArray(gameIds) && gameIds.length > 0) {
        const currentIndex = gameIds.indexOf(gameId);
        if (currentIndex > 0) {
          const prevGameId = gameIds[currentIndex - 1];

          setGameMetadata((metadata) => ({
            ...metadata,
            prevGameId: prevGameId,
            // No need to store context in metadata
          }));
        } else {
          setGameMetadata((metadata) => ({ ...metadata, prevGameId: null }));
        }
      }
      // Check for FOLLOWING tab origin
      else if (origin === 'FOLLOWING' && Array.isArray(gameIds) && gameIds.length > 0) {
        const currentIndex = gameIds.indexOf(gameId);
        if (currentIndex > 0) {
          const prevGameId = gameIds[currentIndex - 1];

          setGameMetadata((metadata) => ({
            ...metadata,
            prevGameId: prevGameId,
            // No need to store context in metadata
          }));
        } else {
          setGameMetadata((metadata) => ({ ...metadata, prevGameId: null }));
        }
      }
      // If navigating within ALL GAMES of a creator
      else if (fromAllGames && creatorId && creatorGames.length > 0 && currentCreatorGameIndex !== null) {
        // Check if there's a previous game in the creator's games
        if (currentCreatorGameIndex > 0) {
          const prevGameInCreatorGames = creatorGames[currentCreatorGameIndex - 1];

          setGameMetadata((metadata) => {
            const newState = {
              ...metadata,
              prevGameId: prevGameInCreatorGames.id,
              // Remove prevGameAllGamesInfo again
            };
            return newState;
          });
        } else {
          // No previous game in creator's games

          setGameMetadata((metadata) => ({
            ...metadata,
            prevGameId: null
          }));
        }
      }
      // If navigating within a bookmark folder or profile folder
      else if ((fromBookmark || fromProfile) && folderName && folderGames.length > 0 && currentFolderIndex !== null) {
        // Check if there's a previous game in the folder
        if (currentFolderIndex > 0) {
          const prevGameInFolder = folderGames[currentFolderIndex - 1];
          setGameMetadata((metadata) => ({
            ...metadata,
            prevGameId: prevGameInFolder.gameId,
            prevGameBookmarkInfo: {
              fromBookmark: fromBookmark,
              fromProfile: fromProfile,
              folderName: folderName,
              profileUserId: profileUserId,
              folderIndex: currentFolderIndex - 1
            }
          }));
        } else {
          // No previous game in folder
          setGameMetadata((metadata) => ({
            ...metadata,
            prevGameId: null
          }));
        }
      } else {
        // Default behavior - fetch previous game chronologically
        const prevGame = await fetchPrevGame(gameId, orderByParam, userId, tag);
        setGameMetadata((metadata) => ({
          ...metadata,
          prevGameId: prevGame?.id,
          // prevGameTrendingInfo: null // REMOVED - No longer storing in metadata
        }));
      }
    };

    getPrevPostDetails();
  }, [gameId, location.state, orderByParam, userId, tag, fromBookmark, fromProfile, folderName, profileUserId, folderGames, currentFolderIndex, fromAllGames, creatorId, creatorGames, currentCreatorGameIndex]); // Depend on location.state directly

  useEffect(() => {
    if (!gameMetadata) {
      return;
    }

    const newGame = new Chess(gameMetadata.fen);
    moves && moves.forEach((move) => newGame.move(move.notation));
    dispatch({ type: 'SET_MOVES', payload: moves });
  }, [gameMetadata]);

  // Use the GameStateContext's currentMove instead of useMoveIndex hook to avoid conflicts
  const currentMoveIdx = currentMove;
  const setCurrentMoveIdx = goToContextMove;

  // FEN TRACKING - Connect currentFen to existing game state (placed after currentMoveIdx declaration)
  useEffect(() => {
    // Calculate FEN using the same method as 2AddGame.js
    // Pass the game state context for starting position variation support
    const newFen = getCurrentBoardPosition(moves, currentMove, rootFEN, state);
    
    if (newFen && newFen !== lastFenRef.current) {
      // console.log(`🎯 2ViewGame: FEN updated for move ${currentMove}: ${newFen}`);
      
      // Special logging for starting position variations
      if (currentMove && currentMove.startsWith('-1|')) {
        // console.log(`🔍 2ViewGame: Starting position variation detected - ${currentMove}`);
      }
      
      lastFenRef.current = newFen; // Update the ref
      setCurrentFen(newFen);
      // Update global window.currentFEN for compatibility
      window.currentFEN = newFen;
      
      // CRITICAL FIX: Update Redux state to keep state.currentFEN synchronized
      setContextFEN(newFen);
      
      // Debug verification: ensure synchronization is working
      // console.log(`✅ 2ViewGame: State synchronized - currentFEN: ${state.currentFEN}, newFen: ${newFen}`);
      
      // Check for cached analysis first
      const cachedAnalysis = checkForCachedAnalysis(currentMove, newFen);
      if (cachedAnalysis) {
        // console.log(`📋 2ViewGame: Using cached analysis for move ${currentMove}`);
        // Analysis is already set in window.currentAnalysisCache by checkForCachedAnalysis
        // Dispatch event to notify StockfishAnalysisPanel that analysis is ready
        window.dispatchEvent(new CustomEvent('stockfish-analysis-ready', {
          detail: {
            analysis: cachedAnalysis,
            position: 'move',
            moveId: currentMove,
            fen: newFen
          }
        }));
      } else {
        // console.log(`🔄 2ViewGame: No cached analysis for move ${currentMove}, will trigger fresh analysis`);
        // Clear any existing analysis cache for the previous position
        window.currentAnalysisCache = null;
        // Fresh analysis will be triggered by StockfishAnalysisPanel when it receives the new FEN
      }
    } else if (newFen === lastFenRef.current) {
      // console.log(`⚡ 2ViewGame: FEN unchanged for move ${currentMove}: ${newFen}`);
    }
  }, [moves, currentMove, rootFEN, setContextFEN]); // Add setContextFEN to dependencies

  // Analyze position when game state changes
  useEffect(() => {
    if (game && stockfishInitialized) {
      const currentFen = game.fen();
      setCurrentPosition(currentFen);

      // Stop any ongoing analysis first
      if (stockfishEngine.isAnalysisInProgress()) {
        stockfishEngine.stopAnalysis();
      }

      // Start analyzing position at a lower depth for the evaluation bar
      // This runs for all users, regardless of premium status
      // const analyzeCurrentPosition = async () => {
      //   try {
      //     // Use a lower depth for performance (premium users can get deeper analysis in Stockfish component)
      //     await stockfishEngine.analyzePosition(currentFen, { depth: 10 });
      //   } catch (error) {
      //     console.error('Error analyzing position:', error);
      //   }
      // };

      // analyzeCurrentPosition();
    }
  }, [game, currentMoveIdx, stockfishInitialized, setCurrentPosition]);

   // Add the new Stockfish analysis hook
   const {
    analysis: stockfishAnalysis,
    isAnalyzing: stockfishIsAnalyzing,
    analysisError: stockfishAnalysisError,
    forceAnalysisRefresh,
    cancelAnalysis: cancelStockfishAnalysis,
    manager: stockfishManager
  } = useStockfishAnalysisManager({
    currentMoveIdx: state.currentMove,
    moves: state.moves,
    currentFEN: state.currentFEN,
    gameState: state,
    dispatch,
    enabled: true // Always enable for background calculation
  });

  // Extract evaluation from stockfish analysis for the evaluation bar
  const currentEvaluation = React.useMemo(() => {
    // Debug logging for starting position variations
    if (currentMove && currentMove.startsWith('-1|')) {
      // console.log(`🔍 2ViewGame: Extracting evaluation for starting position variation ${currentMove}:`, {
      //   hasStockfishAnalysis: !!stockfishAnalysis,
      //   stockfishAnalysisKeys: stockfishAnalysis ? Object.keys(stockfishAnalysis) : null,
      //   hasPvs: stockfishAnalysis?.pvs?.length > 0,
      //   firstPvNormalizedCP: stockfishAnalysis?.pvs?.[0]?.normalizedCP,
      //   firstPvEvaluation: stockfishAnalysis?.pvs?.[0]?.evaluation
      // });
    }
    
    if (!stockfishAnalysis) {
      return 0; // Default to 0 when no analysis
    }
    
    // Try to get the best evaluation from the first PV line
    if (stockfishAnalysis.pvs && stockfishAnalysis.pvs.length > 0) {
      const firstPV = stockfishAnalysis.pvs[0];
      
      // Check for normalizedCP first (most reliable)
      if (firstPV.normalizedCP !== undefined && firstPV.normalizedCP !== null) {
        return firstPV.normalizedCP;
      }
      
      // Fall back to evaluation string
      if (firstPV.evaluation) {
        // Handle mate scores
        if (typeof firstPV.evaluation === 'string' && firstPV.evaluation.includes('M')) {
          return firstPV.evaluation;
        }
        
        // Parse numeric evaluations
        const numericEval = parseFloat(firstPV.evaluation.replace('+', ''));
        if (!isNaN(numericEval)) {
          return numericEval;
        }
      }
    }
    
    // Try scores array as fallback
    if (stockfishAnalysis.scores && stockfishAnalysis.scores.length > 0) {
      const firstScore = stockfishAnalysis.scores[0];
      
      // Handle mate scores
      if (typeof firstScore === 'string' && firstScore.includes('M')) {
        return firstScore;
      }
      
      // Parse numeric scores
      const numericScore = parseFloat(firstScore.replace('+', ''));
      if (!isNaN(numericScore)) {
        return numericScore;
      }
    }
    
    return 0; // Default fallback
  }, [stockfishAnalysis]);

  // Replace the old analysis effect with this simplified version
  useEffect(() => {
    // The new analysis system handles everything automatically
    // We just need to expose some functions globally for backward compatibility
    
    // Expose global functions for components that still use the old API
    window.getCurrentMoveIndex = () => state.currentMove;
    window.checkForCachedAnalysis = (moveIndex, targetFEN = null) => {
      // Check if move has analysis
      if (moveIndex === '-1') return false;
      
      const moveObj = getMoveObject(moveIndex);
      return moveObj ? !!moveObj.analysis : false;
    };
    window.getCachedAnalysisForFEN = (fen) => {
      // For backward compatibility - check current analysis
      if (stockfishAnalysis && stockfishAnalysis.positionFEN) {
        const currentKey = stockfishAnalysis.positionFEN.split(' ').slice(0, 4).join(' ');
        const searchKey = fen.split(' ').slice(0, 4).join(' ');
        return currentKey === searchKey ? stockfishAnalysis : null;
      }
      return null;
    };
    window.updatePositionForAnalysis = (fen) => {
      // Force analysis refresh for the current position
      forceAnalysisRefresh();
    };
    
    // Update global analysis cache for UI components
    window.currentAnalysisCache = stockfishAnalysis;
    
    // Expose the analysis manager for cache management
    window.stockfishAnalysisManager = stockfishManager;
    
    // Ensure window.getCurrentMoveIndex is available for StockfishAnalysisPanel
    window.getCurrentMoveIndex = () => state.currentMove;
    
    // Add event listener for forced stockfish analysis
    const handleStockfishAnalyze = (event) => {
      
      
      if (event.detail && event.detail.forceCalculation) {
        const { fen, reason } = event.detail;
        
        
        
        // If we have a specific FEN and we're at the starting position (-1), 
        // we need to handle this specially since forceAnalysisRefresh only works for moves
        if (fen && state.currentMove === '-1' && reason === 'root-fen-changed') {
          
          
          // Clear cache first
          if (stockfishManager) {
            stockfishManager.clearCache();
            
            // Request analysis directly for the starting position
            stockfishManager.requestAnalysis(fen, '-1', null, null)
              .then(analysis => {
                
                // Update the global cache so UI components can access it
                window.currentAnalysisCache = analysis;
              })
              .catch(error => {
                console.error('[2ViewGame] Starting position analysis failed:', error);
              });
          }
        } else {
          // Use the normal force refresh for other cases
          forceAnalysisRefresh();
        }
      }
    };
    
    window.addEventListener('stockfish-analyze', handleStockfishAnalyze);
    
    return () => {
      window.removeEventListener('stockfish-analyze', handleStockfishAnalyze);
      delete window.stockfishAnalysisManager;
    };
  }, [state.currentMove, stockfishAnalysis, forceAnalysisRefresh, stockfishManager]);

  // NEW: Listen for move-focused comment sorting events
  useEffect(() => {
    const handleMoveFocusedComments = (event) => {
      const { moveIndex } = event.detail;
      // console.log('[ViewGame] Move-focused sorting for move:', moveIndex);
      
      // Set the move-focused sorting state
      setMoveFocusedSorting(moveIndex);
      
      // Open social tab if not already open
      if (expandedTab !== 'social') {
        setExpandedTab('social');
      }
      
      // Scroll to top of social tab content
      const scrollToTop = () => {
        // Try multiple selectors to find the scrollable container
        const selectors = [
          '.social-tab-content',
          '.comments-container', 
          '[data-tab="social"]',
          '.tab-content',
          '.expanded-content',
          '.sidebar-content',
          '.comments-section',
          '.social-content'
        ];
        
        let scrolled = false;
        for (const selector of selectors) {
          const container = document.querySelector(selector);
          if (container && container.scrollHeight > container.clientHeight) {
            container.scrollTop = 0;
            scrolled = true;
            // console.log(`[ViewGame] Scrolled to top using selector: ${selector}`);
            break;
          }
        }
        
        if (!scrolled) {
          // Final fallback: find any scrollable element and scroll it
          const allScrollable = document.querySelectorAll('*');
          for (const element of allScrollable) {
            if (element.scrollHeight > element.clientHeight && element.scrollTop > 0) {
              element.scrollTop = 0;
              // console.log('[ViewGame] Scrolled to top using fallback element');
              break;
            }
          }
        }
      };
      
      // If tab is already open, scroll immediately and also after a delay
      if (expandedTab === 'social') {
        scrollToTop();
        setTimeout(scrollToTop, 50);
        setTimeout(scrollToTop, 150);
      } else {
        // If tab is opening, wait for it to open then scroll
        setTimeout(scrollToTop, 100);
        setTimeout(scrollToTop, 200);
      }
    };

    window.addEventListener('focus-move-comments', handleMoveFocusedComments);
    
    return () => {
      window.removeEventListener('focus-move-comments', handleMoveFocusedComments);
    };
  }, [expandedTab]);

  // Helper function to get move object by ID
  const getMoveObject = (moveId) => {
    if (!moveId || moveId === '-1') return null;
    
    // Handle starting position variations (e.g., "-1|0:0")
    if (moveId.startsWith('-1|')) {
      try {
        const parts = moveId.split('|');
        if (parts.length >= 2) {
          const variationPart = parts[1];
          const [varIdx, moveIdx] = variationPart.split(':').map(Number);
          
          if (state?.startPosition?.variations && varIdx < state.startPosition.variations.length) {
            const variation = state.startPosition.variations[varIdx];
            return variation?.[moveIdx] || null;
          }
        }
      } catch (err) {
        console.error('Error getting starting position variation move:', err);
      }
      return null;
    }
    
    if (!moveId.includes('|')) {
      const idx = parseInt(moveId, 10);
      return (idx >= 0 && idx < state.moves.length) ? state.moves[idx] : null;
    }
    
    // Handle variations - simplified version
    const parts = moveId.split('|');
    let currentNode = null;
    const mainIdx = parseInt(parts[0], 10);
    
    if (mainIdx >= 0 && mainIdx < state.moves.length) {
      currentNode = state.moves[mainIdx];
      
      for (let i = 1; i < parts.length; i++) {
        if (!parts[i].includes(':')) continue;
        const [varIdx, moveIdx] = parts[i].split(':').map(Number);
        
        if (i < parts.length - 1) {
          if (currentNode.variations && 
              varIdx < currentNode.variations.length &&
              moveIdx < currentNode.variations[varIdx].length) {
            currentNode = currentNode.variations[varIdx][moveIdx];
          } else {
            return null;
          }
        } else {
          if (currentNode.variations && 
              varIdx < currentNode.variations.length &&
              moveIdx < currentNode.variations[varIdx].length) {
            return currentNode.variations[varIdx][moveIdx];
          }
        }
      }
    }
    
    return null;
  };

  // Configuration for Stockfish difficulty levels
  const difficultySettings = {
    1: { depth: 5, moveSelection: { randomLegal: 1.0, best: 0.0, secondBest: 0.0, thirdBest: 0.0 } },
    2: { depth: 5, moveSelection: { randomLegal: 0.75, best: 0.0, secondBest: 0.0, thirdBest: 0.25 } },
    3: { depth: 10, moveSelection: { randomLegal: 0.5, best: 0.0, secondBest: 0.0, thirdBest: 0.5 } },
    4: { depth: 10, moveSelection: { randomLegal: 0.25, best: 0.0, secondBest: 0.25, thirdBest: 0.5 } },
    5: { depth: 10, moveSelection: { randomLegal: 0.25, best: 0.25, secondBest: 0.25, thirdBest: 0.25 } },
    6: { depth: 15, moveSelection: { randomLegal: 0.1, best: 0.25, secondBest: 0.25, thirdBest: 0.4 } },
    7: { depth: 15, moveSelection: { randomLegal: 0.1, best: 0.25, secondBest: 0.4, thirdBest: 0.25 } },
    8: { depth: 15, moveSelection: { randomLegal: 0.1, best: 0.4, secondBest: 0.5, thirdBest: 0.0 } },
    9: { depth: 20, moveSelection: { randomLegal: 0.0, best: 0.8, secondBest: 0.2, thirdBest: 0.0 } },
    10: { depth: 20, moveSelection: { randomLegal: 0.0, best: 1.0, secondBest: 0.0, thirdBest: 0.0 } },
  };

  // Function to select a move based on the current difficulty level
  const selectMoveByDifficulty = async (fen, currentDifficulty) => {
    try {


      // Get settings for the current difficulty level (default to level 5 if not found)
      const settings = difficultySettings[currentDifficulty] || difficultySettings[5];


      // For levels that include random legal moves, we need to get all legal moves
      let allLegalMoves = [];
      if (settings.moveSelection.randomLegal > 0) {
        try {
          // Create a temporary chess.js instance to get legal moves
          const tempChess = new Chess(fen);
          allLegalMoves = tempChess.moves({ verbose: true });

        } catch (error) {
          console.error('[DEBUG] Error getting legal moves:', error);
          // If this fails, we'll fall back to engine moves only
        }
      }

      // For all levels, we need the top candidate moves from the engine


      // Analyze position with configured depth and multipv=3 to get top 3 moves
      await stockfishEngine.analyzePosition(fen, {
        depth: settings.depth,
        multipv: 3 // We need up to 3 best moves for our difficulty levels
      });

      // Wait briefly for analysis to complete

      await new Promise(resolve => setTimeout(resolve, Math.max(500, settings.depth * 50))); // Scale wait time with depth

      // Get the evaluation data with multiple PVs
      const pvData = window.latestEvaluation?.pvs || [];
      if (!pvData || pvData.length === 0) {
        console.error('[DEBUG] No PV data available after analysis');
        // If we have no PV data, use random legal move as fallback (if available)
        if (allLegalMoves.length > 0) {
          const randomMove = allLegalMoves[Math.floor(Math.random() * allLegalMoves.length)];

          return randomMove.san;
        }
        return null;
      }



      // Extract the moves from PV data
      const candidateMoves = pvData.map(pv => {
        // Each PV should have a first move we can use
        if (pv.moves && pv.moves.length > 0) {
          return { san: pv.moves[0], score: pv.score };
        }
        return null;
      }).filter(Boolean);

      if (candidateMoves.length === 0) {
        console.error('[DEBUG] No valid candidate moves found');
        return null;
      }


      // Now select a move based on the difficulty settings
      const { randomLegal, best, secondBest, thirdBest } = settings.moveSelection;

      // Generate a random number between 0 and 1
      const rand = Math.random();
      let selectedMove = null;

      // Use cumulative probabilities to select move
      if (rand < randomLegal && allLegalMoves.length > 0) {
        // Select a random legal move
        const randomMove = allLegalMoves[Math.floor(Math.random() * allLegalMoves.length)];
        selectedMove = randomMove.san;

      } else if (rand < randomLegal + best && candidateMoves.length >= 1) {
        // Select best move
        selectedMove = candidateMoves[0].san;

      } else if (rand < randomLegal + best + secondBest && candidateMoves.length >= 2) {
        // Select second best move
        selectedMove = candidateMoves[1].san;

      } else if (candidateMoves.length >= 3) {
        // Select third best move
        selectedMove = candidateMoves[2].san;

      } else {
        // Fallback: use the best available move
        selectedMove = candidateMoves[0].san;

      }


      return selectedMove;

    } catch (error) {
      console.error('[DEBUG] Error in selectMoveByDifficulty:', error);
      return null;
    }
  };

  // Function to handle automatic Stockfish response in exploration mode
  const handleStockfishResponse = useCallback(async () => {
    // Only respond if all conditions are met:
    // 1. Game mode is set to exploration
    // 2. We're in a variation (not in the original game moves)
    // 3. Stockfish is initialized
    

    if (
      gameMode === 'exploration' && // Only exploration mode triggers auto-response, not manual
      isVariationActive &&
      game &&
      stockfishInitialized
    ) {


      // Get the current FEN position
      const currentFen = game.fen();

      // Check whose turn it is
      const isWhiteTurn = currentFen.split(' ')[1] === 'w';




      // IMPORTANT: Only respond if it's the opponent's turn (opposite of the board orientation)
      // For white orientation, only respond if it's black's turn (isWhiteTurn = false)
      // For black orientation, only respond if it's white's turn (isWhiteTurn = true)
      if ((orientation === 'white' && isWhiteTurn) || (orientation === 'black' && !isWhiteTurn)) {

        return;
      }



      // Use the current difficulty level from state


      // Use our new difficulty-based move selection
      const bestMove = await selectMoveByDifficulty(currentFen, engineDifficulty);

      if (bestMove) {


        // Check if makeChessMove function is available on window


        // Use the makeChessMove function from the board component
        if (window.makeChessMove) {
          try {
            const moveResult = window.makeChessMove(bestMove);
          } catch (error) {
          }
        } else {
          console.warn('[DEBUG] makeChessMove function not available on window object');

          // Fallback method: try to execute the move directly through the Chess.js object
          try {

            // Get the current position and make the move on the game object
            const result = game.move(bestMove);
            if (result) {


              // Update the UI to reflect the move
              // First update the moves array with the new move
              const updatedMoves = [...moves];
              const { prefix, currMoveNum } = parseMove(currentMoveIdx);
              const nextMoveIdx = `${prefix}${currMoveNum + 1}`;

              // Import the needed function from Chess utility
              const newMove = {
                notation: bestMove,
                creator: {
                  id: -1,
                  type: constants.CHESSBOARD.MOVE_TYPES.COMMENT,
                  automated: true  // Mark this move as created by Stockfish automation
                }
              };

              // Add the move to the array
              updatedMoves.push(newMove);

              // Update state
              dispatch({ type: 'SET_MOVES', payload: updatedMoves });
              dispatch({ type: 'GOTO_MOVE', payload: nextMoveIdx });


            } else {
              console.error('[DEBUG] Fallback move failed - invalid move');
            }
          } catch (error) {
            console.error('[DEBUG] Error in fallback move execution:', error);
          }
        }
      } else {
        console.warn('[DEBUG] No move available from Stockfish after all attempts');

        // Try alternative approaches if the difficulty-based selection failed
        // 1. First try the context evaluation data

        if (evaluation && evaluation.bestMove && evaluation.bestMove.san) {
          const fallbackMove = evaluation.bestMove.san;


          // Execute the fallback move
          try {
            if (window.makeChessMove) {
              window.makeChessMove(fallbackMove);
            }
          } catch (error) {
            console.error('[DEBUG] Error executing fallback move:', error);
          }
          return;
        }

        // 2. Try direct analysis as a last resort
        try {

          const engineResult = await stockfishEngine.getBestMove(currentFen, { depth: 10 });
          if (engineResult && engineResult.bestMove) {
            const lastResortMove = engineResult.bestMove.san || engineResult.bestMove;


            // Execute the last resort move
            if (window.makeChessMove && lastResortMove) {
              window.makeChessMove(lastResortMove);
            }
          }
        } catch (error) {
          console.error('[DEBUG] Error in last resort move calculation:', error);
        }
      }
    } else {
      if (gameMode === 'manual') {
      }
    }
  }, [gameMode, isVariationActive, game, stockfishInitialized, orientation, evaluation, moves, currentMoveIdx, engineDifficulty]);

  // Add a function to check if the current move has variations
  const checkForVisibleVariations = useCallback(() => {
    // Check if current move has variations
    if (moves && currentMoveIdx !== '-1') {
      const currentMove = getMove(moves, currentMoveIdx);
      const hasVariations = currentMove &&
        currentMove.variations &&
        currentMove.variations.length > 0 &&
        currentMove.variations.some(v => v && v.length > 0);

      setHasVisibleVariations(hasVariations);
      return hasVariations;
    }
    setHasVisibleVariations(false);
    return false;
  }, [moves, currentMoveIdx]);

  // Call the check function whenever moves or currentMoveIdx changes
  useEffect(() => {
    checkForVisibleVariations();
  }, [moves, currentMoveIdx, checkForVisibleVariations]);

  // Effect to update game mode when localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const newGameMode = localStorage.getItem('gameMode') || 'manual'; // Default to manual mode
      setGameMode(newGameMode);


      const newDifficulty = parseInt(localStorage.getItem('engineDifficulty') || '5');
      setEngineDifficulty(newDifficulty);

    };

    // Direct event handler for changes from GameSettingsPopup
    const handleGameModeChanged = (event) => {
      const newGameMode = event.detail.gameMode;

      setGameMode(newGameMode);
    };

    // Direct event handler for difficulty changes from GameSettingsPopup
    const handleDifficultyChanged = (event) => {
      const newDifficulty = event.detail.engineDifficulty;

      setEngineDifficulty(newDifficulty);
    };

    // Listen for storage changes (this will catch changes made in GameSettingsPopup)
    window.addEventListener('storage', handleStorageChange);

    // Listen for direct custom events (more reliable within the same window)
    document.addEventListener('gameModeChanged', handleGameModeChanged);
    document.addEventListener('engineDifficultyChanged', handleDifficultyChanged);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      document.removeEventListener('gameModeChanged', handleGameModeChanged);
      document.removeEventListener('engineDifficultyChanged', handleDifficultyChanged);
    };
  }, []);

  // Additional effect to ensure gameMode is properly synchronized with localStorage on component mount
  useEffect(() => {
    // Get the gameMode directly from localStorage when component mounts
    const savedGameMode = localStorage.getItem('gameMode') || 'manual';

    setGameMode(savedGameMode);
  }, []);

  // Function to detect if current position represents a variation from the original game
  const detectVariationState = (originalMoves, currentMoves, currentIdx) => {
    if (!originalMoves || !currentMoves || currentIdx === '-1') {
      return false;
    }

    // Parse the current move index to get the actual numerical index
    let moveIndex;
    try {
      const { currMoveNum } = parseMove(currentIdx);
      moveIndex = currMoveNum;
    } catch (error) {
      return false;
    }

    // Check if we're on a user-created variation or comment
    const currentMove = getMove(currentMoves, currentIdx);

    // Only return true if this is explicitly a user-created comment move
    if (currentMove && currentMove.creator &&
      currentMove.creator.type === constants.CHESSBOARD.MOVE_TYPES.COMMENT &&
      currentMove.creator.id === -1) { // -1 indicates unsaved user comment
      return true;
    }

    // If we're beyond the original moves length, it's a variation
    if (moveIndex >= originalMoves.length) {
      // Check if this move was created by the user (-1 id)
      return currentMove && currentMove.creator && currentMove.creator.id === -1;
    }

    // Check if current move's notation matches the original at the same position
    // AND if it was created by the current user
    if (currentMove && originalMoves[moveIndex] &&
      currentMove.notation !== originalMoves[moveIndex].notation &&
      currentMove.creator && currentMove.creator.id === -1) {
      return true;
    }

    // Check for variations that were created by the current user
    if (currentMoves.some(move =>
      move.variations &&
      move.variations.length > 0 &&
      move.variations.some(variation =>
        variation.some(varMove =>
          varMove.creator && varMove.creator.id === -1
        )
      ))) {
      // Only return true if we're currently on one of those user-created variations
      const lines = getLines(currentIdx);
      if (lines.length > 1) { // We're in a variation
        // Check if this specific variation was created by the user
        let movesToCheck = currentMoves;
        let inUserVariation = false;

        for (let i = 0; i < lines.length; i++) {
          const [variationNum, moveInThisLine] = destructureLine(lines[i]);
          if (variationNum) {
            const parentMove = movesToCheck?.[moveInThisLine];
            if (!parentMove || !parentMove.variations || !parentMove.variations[variationNum]) {
              // Parent move or variation doesn't exist, break the loop
              break;
            }
            
            movesToCheck = parentMove.variations[variationNum];

            // Check if any move in this variation was created by the user
            if (movesToCheck && movesToCheck.some(move => move.creator && move.creator.id === -1)) {
              inUserVariation = true;
              break;
            }
          }
        }

        return inUserVariation;
      }
    }

    return false;
  };

  // Add centering effect for moves
  useEffect(() => {
    if (!moves?.length) return; // Don't run if no moves

    const centerCurrentMove = () => {
      const currentMoveElement = document.querySelector('.current-move');
      const container = document.querySelector('.moves-container');

      if (!currentMoveElement || !container) {
        // If elements not found, retry after a short delay
        setTimeout(centerCurrentMove, 100);
        return;
      }

      // Get all necessary measurements
      const containerWidth = container.offsetWidth;
      const currentMoveWidth = currentMoveElement.offsetWidth;
      const currentMoveLeft = currentMoveElement.offsetLeft;
      const totalContentWidth = container.scrollWidth;

      // Calculate the target scroll position to center the current move
      const targetScrollPosition = Math.max(
        0, // Don't scroll past the start
        Math.min(
          currentMoveLeft - (containerWidth - currentMoveWidth) / 2,
          totalContentWidth - containerWidth // Don't scroll past the end
        )
      );

      // Apply the scroll with smooth animation
      container.scrollTo({
        left: targetScrollPosition,
        behavior: 'smooth'
      });
    };

    // Try to center immediately and set up a few retries
    centerCurrentMove();
    const retryTimes = [100, 300, 500]; // Retry after 100ms, 300ms, and 500ms
    const timeoutIds = retryTimes.map(time => setTimeout(centerCurrentMove, time));

    // Add resize listener to handle window/container size changes
    const resizeObserver = new ResizeObserver(() => {
      centerCurrentMove();
    });

    const container = document.querySelector('.moves-container');
    if (container) {
      resizeObserver.observe(container);
    }

    // Check for variation state
    if (!gameHasPuzzleTag && gameMetadata?.moves && moves && currentMoveIdx !== '-1') {
      // This detects if the current position represents a variation from the original game
      const isInVariation = detectVariationState(gameMetadata.moves, moves, currentMoveIdx);
      setIsVariationActive(isInVariation);

      // NEW: Auto-switch to Game Tab when comment moves are created
      if (isInVariation && expandedTab === 'social') {
        
        setExpandedTab('gameInfo');
        setVariationToComment(moves);
      }
      
      // Set variationToComment when in Game Tab and variation is active
      if (isInVariation && expandedTab === 'gameInfo') {
        setVariationToComment(moves);
      }
    }

    return () => {
      timeoutIds.forEach(id => clearTimeout(id));
      if (container) {
        resizeObserver.disconnect();
      }
    };
  }, [currentMoveIdx, moves, gameHasPuzzleTag, gameMetadata?.moves, expandedTab]); // Re-run when tab changes or moves change

  // Effect to trigger Stockfish response when a move is made in a variation
  useEffect(() => {
   // When in a variation and in exploration mode, trigger Stockfish response
    if (isVariationActive && gameMode === 'exploration' && game && stockfishInitialized) {


      // Check if game and stockfish are ready
      if (!game) {
        console.warn('[DEBUG] Game object not available for Stockfish response');
        return;
      }

      if (!stockfishInitialized) {
        console.warn('[DEBUG] Stockfish not initialized for auto-response');
        return;
      }

      // Log the current FEN for debugging
      const currentFen = game.fen();


      // Check if it's the opponent's turn (opposite of board orientation)
      const isWhiteTurn = currentFen.split(' ')[1] === 'w';
      const isOpponentTurn = (orientation === 'white' && !isWhiteTurn) ||
        (orientation === 'black' && isWhiteTurn);

      if (!isOpponentTurn) {
        return;
      }

      // Check if the last move was made by a human (not by Stockfish)
      // We can determine this by checking the move history and creator
      let lastMoveByHuman = true;

      if (moves.length > 0 && currentMoveIdx !== '-1') {
        const currentMove = getMove(moves, currentMoveIdx);
        // If there's a creator field with id = -1 and automated = true, it was made by Stockfish
        if (currentMove && currentMove.creator &&
          currentMove.creator.id === -1 &&
          currentMove.creator.automated === true) {
          lastMoveByHuman = false;

          return;
        }
      }

      if (lastMoveByHuman) {
        // Ensure we don't trigger multiple responses
        if (!isProcessingStockfishResponse.current) {
          isProcessingStockfishResponse.current = true;

          // Small delay to ensure UI is updated before response
          setTimeout(() => {
            handleStockfishResponse().finally(() => {
              isProcessingStockfishResponse.current = false;
            });
          }, 100);
        }
      }
    } else {
      if (gameMode === 'manual') {
      }
    }
  }, [isVariationActive, gameMode, contextCurrentMove, handleStockfishResponse, game, stockfishInitialized, contextOrientation, contextMoves]);

  const keyDownHandler = useCallback(
    (e) => {
      // Skip arrow key navigation only for active puzzles, allow after completion
      if (gameHasPuzzleTag && puzzleState !== 'completed') {
        return;
      }

      if (e.key === 'ArrowLeft') {
        onPrevMove(currentMoveIdx, setCurrentMoveIdx);
      } else if (e.key === 'ArrowRight') {
        // onNextMove(currentMoveIdx, setCurrentMoveIdx, moves);
      } else if (e.key === 'ArrowUp') {
        // Go to the first move (reset)
        setCurrentMoveIdx('-1');
      } else if (e.key === 'ArrowDown') {
        // Go to the last move (end)
        // handleJumpToLastMove();
      }
    },
    [currentMoveIdx, moves, setCurrentMoveIdx, gameHasPuzzleTag, puzzleState],
  );

  useEffect(() => {
    document.removeEventListener('keydown', keyDownHandler);
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [keyDownHandler]);

  // Effect to switch to social tab when a comment move is selected
  // useEffect(() => {
  //   if (currentMoveIdx === '-1' || !moves) return;

  //   // Get the current move object
  //   const currentMove = getMove(moves, currentMoveIdx);

  //   // If this is a comment move (has creator of type COMMENT)
  //   if (currentMove?.creator?.type === constants.CHESSBOARD.MOVE_TYPES.COMMENT &&
  //     currentMove?.creator?.id !== -1) { // Not our own temporary comment
  //     // If we're not already on the social tab, switch to it
  //     if (expandedTab !== 'social') {
  //       handleTabSwitch('social'); // Use protected tab switching
  //     }
  //   }
  // }, [currentMoveIdx, moves, expandedTab]);

  const { screams, loading } = props.data;

  const handleAddComment = async (commentContent, moveData = null) => {
    const content = commentContent;
    const commentId = gameMetadata.comments?.length || 0;
    const creatorHandle = gameMetadata?.creatorHandle;

    // Check if we have a valid post creator
    if (!creatorHandle) {
      console.error("Post creator handle is missing - notification will not be sent");
    } else if (authenticatedUserHandle !== creatorHandle) {
      // Only send notification if commenter is not the post creator
      createCommentNotification(creatorHandle);
    } else {
    }

    // Only create notification if you're not commenting on your own post
    if (creatorHandle && creatorHandle !== authenticatedUserHandle) {
      await createCommentNotification(creatorHandle, content);
    }

    // Update moves with comment ID
    const updatedMovesWithCommentId = updateCommentIdInMoves(moves, commentId);

    // Apply the exact same profanity filtering used for game captions in 2AddGame.js
    const cleanedContent = cleanProfanity(content);

    // Create comment object with optional move-linking data
    const commentObject = {
      id: commentId,
      user: props?.user?.credentials?.userId,
      content: cleanedContent,
      username: props?.user?.credentials?.handle,
      likes: [], // Keeping this as [] as per previous advice

      // NEW: Add move-linking data if provided
      ...(moveData && {
        moveIndex: moveData.moveIndex,
        moveNotation: moveData.moveNotation, 
        moveFEN: moveData.moveFEN,
        moveFromSquare: moveData.moveFromSquare,
        moveToSquare: moveData.moveToSquare,
        parentMoveIndex: moveData.parentMoveIndex
      })
    };

    const updatedPost = {
      ...gameMetadata,
      moves: updatedMovesWithCommentId,
      comments: [
        ...(gameMetadata.comments || []),
        commentObject,
      ],
    };
    
    // Update local state immediately
    setGameMetadata(updatedPost);
    setContextMoves(updatedMovesWithCommentId); // This will trigger re-renders

    // Stay on current move after commenting (removed navigation to parent)

    // Helper function to extract all string values from an object recursively
    const extractAllStrings = (obj, path = '') => {
      const strings = [];
      
      if (typeof obj === 'string') {
        strings.push({ path, value: obj });
      } else if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          strings.push(...extractAllStrings(item, `${path}[${index}]`));
        });
      } else if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(key => {
          const newPath = path ? `${path}.${key}` : key;
          strings.push(...extractAllStrings(obj[key], newPath));
        });
      }
      
      return strings;
    };

    try {
    
      const allStrings = extractAllStrings(updatedPost);
      allStrings.forEach((item, index) => {
      });
      
      Object.keys(gameMetadata).forEach(key => {
        if (typeof gameMetadata[key] === 'string') {
        }
      });
      
      if (moves && Array.isArray(moves)) {
        moves.forEach((move, index) => {
          if (move && typeof move === 'object') {
            Object.keys(move).forEach(key => {
              if (typeof move[key] === 'string') {
              }
            });
          }
        });
      }
      
      await putGame(gameId, updatedPost);
    } catch (err) {
      console.error("Error updating game with comment:", err);
      console.error("Response data:", err.response?.data);
      console.error("Response status:", err.response?.status);
    }
  };

  const createCommentNotification = async (creatorHandle, commentContent) => {
    // Don't proceed if no creator handle is available
    if (!creatorHandle) {
      console.error("Cannot create notification: Post creator handle is missing");
      return;
    }



    try {
      // Add a new document with a generated id.
      const docRef = await addDoc(collection(firestore, "notifications"), {
        type: "new_comment",
        commentBy: authenticatedUserHandle,
        commentTo: creatorHandle,
        targetUser: creatorHandle, // Add targetUser field for efficient querying
        gameId: gameId, // Add gameId to allow navigation to the specific game
        commentContent: commentContent, // Add the actual comment content
        status: "unread",
        timestamp: new Date(),
      });

    }
    catch (error) {
      console.error("Error creating comment notification:", error);
    }
  }

  // Function to create a like notification in Firestore
  const createLikeNotification = async (creatorHandle) => {
    // Don't proceed if no creator handle is available
    if (!creatorHandle) {
      console.error("Cannot create like notification: Post creator handle is missing");
      return;
    }

    // Don't create notification if liking your own post
    if (creatorHandle === authenticatedUserHandle) {

      return;
    }



    try {
      // Add a new document with a generated id
      const docRef = await addDoc(collection(firestore, "notifications"), {
        type: "new_like",
        likedBy: authenticatedUserHandle,
        likedTo: creatorHandle,
        targetUser: creatorHandle, // Add targetUser field for efficient querying
        gameId: gameId, // Add gameId to allow navigation to the specific game
        status: "unread",
        timestamp: new Date(),
      });

      return docRef.id; // Return the ID for later reference if needed
    }
    catch (error) {
      console.error("Error creating like notification:", error);
      return null;
    }
  }

  // Function to delete a like notification when a user unlikes a post
  const deleteLikeNotification = async () => {
    try {
      // Query for notifications matching this user, game and type
      const q = firestoreQuery(
        collection(firestore, "notifications"),
        where("likedBy", "==", authenticatedUserHandle),
        where("gameId", "==", gameId),
        where("type", "==", "new_like")
      );

      const querySnapshot = await getDocs(q);

      // Check if we found any documents
      if (querySnapshot.empty) {
        
        return;
      }


      // Delete all matching notifications
      const deletePromises = [];
      querySnapshot.forEach((document) => {
        deletePromises.push(deleteDoc(document.ref));
      });

      await Promise.all(deletePromises);
    }
    catch (error) {
      console.error("Error deleting like notification:", error);
    }
  }

  const updateContentForMove = (newContent, moveIdx = null) => {
    // Use provided moveIdx or fall back to currentMoveIdx
    const targetMoveIdx = moveIdx !== null ? moveIdx : currentMoveIdx;
    
    // Handle start position content update (index -1)
    if (targetMoveIdx === '-1') {
      
      dispatch({ 
        type: 'UPDATE_START_POSITION_CONTENT', 
        payload: newContent 
      });
      return;
    }
    
    // Handle regular move content updates
    const move = getMove(moves, targetMoveIdx);
    if (move) {
      
      move.content = newContent;
      
      // Dispatch update to ensure state consistency
      dispatch({ 
        type: 'UPDATE_MOVE_PROPERTIES', 
        payload: { 
          moveId: targetMoveIdx,
          properties: { content: newContent }
        }
      });
    } else {
      console.warn('[updateContentForMove] Move not found:', targetMoveIdx);
    }
  };

  const handleBookmarkSave = (folder, isPrivate) => {
    setIsBookmarked(true);

    // Show a success notification to the user
    const notification = document.createElement('div');
    notification.textContent = `Game saved to "${folder}". Visit the Bookmark tab to see it.`;
    notification.style.position = 'fixed';
    notification.style.top = '50%';
    notification.style.left = '50%';
    notification.style.transform = 'translate(-50%, -50%)';
    notification.style.backgroundColor = 'gold';
    notification.style.color = 'black';
    notification.style.padding = '15px 25px';
    notification.style.borderRadius = '5px';
    notification.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
    notification.style.zIndex = '9999';
    notification.style.fontWeight = 'bold';
    notification.style.fontSize = '16px';
    document.body.appendChild(notification);

    // Remove the notification after 3 seconds
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.5s ease';
      setTimeout(() => document.body.removeChild(notification), 500);
    }, 3000);

    // Here you would make an API call to save the bookmark
    // For example: saveBookmark(gameId, folder, isPrivate);
  };

  const handleRemoveBookmark = () => {
    setIsBookmarked(false);

    // Show a notification for bookmark removal
    const notification = document.createElement('div');
    notification.textContent = 'Removed from Bookmarks';
    notification.style.position = 'fixed';
    notification.style.top = '50%';
    notification.style.left = '50%';
    notification.style.transform = 'translate(-50%, -50%)';
    notification.style.backgroundColor = '#333';
    notification.style.color = 'white';
    notification.style.padding = '15px 25px';
    notification.style.borderRadius = '5px';
    notification.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
    notification.style.zIndex = '9999';
    notification.style.fontWeight = 'bold';
    notification.style.fontSize = '16px';
    document.body.appendChild(notification);

    // Remove the notification after 3 seconds
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.5s ease';
      setTimeout(() => document.body.removeChild(notification), 500);
    }, 3000);

    // Here you would make an API call to remove the bookmark
    // For example: removeBookmark(gameId);

  };

  // Add effect to close expanded annotation when currentMoveIdx changes
  useEffect(() => {
    if (expandedAnnotation) {
      setExpandedAnnotation(false);
    }
  }, [currentMoveIdx]);

  // Add effect to handle keyboard and click events to close expanded annotation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (expandedAnnotation && (e.key === 'Escape' || e.key === 'Esc')) {
        setExpandedAnnotation(false);
      }
    };

    const handleClickOutside = (e) => {
      // Close expanded annotation when clicking outside the annotation content
      if (expandedAnnotation) {
        const annotationContent = document.querySelector('.annotation-content');
        const annotationHeader = document.querySelector('.annotation-header');
        if (annotationContent && annotationHeader &&
          !annotationContent.contains(e.target) &&
          !annotationHeader.contains(e.target) &&
          !e.target.closest('.annotation-close-btn')) {
          setExpandedAnnotation(false);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [expandedAnnotation]);

  // Add an effect to handle automatic moves when currentMoveIdx changes
  useEffect(() => {
    // Only process for puzzles that aren't completed yet
    if (!gameHasPuzzleTag || !gameMetadata?.moves || puzzleState === 'completed' || puzzleState === 'reset') {
      return;
    }

    // Skip this for the initial state and if user is starting the puzzle
    if (currentMoveIdx === '-1') {
      return;
    }

    const moveIndex = parseInt(currentMoveIdx);

    // Only process if this is a user's move (even indices: 0, 2, 4...)
    if (moveIndex % 2 === 0) {

      // If there's a next opponent move to play
      if (moveIndex + 1 < gameMetadata.moves.length) {
        // Schedule the opponent's response after a short delay
        const timeoutId = setTimeout(() => {

          // This directly sets the move index to show the opponent's move
          setCurrentMoveIdx((moveIndex + 1).toString());

          // Reveal the opponent's move (add it to the revealed moves)
          setRevealedMoves(prev => {
            if (!prev.includes(moveIndex + 1)) {
              // Set this as the last revealed move for animation
              setLastRevealedMove(moveIndex + 1);
              // Clear the last revealed move highlight after 1.5 seconds
              setTimeout(() => setLastRevealedMove(null), 1500);
              return [...prev, moveIndex + 1];
            }
            return prev;
          });

          // REMOVED: Duplicate completion check - this is now handled only in handlePuzzleMoveValidation

        }, 800);

        // Clean up the timeout if the component unmounts or the effect is re-run
        return () => clearTimeout(timeoutId);
      }
      // If there's no opponent move after this, the puzzle completion is handled in handlePuzzleMoveValidation
    }
  }, [currentMoveIdx, gameHasPuzzleTag, gameMetadata?.moves, puzzleState]);

  // Add a useEffect to monitor puzzle completion based on current position
  useEffect(() => {
    // Only check for completion in active puzzles
    if (!gameHasPuzzleTag || !gameMetadata?.moves || puzzleState === 'completed' || puzzleState === 'reset') {
      return;
    }

    // Skip if we're at the starting position
    if (currentMoveIdx === '-1') {
      return;
    }

    const currentIndex = parseInt(currentMoveIdx);
    const totalMoves = gameMetadata.moves.length;

    // Check if we've reached or exceeded the final move in the puzzle
    if (currentIndex >= totalMoves - 1) {
      

      // Add a small delay to ensure the move is fully processed
      setTimeout(() => {
        if (puzzleState !== 'completed') {
          
          setPuzzleState('completed');
          setShowGameSettings(true);
        }
      }, 300);
    }
  }, [currentMoveIdx, gameHasPuzzleTag, gameMetadata?.moves, puzzleState]);

  // Reset revealedMoves when a new puzzle is loaded
  useEffect(() => {
    if (gameHasPuzzleTag && gameMetadata?.moves) {
      setRevealedMoves([]); // Reset to empty array when loading a puzzle
    }
  }, [gameHasPuzzleTag, gameId, gameMetadata?.moves]);

  // Simplify the handlePuzzleMoveValidation function to ONLY validate moves
  const handlePuzzleMoveValidation = (move) => {
    

    // Skip validation if not a puzzle, no solution, or if puzzle is already completed
    if (!gameHasPuzzleTag || !gameMetadata?.moves || puzzleState === 'completed') {
      return true; // Allow the move
    }

    // Special handling for the very first move of the puzzle
    if (currentMoveIdx === '-1') {
      

      // For first move, compare against the first move in the solution (index 0)
      if (move.san === gameMetadata.moves[0]?.notation) {
        // Correct first move - allow it and reveal it
        setRevealedMoves(prev => [...prev, 0]);
        setLastRevealedMove(0);
        setTimeout(() => setLastRevealedMove(null), 1500);
        return true;
      } else {
        // Incorrect first move - show popup
        setPuzzleState('incorrect');
        setShowGameSettings(true);
        return false;
      }
    }

    // Get the current move index as number
    const currentMoveIndex = parseInt(currentMoveIdx);

    // Determine the next expected move index
    const nextMoveIndex = currentMoveIndex + 1;

    // Get the expected move at this position
    const expectedMove = gameMetadata.moves[nextMoveIndex];

    // If there's no expected move, allow the move (completion will be handled by useEffect)
    if (!expectedMove) {
      
      return true;
    }

    // Compare the attempted move with the expected move
    if (move.san === expectedMove.notation) {
      // Correct move - allow it and reveal it
      

      // Reveal this move (add it to the revealed moves)
      setRevealedMoves(prev => {
        if (!prev.includes(nextMoveIndex)) {
          setLastRevealedMove(nextMoveIndex);
          setTimeout(() => setLastRevealedMove(null), 1500);
          return [...prev, nextMoveIndex];
        }
        return prev;
      });

      // Note: Completion detection is now handled by the dedicated useEffect
      return true;
    } else {
      // Incorrect move - show the popup
     
      
      setPuzzleState('incorrect');
      setShowGameSettings(true);
      return false;
    }
  };

  // Add this function to check if a move should be allowed to be recorded as a variation
  const shouldAllowVariation = () => {
    // Only disallow variations in active puzzles
    if (gameHasPuzzleTag && puzzleState !== 'completed') {
      return false;
    }

    // Allow variations for completed puzzles and all other game types
    return true;
  };

  // Add custom CSS for the newly revealed move animation
  useEffect(() => {
    // Add the CSS for revealed move animation if it doesn't exist yet
    if (!document.getElementById('revealed-move-styles')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'revealed-move-styles';
      styleEl.innerHTML = `
        @keyframes highlightRevealedMove {
          0% { background-color: gold; color: black; }
          70% { background-color: gold; color: black; }
          100% { background-color: transparent; }
        }
        .newly-revealed-move {
          animation: highlightRevealedMove 1.5s ease-out;
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Cleanup on unmount
    return () => {
      const styleEl = document.getElementById('revealed-move-styles');
      if (styleEl) styleEl.remove();
    };
  }, []);

  // Create a wrapper for Moves component that adds the highlight class to newly revealed moves
  const PuzzleMoves = ({ moves, ...props }) => {
    // Process moves to add the highlight class to newly revealed moves
    const processedMoves = moves.map((move, idx) => {
      // If this is the last revealed move, add a special class for highlighting
      if (idx === lastRevealedMove) {
        return { ...move, className: 'newly-revealed-move' };
      }
      return move;
    });

    return (
      <MovesThree 
        moves={processedMoves} 
        isPuzzle={true}
        maxMoveIndex={parseInt(currentMoveIdx)}
        revealedMoves={revealedMoves}
        isViewGame={true} // Enable variation captions and move content
        {...props} 
      />
    );
  };

  // Add a ref to track if we're currently showing the solution
  const showingSolutionRef = useRef(false);

  // Add a function to handle showing the solution step by step
  const showPuzzleSolution = useCallback(() => {
    // Prevent multiple simultaneous calls
    if (showingSolutionRef.current) {
      
      return;
    }

    // Additional check to ensure we should still be showing the solution
    if (puzzleState !== 'showAll') {
      
      return;
    }

    showingSolutionRef.current = true;
    

    // Reset to the start
    setCurrentMoveIdx('-1');
    setRevealedMoves([]);

    // Play all moves in sequence with a delay
    const playMovesWithDelay = (moveIndex = 0) => {
      if (moveIndex >= gameMetadata?.moves?.length) {
        // All moves played, show completed popup
        
        showingSolutionRef.current = false; // Reset the flag
        setTimeout(() => {
          setPuzzleState('completed');
          setShowGameSettings(true);
        }, 500);
        return;
      }

      setTimeout(() => {
        // Set this move as revealed and current
        
        setCurrentMoveIdx(moveIndex.toString());
        setRevealedMoves(prev => [...new Set([...prev, moveIndex])]);
        
        // Update the board position via useGameLogic hook
        if (dispatch) {
          dispatch({ type: 'GOTO_MOVE', payload: moveIndex.toString() });
        }

        // Continue with next move
        playMovesWithDelay(moveIndex + 1);
      }, 750); // 750ms delay between moves
    };

    // Start playing from the beginning
    playMovesWithDelay(0);
  }, [gameMetadata?.moves, setCurrentMoveIdx, dispatch, puzzleState]);

  // Handle puzzle state changes
  useEffect(() => {
    if (!gameHasPuzzleTag) return;

    if (puzzleState === 'reset') {
      // Reset puzzle to initial state
      
      showingSolutionRef.current = false; // Reset the solution flag
      setCurrentMoveIdx('-1');
      setRevealedMoves([]);
      setLastRevealedMove(null);
      
      // Reset the board to the initial position using the useGameLogic hook
      if (dispatch) {
        dispatch({ type: 'GOTO_MOVE', payload: '-1' });
      }
      
      // Reset puzzle state to default after a short delay
      setTimeout(() => {
        setPuzzleState('incorrect');
      }, 100);
    } else if (puzzleState === 'showAll') {
      // Show the entire solution
      
      showPuzzleSolution();
    }
  }, [puzzleState, gameHasPuzzleTag, dispatch]); // Removed showPuzzleSolution from dependencies

  // Add this function to automatically play opponent moves
  const makeAutomaticMove = (moveIndex) => {
    try {
      // Get the move from the puzzle solution
      const moveToPlay = gameMetadata?.moves[moveIndex];

      if (!moveToPlay || !moveToPlay.notation) {
        console.error("Invalid move to play automatically:", moveIndex, moveToPlay);
        return false;
      }



      // This is the key change - we need to call the hook's update function directly
      setCurrentMoveIdx(moveIndex.toString());

      // Add a visual indication that auto-move was executed
      const notification = document.createElement('div');
      notification.textContent = `Auto-move: ${moveToPlay.notation}`;
      notification.style.position = 'fixed';
      notification.style.bottom = '20px';
      notification.style.right = '20px';
      notification.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      notification.style.color = 'white';
      notification.style.padding = '10px';
      notification.style.borderRadius = '5px';
      notification.style.zIndex = '9999';
      document.body.appendChild(notification);

      // Remove the notification after 2 seconds
      setTimeout(() => {
        notification.style.opacity = '0';
        notification.style.transition = 'opacity 0.5s ease';
        setTimeout(() => document.body.removeChild(notification), 500);
      }, 2000);

      return true;
    } catch (error) {
      console.error("Error making automatic move:", error);
      return false;
    }
  };

  // Add handlers for variation management
  const handleUndoCommentMove = () => {
    if (gameHasPuzzleTag) return; // Don't allow in puzzles

    
    
    // Set flag to bypass delete confirmation during undo
    isUndoOperationRef.current = true;
    
    // Check if we're in a variation (comment moves are always in variations)
    if (currentMoveIdx.includes('|')) {
      // We're in a variation - parse the path
      const parts = currentMoveIdx.split('|');
      const mainLineIdx = parseInt(parts[0]);
      const [varIdx, moveIdx] = parts[1].split(':').map(Number);
      
      
      
      const parentMove = moves[mainLineIdx];
      const variation = parentMove?.variations?.[varIdx];
      
      if (!variation || variation.length === 0) {
        
        isUndoOperationRef.current = false; // Reset flag
        return;
      }
      
      
      
      // Check if we're on the last move in the variation
      const isOnLastMove = moveIdx === variation.length - 1;
      
      if (isOnLastMove) {
        // We're on the last move - delete it directly
        
        
        if (moveIdx === 0) {
          // This is the first and only move - go back to parent move
          
          
          // Set flag to bypass confirmation during navigation
          isUndoOperationRef.current = true;
          
          // Remove the entire variation first
          const updatedMoves = [...moves];
          updatedMoves[mainLineIdx].variations.splice(varIdx, 1);
          
          // Clear variation state immediately to prevent conflicts
          setIsVariationActive(false);
          setVariationToComment(null);
          
          // Navigate back to parent move using direct dispatch to avoid confirmation
          dispatch({ type: 'GOTO_MOVE', payload: mainLineIdx.toString() });
          setCurrentMoveIdx(mainLineIdx);
          
          // Clear any position caches that might prevent the same move from being made again
          if (window.resetChessPositionCache) {
            
            window.resetChessPositionCache();
          }
          
          // Clear any board-level move tracking that might consider this a duplicate
          if (window.gameLogic && window.gameLogic.lastMoveRef) {
            
            window.gameLogic.lastMoveRef.current = null;
          }
          
          // Dispatch chess-game-reset event to clear board's lastMoveRef and allow same move again
          
          window.dispatchEvent(new Event('chess-game-reset'));
          
          // Reset flag after successful undo
          isUndoOperationRef.current = false;
        } else {
          // Not the first move - just remove this move and go to previous in variation
          
          const updatedMoves = [...moves];
          updatedMoves[mainLineIdx].variations[varIdx].pop(); // Remove last move
          dispatch({ type: 'SET_MOVES', payload: updatedMoves });
          
          // Go to the new last move in the variation (stay in variation)
          const newLastMoveIdx = moveIdx - 1;
          const newMoveId = `${mainLineIdx}|${varIdx}:${newLastMoveIdx}`;
          
          
          // Set undo flag to bypass confirmation during navigation
          isUndoOperationRef.current = true;
          
          // Navigate using direct dispatch to avoid confirmation
          dispatch({ type: 'GOTO_MOVE', payload: newMoveId });
          setCurrentMoveIdx(newMoveId);
          
          // Clear any position caches that might prevent the same move from being made again
          if (window.resetChessPositionCache) {
            
            window.resetChessPositionCache();
          }
          
          // Dispatch chess-game-reset event to clear board's lastMoveRef and allow same move again
          
          window.dispatchEvent(new Event('chess-game-reset'));
          
          // Reset flag after successful undo
          isUndoOperationRef.current = false;
        }
        
        // Reset flag after successful undo
        isUndoOperationRef.current = false;
      } else {
        // We're not on the last move - show the UndoConfirmModal
        
        isUndoOperationRef.current = false; // Reset flag
        setShowUndoConfirmModal(true);
      }
    } else {
      // We're in main line - use original logic
      const { prefix, currMoveNum } = parseMove(currentMoveIdx);
      let nextMoveIdx = `${prefix}${currMoveNum + 1}`;

      // Check if we're on the last move in the current line
      if (isMoveValid(nextMoveIdx, moves)) {
        // We're not on the last move, show the UndoConfirmModal
        isUndoOperationRef.current = false; // Reset flag
        setShowUndoConfirmModal(true);
        return;
      }

      // We're on the last move, proceed with undo
      isUndoOperationRef.current = false; // Reset flag before calling performUndoLastMove
      performUndoLastMove();
    }
  };

  // Function to perform the actual undo of the last move
  const performUndoLastMove = () => {
    
    
    
    if (moves.length === 0) {
      
      return;
    }

    // Create a copy of moves and remove the last one
    const newMoves = [...moves];
    const removedMove = newMoves.pop();
    

    // Update moves
    setContextMoves(newMoves);

    // Calculate new current move index
    let newCurrentMoveIdx;
    if (newMoves.length === 0) {
      newCurrentMoveIdx = '-1';
    } else {
      newCurrentMoveIdx = (newMoves.length - 1).toString();
    }
    
    

    // Update current move index
    goToContextMove(newCurrentMoveIdx);

    // Calculate and set the new FEN position
    let newFEN;
    if (newCurrentMoveIdx === '-1') {
      newFEN = rootFEN;
      
    } else {
      // Calculate FEN for the new last move
      try {
        const tempGame = new Chess(rootFEN);
        const targetIdx = parseInt(newCurrentMoveIdx);
        
        for (let i = 0; i <= targetIdx && i < newMoves.length; i++) {
          if (newMoves[i] && newMoves[i].notation) {
            
            tempGame.move(newMoves[i].notation);
          }
        }
        
        newFEN = tempGame.fen();
        
      } catch (error) {
        console.error('[performUndoLastMove] Error calculating FEN:', error);
        newFEN = rootFEN;
      }
    }

    // Update the board position
    setContextFEN(newFEN);
    
    
  };

  // Function to jump to the last move in the current line (variation-aware)
  const handleJumpToLastMove = () => {
    
    
    
    // Close the modal first
    setShowUndoConfirmModal(false);
    
    if (!moves || moves.length === 0) {
      
      return;
    }

    // Check if we're in a variation
    if (currentMoveIdx.includes('|')) {
      
      
      // Parse the variation path
      const parts = currentMoveIdx.split('|');
      const mainLineIdx = parseInt(parts[0]);
      const [varIdx, moveIdx] = parts[1].split(':').map(Number);
      
      
      
      // Get the variation
      const parentMove = moves[mainLineIdx];
      const variation = parentMove?.variations?.[varIdx];
      
      if (variation && variation.length > 0) {
        // Jump to the last move in this variation
        const lastMoveInVariation = variation.length - 1;
        const newMoveIdx = `${mainLineIdx}|${varIdx}:${lastMoveInVariation}`;
        
        
        goToContextMove(newMoveIdx);
        
        // Calculate FEN for this position
        try {
          const tempGame = new Chess(rootFEN);
          
          // Play main line moves up to parent
          for (let i = 0; i <= mainLineIdx && i < moves.length; i++) {
            if (moves[i] && moves[i].notation) {
              tempGame.move(moves[i].notation);
            }
          }
          
          // Play variation moves
          for (let j = 0; j <= lastMoveInVariation && j < variation.length; j++) {
            if (variation[j] && variation[j].notation) {
              tempGame.move(variation[j].notation);
            }
          }
          
          const newFEN = tempGame.fen();
          
          setContextFEN(newFEN);
        } catch (error) {
          console.error('[handleJumpToLastMove] Error calculating variation FEN:', error);
        }
      }
    } else {
      // Main line - jump to last move
      const lastMoveIdx = (moves.length - 1).toString();
      
      
      goToContextMove(lastMoveIdx);
      
      // Calculate FEN for last move
      try {
        const tempGame = new Chess(rootFEN);
        
        for (let i = 0; i < moves.length; i++) {
          if (moves[i] && moves[i].notation) {
            
            tempGame.move(moves[i].notation);
          }
        }
        
        const newFEN = tempGame.fen();
        
        setContextFEN(newFEN);
      } catch (error) {
        console.error('[handleJumpToLastMove] Error calculating main line FEN:', error);
      }
    }
    
    
  };

  // Function to end the line at the current position
  const handleEndLineHere = () => {
    
    
    
    setShowUndoConfirmModal(false);

    if (!moves || moves.length === 0) {
      
      return;
    }

    // Check if we're in a variation
    if (currentMoveIdx.includes('|')) {
      
      
      // Parse the variation path
      const parts = currentMoveIdx.split('|');
      const mainLineIdx = parseInt(parts[0]);
      const [varIdx, moveIdx] = parts[1].split(':').map(Number);
      
      
      
      // Create a copy of moves and trim the variation
      const newMoves = [...moves];
      const parentMove = newMoves[mainLineIdx];
      
      if (parentMove && parentMove.variations && parentMove.variations[varIdx]) {
        // Trim the variation to the current move
        const trimmedVariation = parentMove.variations[varIdx].slice(0, moveIdx + 1);
        newMoves[mainLineIdx] = {
          ...parentMove,
          variations: [
            ...parentMove.variations.slice(0, varIdx),
            trimmedVariation,
            ...parentMove.variations.slice(varIdx + 1)
          ]
        };
        
        
        setContextMoves(newMoves);
        
        // Stay at the current position (no move change needed)
        // But recalculate FEN to ensure consistency
        try {
          const tempGame = new Chess(rootFEN);
          
          // Play main line moves up to parent
          for (let i = 0; i <= mainLineIdx && i < newMoves.length; i++) {
            if (newMoves[i] && newMoves[i].notation) {
              tempGame.move(newMoves[i].notation);
            }
          }
          
          // Play variation moves up to current position
          for (let j = 0; j <= moveIdx && j < trimmedVariation.length; j++) {
            if (trimmedVariation[j] && trimmedVariation[j].notation) {
              tempGame.move(trimmedVariation[j].notation);
            }
          }
          
          const newFEN = tempGame.fen();
          
          setContextFEN(newFEN);
        } catch (error) {
          console.error('[handleEndLineHere] Error calculating trimmed variation FEN:', error);
        }
      }
    } else {
      // Main line - trim to current move
      const currentIdx = parseInt(currentMoveIdx);
      const newMoves = moves.slice(0, currentIdx + 1);
      
      
      setContextMoves(newMoves);
      
      // Calculate FEN for the new last move
      try {
        const tempGame = new Chess(rootFEN);
        
        for (let i = 0; i < newMoves.length; i++) {
          if (newMoves[i] && newMoves[i].notation) {
            
            tempGame.move(newMoves[i].notation);
          }
        }
        
        const newFEN = tempGame.fen();
        
        setContextFEN(newFEN);
      } catch (error) {
        console.error('[handleEndLineHere] Error calculating trimmed main line FEN:', error);
      }
    }
    
    
  };

  const handleDeleteCurrentCommentLine = () => {
    if (gameHasPuzzleTag) return; // Don't allow in puzzles

    
    

    // Create a deep copy of moves to work with
    let updatedPostMoves = JSON.parse(JSON.stringify(moves));
    
    // COMPLETE RESET OF TEMPORARY COMMENT MOVES
    // This function recursively removes all temporary comment moves (id === -1) from the entire move tree
    const removeAllTemporaryCommentMoves = (movesArray) => {
      if (!movesArray || !Array.isArray(movesArray)) return movesArray;
      
      // First, filter out any top-level temporary comment moves
      const filteredMoves = movesArray.filter(move => {
        const isTemporaryComment = move?.creator?.type === constants.CHESSBOARD.MOVE_TYPES.COMMENT && 
                                  move?.creator?.id === -1;
        if (isTemporaryComment) {
          
        }
        return !isTemporaryComment;
      });
      
      // Then, recursively clean variations
      filteredMoves.forEach(move => {
        if (move.variations && Array.isArray(move.variations)) {
          move.variations = move.variations.map(variation => {
            return removeAllTemporaryCommentMoves(variation);
          }).filter(variation => variation.length > 0); // Remove empty variations
        }
      });
      
      return filteredMoves;
    };
    
    // Apply the complete cleanup
    updatedPostMoves = removeAllTemporaryCommentMoves(updatedPostMoves);
    
   
    
    // Update the moves in the store
    dispatch({ type: 'SET_MOVES', payload: updatedPostMoves });

    // Navigate back to parent move if we were in a variation
    if (currentMoveIdx.includes('|')) {
      
      navigateToParentMove(currentMoveIdx);
    } else {
      // We were in main line - go to the last valid move
      let targetMoveIdx;
      if (updatedPostMoves.length > 0) {
        targetMoveIdx = (updatedPostMoves.length - 1).toString();
      } else {
        targetMoveIdx = '-1'; // Go to start if no moves left
      }
      
      
      // Navigate to the target position with proper FEN calculation
      setCurrentMoveIdx(parseInt(targetMoveIdx) >= 0 ? parseInt(targetMoveIdx) : -1);
      goToContextMove(targetMoveIdx);
      
      // Calculate and set the correct FEN
      let newFEN;
      if (targetMoveIdx === '-1') {
        newFEN = rootFEN;
      } else {
        try {
          const tempGame = new Chess(rootFEN);
          const targetIdx = parseInt(targetMoveIdx);
          
          for (let i = 0; i <= targetIdx && i < updatedPostMoves.length; i++) {
            if (updatedPostMoves[i] && updatedPostMoves[i].notation) {
              tempGame.move(updatedPostMoves[i].notation);
            }
          }
          
          newFEN = tempGame.fen();
        } catch (error) {
          console.error('[handleDeleteCurrentCommentLine] Error calculating FEN:', error);
          newFEN = rootFEN;
        }
      }
      
      setContextFEN(newFEN);
    }

    // COMPLETE STATE RESET
    setIsVariationActive(false);
    setVariationToComment(null);
    
    // Clear any position caches that might prevent the same move from being made again
    if (window.resetChessPositionCache) {
      
      window.resetChessPositionCache();
    }
    
    // Dispatch chess-game-reset event to clear board's lastMoveRef and allow same move again
    
    window.dispatchEvent(new Event('chess-game-reset'));
    
    
  };

  const calculateVariationStartingTurn = (allMoves, parentMoveNotation, mainBoardStartingTurn) => {
    // Safety check for parentMoveNotation
    if (!parentMoveNotation || typeof parentMoveNotation !== 'string') {
      return mainBoardStartingTurn;
    }
    
    const parentMoveObj = getMove(allMoves, parentMoveNotation);
    if (!parentMoveObj) return mainBoardStartingTurn; // Default if parent move not found
    
    try {
      // Get the numerical index of the parent move on its own line
      let parentMoveIndexOnItsLine = 0;
      
      if (parentMoveNotation.includes('|')) {
        const parentParts = parentMoveNotation.split('|');
        const parentLastSegment = parentParts[parentParts.length - 1];
        
        if (parentLastSegment && parentLastSegment.includes(':')) {
          parentMoveIndexOnItsLine = parseInt(parentLastSegment.split(':')[0]);
        } else if (parentLastSegment) {
          parentMoveIndexOnItsLine = parseInt(parentLastSegment);
        }
      } else {
        // Simple case - just a number
        parentMoveIndexOnItsLine = parseInt(parentMoveNotation);
      }
      
      // If parsing failed and resulted in NaN, default to 0
      if (isNaN(parentMoveIndexOnItsLine)) {
        parentMoveIndexOnItsLine = 0;
      }
      
      // Determine if the parent move was white or black
      const isParentWhite = (mainBoardStartingTurn === 'w') ? 
        (parentMoveIndexOnItsLine % 2 === 0) : 
        (parentMoveIndexOnItsLine % 2 !== 0);
        
      // The variation starting turn is the opposite color of the parent
      return isParentWhite ? 'b' : 'w';
    } catch (error) {
      console.error("Error in calculateVariationStartingTurn:", error);
      return mainBoardStartingTurn; // Default in case of error
    }
  };

  // Helper to get the last main line move index (not a comment)
  const getLastMainLineMove = () => {
    if (!moves || moves.length === 0) return '-1';
    let lastMainLineIdx = -1;
    for (let i = 0; i < moves.length; i++) {
      if (!moves[i].creator || moves[i].creator.type !== 'COMMENT') {
        lastMainLineIdx = i;
      } else {
        break;
      }
    }
    return lastMainLineIdx.toString();
  };

  if (loading) {
    return <ScreamSkeleton />;
  }
  /*
    return (
      <Grid container spacing={16}>
        <Grid item sm={8} xs={12}>
          {recentScreamsMarkup}
        </Grid>
        <Grid item sm={4} xs={12}>
          <Profile />
        </Grid>
      </Grid>
    );
    */

  const handleNextGameClick = () => {
    // Create a clean query object that excludes ctx=newGame parameter
    const cleanQuery = new URLSearchParams();
    query.forEach((value, key) => {
      if (key !== 'ctx') {
        cleanQuery.append(key, value);
      }
    });

    // Get origin and gameIds from location.state
    // if (location.state?.origin === 'TRENDING' && gameMetadata?.nextGameId) {
    const origin = location.state?.origin;
    const stateGameIds = location.state?.gameIds;

    // Check for TRENDING, FOLLOWING, or tag-filter context using location.state
    if (stateGameIds && Array.isArray(stateGameIds)) {
      const currentIndex = stateGameIds.indexOf(gameId);
      if (currentIndex !== -1 && currentIndex < stateGameIds.length - 1) {
        const nextGameId = stateGameIds[currentIndex + 1];
        
        // Preserve the tag URL parameter if it exists
        let navigateUrl = `/games/${nextGameId}`;
        if (tag) {
          navigateUrl += `?tag=${tag}`;
        }
        
        // Pass the same state along to maintain the collection
        history.push(navigateUrl, location.state);
        return;
      } else if (currentIndex === stateGameIds.length - 1) {
        // Reached the end of the collection
        alert('You have reached the last game in this collection.');
        return;
      }
    } 
    // Check if we're in a tag-filtered context but don't have gameIds in state
    else if (tag && gameMetadata?.nextGameId) {
      // Make sure the tag filter is preserved when navigating to the next game
      cleanQuery.set('tag', tag); // Ensure tag is included in query params
      history.push(`/games/${gameMetadata.nextGameId}?${cleanQuery.toString()}`);
      return;
    }
    // **** Check for ALL GAMES context (using URL params and component state) ****
    else if (fromAllGames && creatorId) {
      if (creatorGames.length > 0 && currentCreatorGameIndex !== null && currentCreatorGameIndex < creatorGames.length - 1) {
        const nextIndex = currentCreatorGameIndex + 1;
        const nextGame = creatorGames[nextIndex];
        if (!nextGame || !nextGame.id) {
          console.error("[DEBUG] Error: Next game or game ID missing in creatorGames array at index", nextIndex);
          return; // Prevent navigation if data is missing
        }

        // Don't include ctx=newGame in the URL
        const nextGameUrl = `/games/${nextGame.id}?fromAllGames=true&creatorId=${creatorId}&gameIndex=${nextIndex}`;
        history.push(nextGameUrl);
        return; // Exit after handling this context
      } else {
        // Optionally alert user or do nothing if already at the end
        if (currentCreatorGameIndex === creatorGames.length - 1) {
          alert('You are at the last game by this creator.');
        }
        return;
      }
    }

    // Remaining code for folders/bookmarks stays the same...
    // Existing logic for folders / chronological
    const nextGameInFolder = folderGames[currentFolderIndex + 1];

    

    // Check if we're at the end of a folder
    if ((fromBookmark || fromProfile) && folderName && folderGames.length > 0 && currentFolderIndex === folderGames.length - 1) {
      if (!isAuthenticatedUser) {
        alert('Sign in to access more games and content.');
      } else {
        alert('You are at the last game in this folder.');
      }
      return;
    }

    // First check if we're in a bookmark or profile folder context and have a valid next game
    if ((fromBookmark || fromProfile) && folderName && nextGameInFolder && nextGameInFolder.gameId) {
      // Create base URL with the next game's folder context 
      // Make sure not to include ctx=newGame
      let nextGameUrl = `/games/${nextGameInFolder.gameId}?`;

      // Add appropriate parameters based on navigation context
      if (fromProfile) {
        nextGameUrl += `fromProfile=true&profileUserId=${profileUserId}&folderName=${encodeURIComponent(folderName)}`;
      } else {
        nextGameUrl += `fromBookmark=true&folderName=${encodeURIComponent(folderName)}`;
      }

      // Add folder index if available
      if (nextGameInFolder.index !== undefined) {
        history.push(`${nextGameUrl}&folderIndex=${nextGameInFolder.index}`);
      } else if (currentFolderIndex !== null) {
        history.push(`${nextGameUrl}&folderIndex=${currentFolderIndex + 1}`);
      } else {
        history.push(nextGameUrl);
      }
    }
    // Fall back to metadata-based navigation if direct folder info isn't available
    else if (gameMetadata?.nextGameId) {
      if ((fromBookmark || fromProfile) && folderName) {
        // Create a base URL with the next game's context info
        // Make sure not to include ctx=newGame
        let nextGameUrl = `/games/${gameMetadata.nextGameId}?`;

        // Add appropriate parameters based on navigation context
        if (fromProfile) {
          nextGameUrl += `fromProfile=true&profileUserId=${profileUserId}&folderName=${encodeURIComponent(folderName)}`;
        } else {
          nextGameUrl += `fromBookmark=true&folderName=${encodeURIComponent(folderName)}`;
        }

        // Add folder index if available
        if (gameMetadata.nextGameBookmarkInfo && gameMetadata.nextGameBookmarkInfo.folderIndex !== undefined) {
          history.push(`${nextGameUrl}&folderIndex=${gameMetadata.nextGameBookmarkInfo.folderIndex}`);
        } else {
          history.push(nextGameUrl);
        }
      } else {
        // Default navigation with clean query (no ctx=newGame)
        history.push(`/games/${gameMetadata.nextGameId}?${cleanQuery.toString()}`);
      }
    } else {
      // More user-friendly message for non-authenticated users
      if (!isAuthenticatedUser) {
        alert('Sign in to access more games and content.');
      } else {
        alert('No more games available.');
      }
    }
  };

  const handlePrevGameClick = () => {
    // Create a clean query object that excludes ctx=newGame parameter
    const cleanQuery = new URLSearchParams();
    query.forEach((value, key) => {
      if (key !== 'ctx') {
        cleanQuery.append(key, value);
      }
    });

    // Get origin and gameIds from location.state
    const origin = location.state?.origin;
    const stateGameIds = location.state?.gameIds;

    // Check for TRENDING, FOLLOWING, or tag-filter context using location.state
    if (stateGameIds && Array.isArray(stateGameIds)) {
      const currentIndex = stateGameIds.indexOf(gameId);
      if (currentIndex > 0) {
        const prevGameId = stateGameIds[currentIndex - 1];
        
        // Preserve the tag URL parameter if it exists
        let navigateUrl = `/games/${prevGameId}`;
        if (tag) {
          navigateUrl += `?tag=${tag}`;
        }
        
        // Pass the same state along to maintain the collection
        history.push(navigateUrl, location.state);
        return;
      } else if (currentIndex === 0) {
        // Reached the beginning of the collection
        alert('You are at the first game in this collection.');
        return;
      }
    }
    // Check if we're in a tag-filtered context but don't have gameIds in state
    else if (tag && gameMetadata?.prevGameId) {
      // Make sure the tag filter is preserved when navigating to the previous game
      cleanQuery.set('tag', tag); // Ensure tag is included in query params
      history.push(`/games/${gameMetadata.prevGameId}?${cleanQuery.toString()}`);
      return;
    }
    // **** Check for ALL GAMES context (using URL params and component state) ****
    else if (fromAllGames && creatorId) {
      if (creatorGames.length > 0 && currentCreatorGameIndex !== null && currentCreatorGameIndex > 0) {
        const prevIndex = currentCreatorGameIndex - 1;
        const prevGame = creatorGames[prevIndex];
        if (!prevGame || !prevGame.id) {
          console.error("[DEBUG] Error: Previous game or game ID missing in creatorGames array at index", prevIndex);
          return; // Prevent navigation if data is missing
        }

        const prevGameUrl = `/games/${prevGame.id}?fromAllGames=true&creatorId=${creatorId}&gameIndex=${prevIndex}`;
        history.push(prevGameUrl);
        return; // Exit after handling this context
      } else {
        // Optionally alert user or do nothing if already at the beginning
        if (currentCreatorGameIndex === 0) {
          alert('You are at the first game by this creator.');
        }
        return;
      }
    }

    // Existing logic for folders / chronological
    const prevGameInFolder = folderGames[currentFolderIndex - 1];

    

    // Check if we're at the beginning of a folder
    if ((fromBookmark || fromProfile) && folderName && currentFolderIndex === 0) {
      if (!isAuthenticatedUser) {
        alert('Sign in to access more games and content.');
      } else {
        alert('You are at the first game in this folder.');
      }
      return;
    }

    // First check if we're in a bookmark or profile folder context and have a valid previous game
    if ((fromBookmark || fromProfile) && folderName && prevGameInFolder && prevGameInFolder.gameId) {
      // Create base URL with the previous game's folder context
      let prevGameUrl = `/games/${prevGameInFolder.gameId}?`;

      // Add appropriate parameters based on navigation context
      if (fromProfile) {
        prevGameUrl += `fromProfile=true&profileUserId=${profileUserId}&folderName=${encodeURIComponent(folderName)}`;
      } else {
        prevGameUrl += `fromBookmark=true&folderName=${encodeURIComponent(folderName)}`;
      }

      // Add folder index if available
      if (prevGameInFolder.index !== undefined) {
        history.push(`${prevGameUrl}&folderIndex=${prevGameInFolder.index}`);
      } else if (currentFolderIndex !== null) {
        history.push(`${prevGameUrl}&folderIndex=${currentFolderIndex - 1}`);
      } else {
        history.push(prevGameUrl);
      }
    }
    // Fall back to metadata-based navigation if direct folder info isn't available
    else if (gameMetadata?.prevGameId) {
      // if ((fromBookmark || fromProfile) && folderName && gameMetadata.prevGameBookmarkInfo) {

      if ((fromBookmark || fromProfile) && folderName) {
        // Create a base URL with the previous game's context info
        let prevGameUrl = `/games/${gameMetadata.prevGameId}?`;

        // Add appropriate parameters based on navigation context
        if (fromProfile) {
          prevGameUrl += `fromProfile=true&profileUserId=${profileUserId}&folderName=${encodeURIComponent(folderName)}`;
        } else {
          prevGameUrl += `fromBookmark=true&folderName=${encodeURIComponent(folderName)}`;
        }

        // Add folder index if available
        if (gameMetadata.prevGameBookmarkInfo && gameMetadata.prevGameBookmarkInfo.folderIndex !== undefined) {
          history.push(`${prevGameUrl}&folderIndex=${gameMetadata.prevGameBookmarkInfo.folderIndex}`);
        } else {
          history.push(prevGameUrl);
        }
      } else {
        // Default navigation with clean query (no ctx=newGame)
        history.push(`/games/${gameMetadata.prevGameId}?${cleanQuery.toString()}`);
      }
    } else {
      // More user-friendly message for non-authenticated users
      if (!isAuthenticatedUser) {
        alert('Sign in to access more games and content.');
      } else {
        alert('No previous games available.');
      }
    }
  };

  // Get appropriate difficulty icon based on difficulty level
  const getDifficultyIcon = (difficulty) => {
    switch (difficulty?.toLowerCase()) {
      case 'all levels':
        return <i className="fa-solid fa-chess-board"></i>;
      case 'beginner':
        return <i className="fa-solid fa-chess-pawn"></i>;
      case 'intermediate':
        return <i className="fa-solid fa-chess-knight"></i>;
      case 'advanced':
        return <i className="fa-solid fa-chess-rook"></i>;
      case 'master':
        return <i className="fa-solid fa-chess-queen"></i>;
      default:
        return <i className="fa-solid fa-chess-board"></i>; // Default icon
    }
  };

  // Constant weightings for likes and dislikes, used to update game score
  const LIKE_WEIGHT = 4;
  const DISLIKE_WEIGHT = -2;

  const handleLikeClick = async (gameId, gameMetadata) => {
    try {
      const userId = props?.user?.credentials?.userId;
      if (!userId) return; // Exit if no authenticated user

      const gameRef = doc(firestore, "games", gameId);
      const creatorHandle = gameMetadata?.creatorHandle;

      // If already liked, remove the like
      if (gameMetadata?.likes?.includes(userId)) {
        await updateDoc(gameRef, {
          likes: arrayRemove(userId),
          score: increment(-LIKE_WEIGHT)
        });
        setIsLiked(false);

        // Delete the like notification when unliking
        await deleteLikeNotification();
      } else {
        // Add like and remove dislike if exists
        await updateDoc(gameRef, {
          likes: arrayUnion(userId),
          score: increment(LIKE_WEIGHT)
        });
        setIsLiked(true);

        // Create notification for the post creator when liking
        if (creatorHandle) {
          await createLikeNotification(creatorHandle);
        }

        // Remove dislike if exists
        if (gameMetadata?.dislikes?.includes(userId)) {
          await updateDoc(gameRef, {
            dislikes: arrayRemove(userId),
            score: increment(-DISLIKE_WEIGHT)
          });
          setIsDisliked(false);
        }
      }

      // Update local gameMetadata to reflect changes without refetching
      setGameMetadata(prevMetadata => {
        const updatedLikes = isLiked
          ? (prevMetadata.likes || []).filter(id => id !== userId)
          : [...(prevMetadata.likes || []), userId];

        const updatedDislikes = isLiked
          ? prevMetadata.dislikes || []
          : (prevMetadata.dislikes || []).filter(id => id !== userId);

        return {
          ...prevMetadata,
          likes: updatedLikes,
          dislikes: updatedDislikes
        };
      });

    } catch (error) {
      console.error('Error liking game:', error);
    }

  };



  const handleDislikeClick = async (gameId, gameMetadata) => {
    try {
      const userId = props?.user?.credentials?.userId;
      if (!userId) return; // Exit if no authenticated user

      const gameRef = doc(firestore, "games", gameId);

      // If already disliked, remove the dislike
      if (gameMetadata?.dislikes?.includes(userId)) {
        await updateDoc(gameRef, {
          dislikes: arrayRemove(userId),
          score: increment(-DISLIKE_WEIGHT)
        });
        setIsDisliked(false);
      } else {
        // Add dislike and remove like if exists
        await updateDoc(gameRef, {
          dislikes: arrayUnion(userId),
          score: increment(DISLIKE_WEIGHT)
        });
        setIsDisliked(true);

        // Remove like if exists
        if (gameMetadata?.likes?.includes(userId)) {
          await updateDoc(gameRef, {
            likes: arrayRemove(userId),
            score: increment(-LIKE_WEIGHT)
          });
          setIsLiked(false);

          // Delete the like notification when disliking a post that was liked
          await deleteLikeNotification();
        }
      }

      // Update local gameMetadata to reflect changes without refetching
      setGameMetadata(prevMetadata => {
        const updatedDislikes = isDisliked
          ? (prevMetadata.dislikes || []).filter(id => id !== userId)
          : [...(prevMetadata.dislikes || []), userId];

        const updatedLikes = isDisliked
          ? prevMetadata.likes || []
          : (prevMetadata.likes || []).filter(id => id !== userId);

        return {
          ...prevMetadata,
          likes: updatedLikes,
          dislikes: updatedDislikes
        };
      });

    } catch (error) {
      console.error('Error disliking game:', error);
    }
  };

  const handleCommentLike = async (commentIndex, gameId) => {
    try {
      const docRef = doc(firestore, "games", gameId.toString());
      const userId = props?.user?.credentials?.userId;

      // First get the full document
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const gameData = docSnap.data();
        const commentsArray = gameData.comments || [];

        // Make sure the comment exists at the specified index
        if (commentIndex >= 0 && commentIndex < commentsArray.length) {
          // Create a deep copy of the comments array
          const updatedComments = JSON.parse(JSON.stringify(commentsArray));
          const commentToUpdate = updatedComments[commentIndex];
          const commentId = commentToUpdate.id;
          
          // Initialize likes array if it doesn't exist
          if (!Array.isArray(commentToUpdate.likes)) {
            commentToUpdate.likes = [];
          }
          
          // Toggle like status - add if not present, remove if present
          const userLikeIndex = commentToUpdate.likes.indexOf(userId);
          if (userLikeIndex === -1) {
            // User hasn't liked, so add like
            commentToUpdate.likes.push(userId);
          } else {
            // User already liked, so remove like
            commentToUpdate.likes.splice(userLikeIndex, 1);
          }
          
          // Update the entire comments array in Firestore
          await updateDoc(docRef, {
            comments: updatedComments
          });
          
          // Update local state to reflect changes immediately
          setGameMetadata(prevMetadata => {
            const updatedLocalComments = [...(prevMetadata.comments || [])];
            if (updatedLocalComments[commentIndex]) {
              // Keep all existing fields, just update the likes array
              updatedLocalComments[commentIndex] = {
                ...updatedLocalComments[commentIndex],
                likes: [...commentToUpdate.likes] // Use the updated likes array
              };
            }
            return {
              ...prevMetadata,
              comments: updatedLocalComments
            };
          });
          
          // Update the likedComments Set for immediate UI feedback - use comment ID instead of index
          setLikedComments(prev => {
            const newSet = new Set(prev);
            if (userLikeIndex === -1) {
              // User just liked the comment
              newSet.add(commentId);
            } else {
              // User just unliked the comment
              newSet.delete(commentId);
            }
            return newSet;
          });
        } else {
          console.error("Comment index out of bounds");
        }
      } else {
        console.error("Game document not found");
      }
    } catch (error) {
      console.error('Error updating comment like:', error);
    }
  };

  const handleReportClick = (comment) => {

    setReportingComment(comment);
    setIsReportModalOpen(true);
  };

  const handleOpenReportModal = () => {
    setIsReportModalOpen(true);
  };

  // Function to check if we're in a puzzle filter context
  const isInPuzzleFilter = () => {
    return query.get('tag') === 'Puzzle' || tag === 'Puzzle';
  };

  // Simple function to redirect to portal with puzzle filter
  const redirectToPortalWithPuzzleFilter = () => {
    // Use history.push with state to set the Puzzle tag in Portal
    // Pass both versions - uppercase for tab highlighting and proper case for filtering
    history.push('/portal', { 
      activeTag: 'PUZZLE', 
      filterTag: 'Puzzle'
    });
  };

  // Helper: force close social tab if previewing someone else's comment (not building a new one)
  const forceCloseSocialTabIfPreviewing = () => {
    if (commentPreviewMoves?.parentMove) {
      setCurrentMoveIdx(commentPreviewMoves.parentMove);
      setCommentPreviewMoves(false);
      setExpandedTab('gameInfo');
    }
  };

  // Helper function to compare FEN positions (ignoring move counters)
  const fenPositionsEqual = (fen1, fen2) => {
    if (!fen1 || !fen2) return false;
    
    // Split FEN strings and compare only the first 4 parts (position, turn, castling, en passant)
    // Ignore halfmove and fullmove counters which can differ
    const fen1Parts = fen1.split(' ').slice(0, 4).join(' ');
    const fen2Parts = fen2.split(' ').slice(0, 4).join(' ');
    
    return fen1Parts === fen2Parts;
  };

  // Function to check for cached analysis by move index or FEN
  const checkForCachedAnalysis = (moveIndex, targetFEN = null) => {
    try {
      // console.log(`🔍 checkForCachedAnalysis called for move ${moveIndex} with targetFEN: ${targetFEN}`);
      
      // Handle start position analysis (index -1)
      if (moveIndex === '-1' || moveIndex === -1) {
        // console.log('🔍 checkForCachedAnalysis: Checking start position analysis');
        
        // For start position, check if we have analysis in the rootFEN or starting position
        // This would need to be implemented when we add start position analysis support
        
        return false;
      }

      // ENHANCED: Handle starting position variations
      if (typeof moveIndex === 'string' && moveIndex.startsWith('-1|')) {
        // console.log(`🔍 checkForCachedAnalysis: Checking starting position variation ${moveIndex}`);
        
        // Parse the starting position variation move ID
        const match = moveIndex.match(/^-1\|(\d+):(\d+)$/);
        if (!match) {
          console.warn(`❌ Invalid starting position variation ID: ${moveIndex}`);
          return false;
        }
        
        const varIdx = parseInt(match[1], 10);
        const moveIdx = parseInt(match[2], 10);
        
        // Check if we have the variation in state
        if (!state.startPosition || !state.startPosition.variations || 
            varIdx >= state.startPosition.variations.length ||
            !state.startPosition.variations[varIdx] ||
            moveIdx >= state.startPosition.variations[varIdx].length) {
          console.warn(`❌ Starting position variation not found: ${moveIndex}`);
          return false;
        }
        
        const variationMove = state.startPosition.variations[varIdx][moveIdx];
        if (!variationMove || !variationMove.analysis) {
          // console.log(`📋 No cached analysis for starting position variation: ${moveIndex}`);
          return false;
        }
        
        // Validate FEN if provided
        if (targetFEN && variationMove.fen && !fenPositionsEqual(variationMove.fen, targetFEN)) {
          console.warn(`❌ FEN mismatch for starting position variation ${moveIndex}: ${variationMove.fen} vs ${targetFEN}`);
          return false;
        }
        
        // console.log(`✅ Found cached analysis for starting position variation: ${moveIndex}`);
        
        // Format the analysis data
        const formattedAnalysis = {
          ...variationMove.analysis,
          positionFEN: variationMove.fen || targetFEN,
          moveId: moveIndex
        };
        
        // Store in window for compatibility
        window.currentAnalysisCache = formattedAnalysis;
        
        return formattedAnalysis;
      }

      // Handle regular move analysis
      if (!moves || moveIndex < 0 || moveIndex >= moves.length) {
        // console.log(`❌ Invalid move index: ${moveIndex}`);
        return false;
      }

      const move = moves[moveIndex];
      if (!move) {
        
        return false;
      }

      // Check if move has analysis data
      if (move && move.analysis) {
        // If we have a targetFEN, validate that the move's FEN matches
        if (targetFEN && move.fen && !fenPositionsEqual(move.fen, targetFEN)) {
          
          return false;
        }

        // Format the analysis data to ensure it has the right structure
        const formattedAnalysis = move.analysis.pvs ? {
          ...move.analysis,
          // If we have pvs but no lines, create lines from pvs for compatibility
          lines: move.analysis.pvs.map((pv, index) => ({
            move: pv.bestMove || pv.move || '',
            score: move.analysis.scores?.[index] || pv.evaluation || '0.0',
            pv: pv.moves || []
          })),
          positionFEN: move.fen,
          moveId: moveIndex
        } : {
          ...move.analysis,
          positionFEN: move.fen,
          moveId: moveIndex
        };
        
        
        
        // Update global window objects for Stockfish.js to access
        window.currentAnalysisCache = formattedAnalysis;
        window.moveClassificationData = {
          classification: move.analysis.classification || null,
          positionFEN: move.fen || null,
          timestamp: Date.now()
        };

        // Set state variables like 2AddGame.js
        setHasAnalysisCache(true);
        setCurrentAnalysisCache(formattedAnalysis);

        return formattedAnalysis;
      } else {
        
        
        // Clear state variables like 2AddGame.js
        setHasAnalysisCache(false);
        setCurrentAnalysisCache(null);
        
        return false;
      }
    } catch (error) {
      console.error('Error checking for cached analysis:', error);
      return false;
    }
  };

  // Helper function to check if we're in a comment move and handle tab closing
  const handleSocialTabClose = () => {
    // Check if we're currently in a comment move (variation)
    const isInCommentMove = currentMoveIdx && currentMoveIdx.toString().includes('|');
    
    if (isInCommentMove) {
      // Extract parent move index from variation path (e.g., "0|0:1" -> "0")
      const parts = currentMoveIdx.toString().split('|');
      const parentMoveIndex = parts[0];
      
      // Return to parent move first
      setCurrentMoveIdx(parseInt(parentMoveIndex, 10));
      
      // Small delay to ensure move navigation completes before closing tab
      setTimeout(() => {
        handleTabSwitch('gameInfo'); // Use protected tab switching
      }, 100);
    } else {
      // Not in a comment move, close tab immediately
      handleTabSwitch('gameInfo'); // Use protected tab switching
    }
    
    // Clear any preview state
    setCommentPreviewMoves(false);
  };

  // NEW: Protected tab switching function
  const handleTabSwitch = (targetTab) => {
    // If trying to switch to social tab while variation is active, show confirmation
    if (targetTab === 'social' && isVariationActive) {
      setPendingTabSwitch(targetTab);
      setPendingAction('tabSwitch');
      setShowVariationDeleteConfirm(true);
      return;
    }
    
    // Otherwise, allow the switch
    setExpandedTab(targetTab);
  };

  // Helper function to navigate back to parent move with correct FEN
  const navigateToParentMove = (currentVariationMoveIdx) => {
    
    
    if (!currentVariationMoveIdx.includes('|')) {
      
      return;
    }
    
    // Parse the variation path to get the parent move index
    const parts = currentVariationMoveIdx.split('|');
    const parentMoveIdx = parts[0];
    
    
    
    // Calculate the FEN for the parent move position
    let parentFEN;
    try {
      if (parentMoveIdx === '-1') {
        // Parent is the starting position
        parentFEN = rootFEN;
      } else {
        // Calculate FEN by playing moves up to AND INCLUDING the parent move
        // This is the position AFTER the parent move has been played
        const tempGame = new Chess(rootFEN);
        const parentMoveInt = parseInt(parentMoveIdx);
        
        for (let i = 0; i <= parentMoveInt && i < moves.length; i++) {
          if (moves[i] && moves[i].notation) {
            
            tempGame.move(moves[i].notation);
          }
        }
        
        parentFEN = tempGame.fen();
      }
      
      
      
      // Navigate directly using dispatch to avoid goToContextMove conflicts
      dispatch({ type: 'GOTO_MOVE', payload: parentMoveIdx });
      setContextFEN(parentFEN);
      
      
      
    } catch (error) {
      console.error('[navigateToParentMove] Error calculating parent FEN:', error);
      // Fallback to just setting the move index
      dispatch({ type: 'GOTO_MOVE', payload: parentMoveIdx });
    }
  };

  return (
    <div className="app-container">
      {/* Show login prompt only when explicitly triggered */}
      {showLoginPrompt && (
        <LoginPrompt />
      )}
      
      {showNewGameModal && (
        <NewGameAccessModal
          onClose={() => setShowNewGameModal(false)}
          gameId={props?.match?.params?.gameId}
        />
      )}

      {/* Add GameSettingsPopup */}
      {showGameSettings && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 99,
          pointerEvents: 'none'
        }}>
          <div style={{
            position: 'relative',
            width: `${boardSize}px`,
            height: `${boardSize}px`,
            margin: '0 auto',
            pointerEvents: 'auto'
          }}>
            <GameSettingsPopup
              isOpen={showGameSettings}
              onClose={() => {
                setShowGameSettings(false);
                setManualSettingsOpen(false);
              }}
              gameMetadata={gameMetadata}
              boardSize={boardSize}
              puzzleState={puzzleState}
              setPuzzleState={setPuzzleState}
              gameType={gameHasPuzzleTag ? 'puzzle' : gameHasChallengeTag ? 'challenge' : 'default'}
              manualOpen={manualSettingsOpen}
              startingColor={game ? game.turn() : 'w'}
              onSaveForLater={() => setShowBookmarkModal(true)}
              onNextPuzzle={handleNextGameClick}
              isInPuzzleFilter={isInPuzzleFilter()}
              redirectToPortal={redirectToPortalWithPuzzleFilter}
            />
          </div>
        </div>
      )}

      {showShareModal && (
        <ShareGameModal
          onClose={() => setShowShareModal(false)}
          gameLink={`${window.location.origin}/games/${gameId}`}
        />
      )}
      {openModalType === 'ReportComment' && (
        <ReportCommentModal
          onClose={() => setOpenModalType('')}
          commentIndex={tempCommentIndex}
          gameId={tempGameId}
        />
      )}


      {showBookmarkModal && (
        <BookmarkModal
          onClose={() => setShowBookmarkModal(false)}
          onSave={handleBookmarkSave}
          gameId={gameId}
        />
      )}

      {/* Rate Limit Modal */}
      <RateLimitModal
        isVisible={showRateLimitModal}
        onClose={() => setShowRateLimitModal(false)}
      />
















      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'start',
          height: '100vh',
          overflow: 'hidden',
          width: 'auto',
          padding: 0,
        }}><ChessAnalysisWrapper>

          <div style={{
            width: '100%',
            borderRadius: '10px',
            padding: '0px',
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '20px',
            }}>
              <div style={{
                display: 'flex',
                gap: '10px',
              }}>
                <div style={{
                  height: `${boardSize + 189}px`,
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                }}>
                  {showStockfishEval && (
                    <StockfishEval
                      evaluation={currentEvaluation}
                      orientation={orientation}
                      height="100%"
                      width={30}
                      boardSize={boardSize}
                      isAnalyzing={stockfishIsAnalyzing}
                    />
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', }}>
                  <div ref={containerRef}
                    className="main-top-section"
                    style={{
                      width: boardSize + 10,
                      height: boardSize + 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'relative',
                      marginBottom: '10px',
                      transition: 'width 0.2s, height 0.2s',
                      padding: 0,
                      borderRadius: '5px',
                    }}>
                    <div style={{
                      width: boardSize,
                      height: boardSize,
                      boxSizing: 'border-box',
                      boxShadow: '0 0 20px 5px rgba(0, 0, 0, 0.7)',
                      borderRadius: '5px',
                    }}>
                      {ctx === 'newGame' && <NewGameAccessModal open={true} />}
                      {
                        (fetchingGame ? (
                          <div>Loading...</div>
                        ) : (
                          <>
                            {/* <Board
                              game={game}
                              orientation={orientation}
                              moves={moves}
                              // setMoves={setMoves}
                              currentMove={currentMoveIdx}
                              setCurrentMove={setCurrentMoveIdx}
                              isCommenting={!gameHasPuzzleTag || puzzleState === 'completed'} // Enable commenting for completed puzzles
                              boardSize={boardSize}
                              boardTheme={localStorage.getItem('boardTheme') || 'blue'}
                              // isDraggingDisabled={!isAuthenticatedUser} // Disable dragging for non-authenticated users
                              onValidateMove={gameHasPuzzleTag && puzzleState !== 'completed' ? handlePuzzleMoveValidation : null} // Only validate moves for active puzzles
                              shouldAllowVariation={shouldAllowVariation} // Add function to control variation recording
                              isPuzzle={gameHasPuzzleTag && puzzleState !== 'completed'} // Only flag as puzzle when not completed
                            /> */}
                            
                            {/* BoardThree Component */}
                            <div style={{ }}>
                              <BoardThree 
                                ref={boardRef}
                                boardSize={boardSize} 
                                boardTheme={localStorage.getItem('boardTheme') || 'blue'}
                                showBoardNotation={localStorage.getItem('showCoordinates') === null ? true : localStorage.getItem('showCoordinates') === 'true'}
                                // Add puzzle-related props
                                isPuzzle={gameHasPuzzleTag && puzzleState !== 'completed'}
                                onValidateMove={gameHasPuzzleTag && puzzleState !== 'completed' ? handlePuzzleMoveValidation : null}
                                shouldAllowVariation={shouldAllowVariation}
                                puzzleState={puzzleState}
                                gameHasPuzzleTag={gameHasPuzzleTag}
                                // Add solution data and completion callbacks
                                gameMetadata={gameMetadata}
                                revealedMoves={revealedMoves}
                                setRevealedMoves={setRevealedMoves}
                                setLastRevealedMove={setLastRevealedMove}
                                setPuzzleState={setPuzzleState}
                                setShowGameSettings={setShowGameSettings}
                                // Add current move tracking
                                currentMoveIdx={currentMoveIdx}
                                setCurrentMoveIdx={setCurrentMoveIdx}
                                // Add commenting mode
                                isCommenting={!gameHasPuzzleTag || puzzleState === 'completed'} // Enable commenting for completed puzzles
                                // Add view mode (read-only) 
                                isViewMode={true}
                                // Don't show collapsed icons on board in ViewGame
                                showCollapsedIcons={false}
                                // Add player data from gameMetadata
                                initialPOVPlayer={gameMetadata?.povPlayer}
                                initialOppositePlayer={gameMetadata?.oppositePlayer}
                              />
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                  <div style={{
                    width: boardSize + 10,

                    position: 'relative', // Add position relative for stacking
                    height: '150px', // Set fixed height to match GameTitle
                  }}>
                    {/* Always render Stockfish but control visibility */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: showStockfish ? 2 : 1,
                      visibility: showStockfish ? 'visible' : 'hidden',
                    }}>
                      <StockfishAnalysisPanel 
                        fen={state.currentFEN}
                        analysisData={stockfishAnalysis}
                        isAnalyzing={stockfishIsAnalyzing}
                        // analysisData={currentAnalysisCache}
                        // isAnalyzing={!hasAnalysisCache && showStockfish}
                        showStockfish={showStockfish}
                        onMoveSelect={(moveData) => {
                          
                          
                          
                          // Dispatch the move to the board using window events
                          if (moveData.bestMoveLAN || moveData.lan) {
                            const moveToApply = moveData.bestMoveLAN || moveData.lan;
                            
                            
                            window.dispatchEvent(new CustomEvent('stockfish-move-selected', {
                              detail: {
                                move: moveToApply,
                                san: moveData.bestMoveSAN || moveData.san,
                                source: 'stockfish-analysis-panel'
                              }
                            }));
                          }
                        }}
                      />
                    </div>

                    {/* Always render GameTitle but control visibility */}
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: showStockfish ? 1 : 2,
                      visibility: showStockfish ? 'hidden' : 'visible',
                    }}>
                      <GameTitle 
                        gameMetadata={gameMetadata} 
                        onPlayerInfoClick={handlePlayerInfoClick}
                        playerPanelsExpanded={playerPanelsExpanded}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ChessAnalysisWrapper>
      </div>



















      {/*<div style={{ marginTop: '', padding: '15px' }}>
          <Stockfish />
        </div>*/}

      <div
        style={{ margin: '10px', width: '575px' }}
      >
        <div style={{

          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
          {/* Tab container with animation */}
          <div className="tabs-container" style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',

            position: 'relative',
            transition: 'all 0.3s ease-in-out',
            overflowY: 'hidden',
          }}>
            {/* Game Info Tab - Always at top */}
            <div
              className={`game-info-tab ${expandedTab === 'gameInfo' ? 'expanded' : 'collapsed'}`}
              style={{
                borderRadius: '5px',
                border: '5px solid #121212',
                padding: '15px',
                paddingBottom: '10px',
                background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                height: expandedTab === 'gameInfo'
                  ? `calc(${boardSize}px - 70px)`
                  : `calc(100vh - (${boardSize}px - 180px) - 110px)`,
                overflow: 'hidden',
                marginBottom: '10px',
              }}
            >
              {(expandedTab === 'gameInfo' || (expandedTab === 'social' && gameHasPuzzleTag)) && (
                <div style={{
                  fontSize: '40px',
                  fontWeight: 'bold',
                  marginBottom: '15px',
                  textAlign: 'center',
                  borderBottom: '2px solid gold',
                  paddingBottom: '10px',
                  color: 'gold',
                  position: 'relative',
                }}>

                  {/* Add chess-board icon */}
                  <i
                    ref={boardIconRef}
                    className="fa-solid fa-chess-board"
                    style={{
                      position: 'absolute',
                      left: '20px',
                      top: '50%',
                      transform: 'translateY(-65%)',
                      fontSize: '36px',
                      cursor: 'pointer',
                      color: showControlPanel ? '#00f2ea' : '#57b047',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowControlPanel(!showControlPanel);
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = '#00f2ea';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = showControlPanel ? '#00f2ea' : '#57b047';
                    }}
                  />

                  {/* Add gear icon - only show for puzzle games */}
                  {gameHasPuzzleTag && (
                    <i
                      className="fa-solid fa-gear"
                      style={{
                        position: 'absolute',
                        right: '20px',
                        top: '50%',
                        transform: 'translateY(-65%)',
                        fontSize: '36px',
                        cursor: 'pointer',
                        color: 'rgba(255, 0, 80, 0.8)',
                        transition: 'all 0.3s ease'
                      }}
                      onClick={() => {
                        setManualSettingsOpen(true);
                        setShowGameSettings(true);
                      }}
                      onMouseOver={(e) => {
                        e.target.style.color = '#ff0050';
                        // e.target.style.transform = 'translateY(-65%) rotate(90deg)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.color = 'rgba(255, 0, 80, 0.8)';
                        // e.target.style.transform = 'translateY(-65%) rotate(0deg)';
                      }}
                    />
                  )}

                  {/* Control panel for chess options */}
                  {showControlPanel && (
                    <div
                      ref={controlPanelRef}
                      style={{
                        position: 'absolute',
                        bottom: '5px',
                        left: '70px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        gap: '15px',
                        backgroundColor: 'rgba(0, 0, 0, 1)',

                        borderRadius: '8px',
                        border: '2px solid gold',
                        zIndex: 100,
                        boxShadow: '0 0 15px rgba(0, 0, 0, 0.8)',
                        alignItems: 'center',
                        height: '70px',
                        width: 'calc(100% - 150px)',
                      }}
                    >
                      {/* Brilliancies toggle button */}
                      {/* <div
                        className="engine-panel-btn"
                        style={{
                          position: 'relative',
                          display: 'inline-block'
                        }}
                      >
                        <div
                          onClick={handleStockfishIconsToggle}
                          style={{
                            cursor: 'pointer',
                            padding: '5px',
                            borderRadius: '50%',
                            boxShadow: showStockfishIcons
                              ? '0 0 8px rgba(76, 175, 80, 0.8)'
                              : '0 0 5px rgba(255, 215, 0, 0.3)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: showStockfishIcons ? 'rgba(76, 175, 80, 0.1)' : 'transparent',
                            transition: 'all 0.3s ease',
                            height: '40px',
                            width: '40px',
                          }}
                        >
                          {showStockfishIcons ?
                            <img src={BrilliantGray} alt="Brilliant Icon" style={{ width: '30px', height: '30px' }} /> :
                            <img src={BrilliantBlue} alt="Brilliant Icon" style={{ width: '30px', height: '30px' }} />}
                        </div>
                        <div className="engine-panel-tooltip">
                          Move Classifications
                        </div>
                      </div> */}
                      {/* Stockfish Engine */}
                      <div
                        className="engine-panel-btn"
                        style={{
                          position: 'relative',
                          display: 'inline-block'
                        }}
                      >
                        <i
                          className="fa-solid fa-robot"
                          style={{
                            cursor: 'pointer',
                            // color: isPremiumUser ? (showStockfish ? 'rgb(76, 175, 80)' : '#f44336') : '#888',
                            color: showStockfish ? 'rgb(76, 175, 80)' : '#f44336',
                            padding: '5px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // boxShadow: isPremiumUser
                            //   ? (showStockfish ? '0 0 8px rgba(76, 175, 80, 0.8)' : '0 0 5px rgba(255, 215, 0, 0.3)')
                            //   : '0 0 5px rgba(136, 136, 136, 0.3)',
                            // background: isPremiumUser && showStockfish ? 'rgba(76, 175, 80, 0.1)' : 'transparent',
                            boxShadow: showStockfish ? '0 0 8px rgba(76, 175, 80, 0.8)' : '0 0 5px rgba(255, 215, 0, 0.3)',
                            background: showStockfish ? 'rgba(76, 175, 80, 0.1)' : 'transparent',
                            
                            fontSize: '24px',
                            transition: 'all 0.3s ease',
                            height: '40px',
                            width: '40px',
                          }}
                          onClick={handleStockfishToggle}
                        ></i>
                        <div className="engine-panel-tooltip">
                          {isPremiumUser ? "Stockfish Engine" : "Stockfish Engine"}
                        </div>
                      </div>

                      {/* Stockfish Eval Bar */}
                      <div
                        className="engine-panel-btn"
                        style={{
                          position: 'relative',
                          display: 'inline-block'
                        }}
                      >
                        <i
                          className="fa-solid fa-chart-simple"
                          style={{
                            cursor: 'pointer',
                            color: showStockfishEval ? 'rgb(76, 175, 80)' : '#f44336',
                            padding: '5px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: showStockfishEval ? '0 0 8px rgba(76, 175, 80, 0.8)' : '0 0 5px rgba(255, 215, 0, 0.3)',
                            background: showStockfishEval ? 'rgba(76, 175, 80, 0.1)' : 'transparent',
                            fontSize: '24px',
                            transition: 'all 0.3s ease',
                            height: '40px', // Fixed height to match the Brilliant icon
                            width: '40px',  // Fixed width to match the Brilliant icon
                          }}
                          onClick={handleStockfishEvalToggle}
                        ></i>
                        <div className="engine-panel-tooltip">
                          Evaluation Bar
                        </div>
                      </div>



                      {/* Arrows toggle button */}
                      <div
                        className="engine-panel-btn"
                        style={{
                          position: 'relative',
                          display: 'inline-block'
                        }}
                      >
                        <i
                          className="fa-solid fa-arrow-up"
                          style={{
                            cursor: 'pointer',
                            color: showArrows ? 'rgb(76, 175, 80)' : '#f44336',
                            padding: '5px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: showArrows ? '0 0 8px rgba(76, 175, 80, 0.8)' : '0 0 5px rgba(255, 215, 0, 0.3)',
                            background: showArrows ? 'rgba(76, 175, 80, 0.1)' : 'transparent',
                            fontSize: '24px',
                            transition: 'all 0.3s ease',
                            height: '40px',
                            width: '40px',
                          }}
                          onClick={handleArrowsToggle}
                        ></i>
                        <div className="engine-panel-tooltip">
                          Author's Arrows
                        </div>
                      </div>


                    </div>

                  )}
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                  {/* Replace the game type text with opening name when available */}
                  {moves && moves[currentMoveIdx] && moves[currentMoveIdx].opening && moves[currentMoveIdx].opening.name ? (
                    <div 
                      className='opening-info' 
                      style={{
                        fontSize: '20px', 
                        fontWeight: 'bold', 
                        textAlign: 'center', 
                        color: 'gold',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        transition: 'color 0.2s ease'
                      }}
                      title="Openings provided by LiChess"
                      onClick={() => window.open('https://lichess.org', '_blank')}
                      onMouseEnter={(e) => e.target.style.color = '#ffdd44'}
                      onMouseLeave={(e) => e.target.style.color = 'gold'}
                    >
                      {moves[currentMoveIdx].opening.name}
                    </div>
                  ) : (
                    gameHasPuzzleTag ? 'Solve Puzzle' : gameHasChallengeTag ? 'Try To Win' : 'Main Line'
                  )}
                 
                  </div>
                </div>)}

              <div style={{
                position: 'relative',
                overflow: 'auto',
                width: '540px',
                maxWidth: '540px',
                scrollbarWidth: 'thin',
                scrollbarColor: 'gold transparent',
              }}>
                {/* Add puzzle progress indicator */}
                {/* Removing this since we now show it in the annotations area */}
                {/* {gameHasPuzzleTag && puzzleState !== 'completed' && moves.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    background: 'rgba(0, 0, 0, 0.7)',
                    color: 'gold',
                    padding: '5px',
                    textAlign: 'center',
                    fontSize: '14px',
                    zIndex: 2,
                    borderBottom: '1px solid #333'
                  }}>
                    <div>Puzzle Progress: {revealedMoves.length} / {moves.length} moves</div>
                    <div style={{ fontSize: '12px', color: '#aaa', marginTop: '2px' }}>
                      {revealedMoves.length === 0 
                        ? "Make the first move to begin..." 
                        : "Keep going. You are getting closer."}
                    </div>
                  </div>
                )} */}

                {/* Conditionally render moves based on puzzle state */}
                {gameHasPuzzleTag && puzzleState !== 'completed' ? (
                  <PuzzleMoves
                    moves={moves}
                    currentMove={currentMoveIdx}
                    setCurrentMove={setCurrentMoveIdx}
                    starredMoves={starredMoves}
                    currentTurn={game?.turn()}
                    className={""}
                    startingTurn={boardStartingTurn}

                  />
                ) : (
                  // <Moves
                  //   moves={moves}
                  //   currentMove={currentMoveIdx}
                  //   setCurrentMove={setCurrentMoveIdx}
                  //   starredMoves={starredMoves}
                  //   currentTurn={game?.turn()}
                  //   className={""}
                  //   handleVariationNavigation={handleVariationNavigation}
                  //   gameResultInfo={gameResultInfo}
                  //   onVariationVisibilityChange={setHasVisibleVariations}
                  //   startingTurn={boardStartingTurn}
                  // />

                  <div style={{
                    overflowY: 'auto',
                    maxHeight: '480px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: 'gold transparent'
                  }}>
                    <MovesThree
                      // moves={moves}
                      // currentMove={currentMoveIdx}
                      // setCurrentMove={setCurrentMoveIdx}
                      // starredMoves={starredMoves}
                      // currentTurn={game?.turn()}
                      // startingTurn={boardStartingTurn}
                      isViewGame={true}
                      starredMoves={starredMoves}
                      startingTurn={boardStartingTurn}
                      comments={gameMetadata?.comments || []} // Add the comments array for caption matching
                    />
                  </div>
                )}
                
                {/* Conditionally show either puzzle progress counter or annotations */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>

                  {/* Render 'TRUE' in a div when commentPreview=True */}
                  {commentPreviewMoves?.parentMove && commentPreviewMoves?.variationMove && (() => {
                    // Find the comment associated with the preview
                    const relevantComment = gameMetadata?.comments?.find(comment => comment.id === commentPreviewMoves.commentId);
                    const commentUsername = relevantComment?.username;


                    const isParentOfPreviewActiveOnBoard = currentMoveIdx === commentPreviewMoves.parentMove;
                    const effectiveCurrentMoveForPreview = isParentOfPreviewActiveOnBoard ? commentPreviewMoves.variationMove : currentMoveIdx;
                    const effectiveStartingTurnForPreview = isParentOfPreviewActiveOnBoard 
                                                              ? calculateVariationStartingTurn(moves, commentPreviewMoves.parentMove, boardStartingTurn) 
                                                              : boardStartingTurn;

                    return (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', justifyContent: 'center', gap: '10px', width: '490px', alignItems: 'center', background: '#3066be25', height: '65px', borderRadius: '8px', borderLeft: '4px solid #3066be', borderRight: '4px solid #3066be', position: 'relative', marginLeft: '20px' }}> {/* Changed gridTemplateColumns */}
                        <div
                          onClick={() => {
                            // When closing the comment preview, also return to the parent move
                            if (commentPreviewMoves?.parentMove) {
                              setCurrentMoveIdx(commentPreviewMoves.parentMove);
                            }
                            setCommentPreviewMoves(false);
                          }}
                          style={{ cursor: 'pointer', position: 'absolute', top: '50%', left: '-30px', transform: 'translateY(-50%)', zIndex: '1000', }}>
                          <i className="fa-solid fa-circle-xmark" style={{ fontSize: '18px', color: '#ff3366', }}></i>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                          {commentUsername && (
                            <div style={{ fontWeight: 'bold' }}>
                              {renderUserWithBadge(commentUsername, commentUserPremiumData[commentUsername])}
                            </div>
                          )}
                          {/* Render '(comment)' text */}
                          <div style={{ fontSize: '0.8em', fontWeight: 'bold', color: '#3066be', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: '5px' }}
                          >
                            (comment)
                          </div>
                        </div>
                        {/* Render the Moves component */}
                        <div style={{ 
                          overflow: 'hidden', 
                          paddingRight: '10px',
                          overflowY: 'auto',
                          maxHeight: '60px',
                          scrollbarWidth: 'thin',
                          scrollbarColor: 'gold transparent'
                        }}> {/* Added overflow: hidden and paddingRight */}
                          <MovesThree
                            moves={moves}
                            currentMove={effectiveCurrentMoveForPreview} // MODIFIED
                            setCurrentMove={setCurrentMoveIdx}
                            starredMoves={[]}
                            type={"COMMENTS"} // Keep as COMMENTS to show full variation
                            userId={commentPreviewMoves.commentId} // Use the commentId from state
                            handleVariationNavigation={handleVariationNavigation}
                            gameResultInfo={gameResultInfo} // Add this line
                            isAnnotationPreview={true} // Add the new prop here
                            startingTurn={effectiveStartingTurnForPreview} // MODIFIED
                            height={60} // Fixed height for comment preview
                            isViewGame={true} // Enable variation captions and move content
                            comments={gameMetadata?.comments || []} // Pass the comments array for matching creator IDs
                          />
                        </div>
                      </div>
                    );
                  })()}
                </div>

                {currentMove?.content && !(gameHasPuzzleTag && puzzleState !== 'completed') && (
                  <div
                    style={{
                      height: hasVisibleVariations ? 'calc(100% - 185px)' : isVariationActive ? 'calc(100% - 200px)' : 'calc(100% - 147px)',
                      minHeight: '64px',
                      maxHeight: 'none',
                      marginTop: '30px',
                      overflow: 'auto',
                      scrollbarWidth: 'thin',
                      scrollbarColor: 'gold transparent',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '505px',
                  
                      padding: '0px 10px',
                      fontSize: '22px',
                      backgroundColor:
                        // Apply correct background color based on move color (white/black)
                        game?.history({ verbose: true })?.[0]?.color === 'w'
                          ? currentMove?.moveNum % 2 === 0
                            ? '#333333' // Black move (dark background)
                            : '#ffffff' // White move (light background)
                          : currentMove?.moveNum % 2 === 1
                            ? '#333333' // Black move (dark background) 
                            : '#ffffff', // White move (light background)
                      color:
                        // Apply correct text color based on background
                        game?.history({ verbose: true })?.[0]?.color === 'w'
                          ? currentMove?.moveNum % 2 === 0
                            ? '#f0f0f0' // White text on dark background
                            : '#222222' // Dark text on light background
                          : currentMove?.moveNum % 2 === 1
                            ? '#f0f0f0' // White text on dark background
                            : '#222222', // Dark text on light background
                      borderRadius: '5px',
                      border: 'none',
                      // Only add green border on bottom and right sides
                      borderBottom: '8px solid #58b047',
                      borderRight: '8px solid #58b047',
                      background: currentMove?.notation
                        ? (starredMoves.includes(currentMoveIdx)
                          ? 'linear-gradient(315deg, black, gold)'
                          : game?.history({ verbose: true })?.[0]?.color === 'w'
                            ? currentMove?.moveNum % 2 === 0
                              ? 'linear-gradient(to bottom, rgba(51, 51, 51, 0.3), rgba(34, 34, 34, 0.3))'
                              : 'linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(240, 240, 240, 0.3))' // Black move gradient
                            // White move gradient
                            : currentMove?.moveNum % 2 === 1
                              ? 'linear-gradient(to bottom, #333333, #222222)' // Black move gradient
                              : 'linear-gradient(to bottom, #ffffff, #f0f0f0)') // White move gradient
                        : '#58b047',
                      textAlign: 'center',
                      fontStyle: 'italic',
                    }}
                  ><div>{variationContent && (
                    <div style={{ fontSize: '22px', color: 'gold', fontStyle: 'italic' }}>
                      {variationContent}
                    </div>
                  )}
                                            {cleanProfanity(currentMove?.content)}
                    </div>
                  </div>
                )}


              </div>

              {/* Current move display - hidden when variation is active */}
              <div style={{
                display: isVariationActive ? 'none' : 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingBottom: expandedTab === 'gameInfo' ? '10px' : '0px',
              }} className="render-Creator-div">
                {/* <span
                  style={{
                    height: '64px',
                    minWidth: '140px',
                    width: 'fit-content',
                    padding: '0px 15px',
                    fontSize: '30px',
                    backgroundColor:
                      // Apply correct background color based on move color (white/black)
                      game?.history({ verbose: true })?.[0]?.color === 'w'
                        ? currentMove?.moveNum % 2 === 0
                          ? '#333333' // Black move (dark background)
                          : '#ffffff' // White move (light background)
                        : currentMove?.moveNum % 2 === 1
                          ? '#333333' // Black move (dark background) 
                          : '#ffffff', // White move (light background)
                    color:
                      // Apply correct text color based on background
                      game?.history({ verbose: true })?.[0]?.color === 'w'
                        ? currentMove?.moveNum % 2 === 0
                          ? '#f0f0f0' // White text on dark background
                          : '#222222' // Dark text on light background
                        : currentMove?.moveNum % 2 === 1
                          ? '#f0f0f0' // White text on dark background
                          : '#222222', // Dark text on light background
                    borderRadius: '5px',
                    marginRight: '10px',
                    border: 'none',
                    boxShadow: '0 0 12px rgba(88, 176, 71, 0.4)',
                    // Only add green border on bottom and right sides
                    borderBottom: '4px solid #58b047',
                    borderRight: '4px solid #58b047',
                    background: currentMove?.notation
                      ? (starredMoves.includes(currentMoveIdx)
                        ? 'linear-gradient(315deg, black, gold)'
                        : game?.history({ verbose: true })?.[0]?.color === 'w'
                          ? currentMove?.moveNum % 2 === 0
                            ? 'linear-gradient(to bottom, #333333, #222222)' // Black move gradient
                            : 'linear-gradient(to bottom, #ffffff, #f0f0f0)' // White move gradient
                          : currentMove?.moveNum % 2 === 1
                            ? 'linear-gradient(to bottom, #333333, #222222)' // Black move gradient
                            : 'linear-gradient(to bottom, #ffffff, #f0f0f0)') // White move gradient
                      : '#58b047',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    // animation: 'glow-current 2s infinite',
                  }}
                >
                  {currentMove?.notation ? (
                    <span>
                      {Math.floor((parseInt(currentMoveIdx) + 2) / 2)}.
                      {parseInt(currentMoveIdx) % 2 === 1 ? '.. ' : ' '}
                      {currentMove.notation}
                    </span>
                  ) : (
                    <span className='move-new-game'>START</span>
                  )}
                </span> */}
                {gameHasPuzzleTag && puzzleState !== 'completed' && (
                  <div
                    style={{
                      width: '511px',
                      height: '46px',
                      padding: '10px',
                      backgroundColor: '#222',
                      color: 'gold',
                      border: '2px solid #58b047',
                      borderRadius: '5px',
                      fontSize: '16px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      position: 'absolute',
                      bottom: '10px',
                    }}
                  >
                    <div>Puzzle Progress: {calculatePuzzleProgress(currentMoveIdx, gameMetadata?.moves).current} / {calculatePuzzleProgress(currentMoveIdx, gameMetadata?.moves).total} moves</div>
                    {/* <div style={{ fontSize: '14px', color: '#aaa', marginTop: '2px' }}>
                      {currentMoveIdx === '-1'
                        ? "Make the first move to begin..."
                        : "Keep going..."}
                    </div> */}
                  </div>
                )}



              </div>

              {/* Game Controls - Always present for hotkeys, but hidden in social tab */}
              {(!gameHasPuzzleTag || puzzleState === 'completed') && !isVariationActive && (
                <div 
                  className="view-controls" 
                  style={{
                    visibility: expandedTab === 'social' ? 'hidden' : 'visible',
                    height: expandedTab === 'social' ? '0' : 'auto',
                    overflow: 'hidden',
                    position: 'absolute',
                    bottom: '20px',
                    
                  }}
                >
                  <div style={{  }}>
                    <ControlsThree undo={false} disableHotkeys={isCommentInputFocused} moveContext='DEFAULT' />
                  </div>
                </div>
              )}

              {/* Variation moves display - Show in Game Info tab when variation is active */}
              {isVariationActive && !gameHasPuzzleTag && expandedTab === 'gameInfo' && (
                <div style={{
                  border: '2px solid #3066be',
                  borderRadius: '5px',
                  marginBottom: '20px',
                  background: 'rgba(48, 102, 190, 0.1)'
                }}>
                  
                  
                  {/* Variation controls - Only show if there's an active variation and not a puzzle */}
                  {isVariationActive && !gameHasPuzzleTag && expandedTab === 'gameInfo' && (
                    <div className="variation-controls" style={{
                      display: 'flex',
                      flexDirection: 'column',


                      position: 'relative'
                    }}>
                      {/* Annotation text area for current variation when active */}

                      <div style={{
                        marginBottom: '0px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                        {/* Replace the broken textarea and buttons with the working AddComment component */}
                        {isVariationActive && variationToComment ? (
                          <AddComment
                            moves={moves}
                            currentMoveIdx={currentMoveIdx}
                            setCurrentMoveIdx={setCurrentMoveIdx}
                            userId={props?.user?.credentials?.userId}
                            gameId={gameId}
                            showRateLimitError={showRateLimitError}
                            handleAddComment={(comment) => {
                              // Store the current move before submitting to calculate parent later
                              const preSubmissionMoveIdx = currentMoveIdx;
                              
                              handleAddComment(comment).then(() => {
                                
                                // Navigate back to parent move before resetting state
                                if (preSubmissionMoveIdx.includes('|')) {
                                  navigateToParentMove(preSubmissionMoveIdx);
                                  
                                  // Save the parent move to return to when closing social tab
                                  const lines = getLines(preSubmissionMoveIdx);
                                  if (lines.length > 1) {
                                    const parentSegments = lines.slice(0, -1);
                                    const parentMoveIdx = parentSegments.length === 0 ? 
                                      '-1' : parentSegments.join('|');
                                    setCommentPreviewMoves({
                                      parentMove: parentMoveIdx
                                    });
                                  }
                                }
                                
                                // State reset will be handled by AddComment2's submitComment and onVariationCommented
                              }).catch((error) => {
                                console.error('Error in handleAddComment:', error);
                                // Reset state even if there's an error
                                setVariationToComment(null);
                                setIsVariationActive(false);
                              });
                            }}
                            updateContentForMove={updateContentForMove}
                            variationToComment={variationToComment}
                            onVariationCommented={() => {
                              // Reset variation state when AddComment2 requests it
                              setVariationToComment(null);
                              setIsVariationActive(false);
                            }}
                            // Pass the necessary functions and state for the icons
                            handleDeleteCurrentCommentLine={handleDeleteCurrentCommentLine}
                            handleUndoCommentMove={handleUndoCommentMove}
                            isVariationActive={isVariationActive}
                            isUserAuthenticated={isUserAuthenticated}
                            setShowLoginPrompt={setShowLoginPrompt}
                            onInputFocusChange={setIsCommentInputFocused}
                            // NEW: Add function to show delete confirmation popup
                            showDeleteConfirmation={() => {
                              setPendingAction('delete');
                              setShowVariationDeleteConfirm(true);
                            }}
                            key={`addComment-gameTab`} // Fixed key - removed moves dependency that caused remounting
                          />
                        ) : (
                          // Standard comment input for non-variation comments
                          <>  </>
                          // <div className="comment-input"
                          //   style={{
                          //     display: 'flex',
                          //     alignItems: 'center',
                          //     marginTop: '5px',
                          //     marginBottom: '5px',
                          //     width: '100%',
                          //   }}
                          // >
                          //   <input
                          //     type="text"
                          //     placeholder="Start typing a comment..."
                          // value={commentCaption}
                          //     onChange={(e) => setCommentCaption(e.target.value)}
                          //     onFocus={() => {
                          //       
                          //       setIsCommentInputFocused(true);
                          //     }}
                          //     onBlur={() => {
                          //       
                          //       setIsCommentInputFocused(false);
                          //     }}
                          // style={{
                          //       flex: '1',
                          //   height: '40px',
                          //       paddingLeft: '20px',
                          //       fontSize: '18px',
                          //   borderRadius: '5px',
                          //       background: 'transparent',
                          //       color: 'white',
                          //       border: '3px solid #58b047',
                          //       outline: 'none'
                          //     }}
                          //   />
                          //   <button
                          //     style={{
                          //       height: '48px',
                          //       minWidth: '95px',
                          //       backgroundColor: 'black',
                          //       color: '#58b047',
                          //       borderRadius: '5px',
                          //       border: '2px solid #58b047',
                          //       fontSize: '20px',
                          //       fontWeight: 'bold',
                          //       marginLeft: '5px',
                          //       cursor: 'pointer'
                          //     }}
                          //     onClick={() => {
                          //       // Check if user is authenticated
                          //       if (!isUserAuthenticated()) {
                          //         setShowLoginPrompt(true);
                          //         return;
                          //       }
                                
                          //       if (commentCaption.trim()) {
                          //         handleAddComment(commentCaption);
                          //         setCommentCaption('');
                          //       }
                          //     }}
                          //   >
                          //     SEND
                          //   </button>
                          // </div>
                        )}
                      </div>

                      {/* <div style={{
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'center',
                      }}>


                        <button
                          onClick={() => {
                            // Show confirmation dialog instead of deleting immediately
                            setPendingAction('delete');
                            setShowVariationDeleteConfirm(true);
                          }}
                          style={{
                            background: 'transparent',
                            color: '#ff3366',
                            border: '2px solid #ff3366',
                            borderRadius: '4px',
                            padding: '8px 14px',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold'
                          }}
                        >
                          <i className="fa-solid fa-trash" style={{ marginRight: '5px' }}></i>
                          Delete
                        </button>
                        <button
                          onClick={() => handleUndoCommentMove()}
                          style={{
                            background: 'transparent',
                            color: '#3066be',
                            border: '2px solid #3066be',
                            borderRadius: '4px',
                            padding: '8px 14px',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold'
                          }}
                        >
                          <i className="fa-solid fa-scissors" style={{ marginRight: '5px' }}></i>
                          Trim Line
                        </button>
                        <button
                          onClick={() => {
                            // Update moves to add this caption
                            updateContentForMove(commentCaption);

                            // Save the current variation for commenting
                            setVariationToComment(moves);
                            // Switch to social tab
                            setExpandedTab('social');

                            // Reset state after adding this caption
                            setCommentCaption("");
                          }}
                          style={{
                            // background: '#58b047',
                            // color: 'white',
                            // border: '1px solid white',
                            background: 'transparent',
                            color: '#58b047',
                            border: '2px solid #58b047',
                            borderRadius: '4px',
                            padding: '8px 14px',
                            cursor: 'pointer',
                            fontSize: '18px',
                            fontWeight: 'bold'
                          }}
                        >
                          <i className="fa-solid fa-comment" style={{ marginRight: '5px' }}></i>
                          Save For Commenting
                        </button>
                      </div> */}


                    </div>
                  )}
                </div>
              )}







              {/* Button to expand social tab - only when game info is expanded */}
              {/* {expandedTab === 'gameInfo' && (
                <button
                  onClick={() => setExpandedTab('social')}
                  style={{
                    backgroundColor: '#3066be',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    padding: '10px',
                    marginTop: '10px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <i className="fa-solid fa-comments" style={{ marginRight: '10px' }}></i>
                  View Comments & Social
                </button>
              )} */}
            </div>

            {/* Social Media Tab - Always at bottom */}
            <div
              className={`social-media-tab ${expandedTab === 'social' ? 'expanded' : 'collapsed'}`}
              style={{
                borderRadius: '5px',
                border: '5px solid #121212',
                padding: expandedTab === 'social' ? '15px' : '0',
                background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                height: expandedTab === 'social'
                  ? `calc(${boardSize}px - 175px)`
                  : `calc(100vh - (${boardSize}px - 90px) - 95px)`,
                overflow: 'hidden' // Changed from 'auto' to 'hidden' to control overflow
              }}
            >
              {/* Conditional header - only show when expanded */}
              {expandedTab === 'social' && (
                <div style={{
                  fontSize: '30px',
                  fontWeight: 'bold',
                  marginBottom: '5px',
                  textAlign: 'center',
                  color: '#FFA500',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                  {/* Button to return to game info - only when social is expanded */}
                  {expandedTab === 'social' && (
                    <div style={{
                      position: 'absolute',
                      left: '8px',
                      top: '25px',
                      transform: 'translateY(-65%)',
                      fontSize: '30px',
                      cursor: 'pointer',
                      color: 'rgba(255, 0, 80, 1)',
                      transition: 'all 0.3s ease'
                    }}

                      onClick={() => {
                        handleSocialTabClose();
                      }}
                      // onClick={() => {
                      //   setCommentPreviewMoves(false);
                      // Check if we're in a variation or comment move
                      // COMMENTING OUT: We want to preserve the state when closing social tab
                      /*
                      if (isVariationActive ||
                        (getMove(moves, currentMoveIdx)?.creator?.type === constants.CHESSBOARD.MOVE_TYPES.COMMENT)) {
 
                        // Get the lines to find the origin of the variation
                        const lines = getLines(currentMoveIdx);
 
                        if (lines.length > 1) {
                          // We're in a variation, get the parent move
                          let originMoveIdx = '';
 
                          // Take all but the last segment to get back to the parent move
                          const parentSegments = lines.slice(0, -1);
                          if (parentSegments.length === 0) {
                            // We're in a top-level variation, go to start
                            originMoveIdx = '-1';
                          } else {
                            // Reconstruct the parent move notation
                            originMoveIdx = parentSegments.join('|');
                          }
 
                          // Reset variation state
                          // setIsVariationActive(false);
                          // setVariationToComment(null);
 
                          // Set current move to the parent/origin move
                          // setCurrentMoveIdx(originMoveIdx);
                        } else if (getMove(moves, currentMoveIdx)?.creator?.type === constants.CHESSBOARD.MOVE_TYPES.COMMENT) {
                          // For comment moves at the main level, go to previous move (non-comment)
                          let currentIdx = parseInt(currentMoveIdx);
                          let originIdx = '-1';
 
                          // Find the nearest non-comment move
                          while (currentIdx >= 0) {
                            const moveObj = getMove(moves, String(currentIdx));
                            if (!moveObj?.creator || moveObj.creator.type !== constants.CHESSBOARD.MOVE_TYPES.COMMENT) {
                              originIdx = String(currentIdx);
                              break;
                            }
                            currentIdx--;
                          }
 
                          // Set to the non-comment move or start position
                          // setCurrentMoveIdx(originIdx);
                        }
                      }
                      */

                      // Switch to gameInfo tab
                      //   setExpandedTab('gameInfo');
                      // }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.color = '#ff0050';
                        // e.currentTarget.style.transform = 'translateY(-65%) rotate(90deg)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.color = 'rgba(255, 0, 80, 0.8)';
                        // e.currentTarget.style.transform = 'translateY(-65%) rotate(0deg)';
                      }}
                    >
                      <i className="fa-solid fa-circle-xmark"
                        style={{ marginRight: '10px' }}></i>
                    </div>
                  )}

                  Comments
                  <div style={{
                    position: 'absolute',
                    top: '18px',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    background: '#333',
                    borderRadius: '12px',
                    padding: '2px 10px',
                    fontSize: '16px',
                    color: 'white'
                  }}>
                    {gameMetadata?.comments?.length || 0}
                  </div>
                </div>
              )}

              {/* Comments section with conditional rendering based on expanded state */}
              <div className="view-comments" style={{
                width: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden', // Added to control overflow
                position: 'relative', // Added for positioning child elements
                marginBottom: expandedTab === 'social' ? '70px' : '68px', // Adjust for collapsed view
                cursor: expandedTab === 'social' ? 'default' : 'pointer' // Add pointer cursor when collapsed
              }}
                onClick={expandedTab === 'social' ? null : () => {
                  // Expand the social tab when clicked in collapsed mode
                  if (expandedTab !== 'social') {
                    // Check if there's an active variation
                    const hasVariation = detectVariationState(gameMetadata?.moves, moves, currentMoveIdx);

                    // If variation exists, set it up for commenting
                    if (hasVariation) {
                      // CRITICAL: Must set the variation to comment on, just like 'Save For Commenting' does
                      setVariationToComment(moves);
                      setIsVariationActive(true);
                    }

                    // Switch to social tab
                    setExpandedTab('social');
                  }
                }}>
                {/* Comments container - Hide if there's an active variation in expanded view */}
                <div style={{
                  flex: 1,
                  overflow: expandedTab === 'social' ? 'auto' : 'hidden', // This element scrolls in expanded mode only
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#ff6600 transparent',
                  borderRadius: expandedTab === 'social' ? '5px' : '0px',
                  overflowX: 'hidden',
                  border: (!gameMetadata?.comments || gameMetadata.comments.length === 0) ? '2px solid #444' : expandedTab === 'social' ? '2px solid #FFA500' : 'none',
                  // background: 'rgba(128, 128, 128, 0.5)',
                  background: '#1a1a2e',
                  marginBottom: expandedTab === 'social' ? '5px' : '0',
                  maxHeight: expandedTab === 'social' ? 'none' : '100%', // Use 100% in collapsed mode
                  height: '100%', // Take up all available space
                  paddingBottom: expandedTab === 'social' ? '0' : '0', // No bottom padding in collapsed view
                  display: (expandedTab === 'social' && isVariationActive) ? 'none' : 'block', // Hide when variation is active in social tab
                  position: 'relative', // For positioning the overlay message
                }}>
                  {/* Overlay message when comments are blurred */}
                  {(gameHasPuzzleTag && puzzleState !== 'completed' && expandedTab !== 'social' &&
                    gameMetadata?.comments && gameMetadata.comments.length > 0) && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        background: 'rgba(0, 0, 0, 0.7)',
                        color: 'white',
                        padding: '8px 12px',
                        width: '350px',
                        borderRadius: '5px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        filter: 'none',
                        zIndex: 10,
                        border: '1px solid rgba(255, 215, 0, 0.5)',
                        pointerEvents: 'none', // Make sure it doesn't interfere with clicks
                      }}>
                        Comments hidden until puzzle is completed. Click to view.
                      </div>
                    )}

                  {(!gameMetadata?.comments || gameMetadata.comments.length === 0) ? (
                    <div
                      style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '16px',
                        fontStyle: 'italic',
                        cursor: expandedTab === 'social' ? 'default' : 'pointer'
                      }}
                      onClick={expandedTab === 'social' ? null : () => setExpandedTab('social')}
                    >
                      Be the first to add a comment . . .
                    </div>
                  ) : (
                    <div onClick={expandedTab === 'social' ? null : () => setExpandedTab('social')} style={{
                      cursor: expandedTab === 'social' ? 'default' : 'pointer',
                      padding: '0',
                      height: 'calc(100% - 8px)',
                      display: 'flex',
                      flexDirection: 'column',
                      filter: (gameHasPuzzleTag && puzzleState !== 'completed' && expandedTab !== 'social') ? 'blur(4px)' : 'none', // Apply blur when puzzle not completed and tab collapsed

                      justifyContent: expandedTab === 'social' ? 'flex-start' : 'space-between',
                      border: expandedTab === 'social' ? 'none' : '1px solid #FFA500',
                      borderRadius: '10px'
                    }}>
                     {/* {gameMetadata.comments.slice(0, expandedTab === 'social' ? undefined : 2).map(({ user, content, id, username }, index) => ( */}
                      {getSortedComments(gameMetadata.comments)
                        .slice(0, expandedTab === 'social' ? undefined : 2)
                        .map(({ user, content, id, username, hasMoves, userPremium, moveIndex, moveNotation }, index) => (
                        <div
                          key={index}
                          className="comment-container"
                          style={{
                            fontSize: '18px',
                            borderBottom: expandedTab === 'social' ? '2px solid black' : index === 0 ? '1px solid #FFA500' : 'none',
                            padding: expandedTab === 'social' ? '4px 8px' : '2px 4px',
                            height: expandedTab === 'social' ? 'auto' : '50%', // Exact 50% height without calc
                            flex: expandedTab === 'social' ? '0 0 auto' : '1 1 50%', // Equal flex basis for both
                            boxSizing: 'border-box', // Include padding and border in height calculation
                            display: 'flex',
                            flexDirection: expandedTab === 'social' ? 'row' : 'row', // Always row for both views
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            overflow: 'hidden',
                            gap: expandedTab === 'social' ? '3px' : '5px', // Add gap for spacing,
                            background: 'rgb(51, 51, 51)',
                            borderRadius: '10px'
                          }}
                        >



                          {/* Username with badge - different layouts for expanded vs collapsed */}
                          {expandedTab === 'social' ? (
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column', // Column layout for two rows
                              alignItems: 'flex-start',
                              width: '100%',
                              lineHeight: '2rem', // Provide enough height for chess move elements
                              color: 'gold'
                            }}>
                              {/* First Row: Heart + Username + Moves (always) */}
                              <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                width: '100%',
                                gap: '8px'
                              }}>
                                {/* Heart and Report Icons */}
                                <span style={{ 
                                  display: 'flex', 
                                  flexDirection: 'row', 
                                  justifyContent: 'center', 
                                  alignItems: 'center', 
                                  gap: '8px', 
                                  padding: '4px', 
                                  borderRadius: '8px', 
                                }}>
                                  <i
                                    className={`fa-heart ${likedComments.has(id) ? 'fa-solid heart-liked' : 'fa-regular'}`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      // Find the correct index in the original comments array based on comment ID
                                      const originalIndex = gameMetadata.comments.findIndex(comment => comment.id === id);
                                      if (originalIndex !== -1) {
                                        handleCommentLike(originalIndex, gameId);
                                      } else {
                                        console.error(`Comment with ID ${id} not found in original comments array`);
                                      }
                                    }}
                                    style={{ cursor: 'pointer', color: '#ff0050' }}
                                  />
                                  <i
                                    className="fa-solid fa-circle-exclamation"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setOpenModalType('ReportComment');
                                      // Also find the correct index for the report modal
                                      const originalIndex = gameMetadata.comments.findIndex(comment => comment.id === id);
                                      if (originalIndex !== -1) {
                                        setTempCommentIndex(originalIndex);
                                      } else {
                                        setTempCommentIndex(index); // Fallback to the mapped index
                                      }
                                      setTempGameId(gameId);
                                    }}
                                    style={{ cursor: 'pointer', color: 'gray' }}
                                  />
                                </span>

                                {/* Username */}
                                <span 
                                  onClick={() => history.push(`/profile/${username}`)}
                                  style={{
                                    fontWeight: 'bold',
                                    marginRight: '2px',
                                    backgroundColor: '',
                                    padding: '4px 6px',
                                    borderRadius: '8px',
                                    fontSize: '20px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  {renderUserWithBadge(username, commentUserPremiumData[username])}
                                </span>

                                {/* Move-linked comment navigation button */}
                                {moveIndex !== undefined && moveIndex !== null && moveNotation && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setCurrentMoveIdx(moveIndex);
                                    }}
                                    style={{
                                      background: currentMoveIdx === moveIndex ? '#58b047' : '#808080',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      padding: '4px 8px',
                                      fontSize: '14px',
                                      cursor: 'pointer',
                                      marginLeft: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      transition: 'background-color 0.2s ease'
                                    }}
                                    title={`Go to move: ${moveNotation}`}
                                  >
                                    {(() => {
                                      // Calculate move number display
                                      if (moveIndex === '-1') {
                                        return 'Start Position';
                                      }
                                      const moveNumber = Math.floor(parseInt(moveIndex.split('|')[0]) / 2) + 1;
                                      const isWhite = parseInt(moveIndex.split('|')[0]) % 2 === 0;
                                      return `${moveNumber}${isWhite ? '.' : '...'} ${moveNotation}`;
                                    })()}
                                  </button>
                                )}

                                {/* Variation moves (if they exist) */}
                                {hasMoves && !moveIndex && (
                                  <span style={{}}>

                                    {isVariationActive ? (
                                      <>
                                      </>
                                    ) : (
                                      <div style={{
                                        overflowY: 'auto',
                                        maxHeight: expandedTab === 'social' ? '300px' : '200px',
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: 'gold transparent'
                                      }}>
                                        <MovesThree
                                          moves={moves}
                                          currentMove={currentMoveIdx}
                                          setCurrentMove={setCurrentMoveIdx}
                                          currentTurn={game?.turn()}
                                          type={'COMMENT_PREVIEW'} // Changed from 'COMMENTS' to 'COMMENT_PREVIEW'
                                          userId={id}
                                          // className="inline-moves" // Add a class for better styling
                                          handleVariationNavigation={handleVariationNavigation}
                                          gameResultInfo={gameResultInfo}
                                          commentPreviewMoves={commentPreviewMoves}
                                          setCommentPreviewMoves={setCommentPreviewMoves}
                                          starredMoves={starredMoves}
                                          height={expandedTab === 'social' ? '100%' : 200} // 100% for expanded social tab, fixed for collapsed
                                          isViewGame={true} // Enable variation captions and move content
                                          comments={gameMetadata?.comments || []} // Pass the comments array for matching creator IDs
                                        />
                                      </div>
                                    )}
                                  </span>
                                )}
                              </div>

                              {/* Second Row: Caption/Content (always shown if content exists, with proper text wrapping) */}
                              {content && (
                                <div style={{ 
                                  whiteSpace: 'normal', 
                                  wordWrap: 'break-word',
                                  wordBreak: 'break-word', 
                                  lineHeight: '1.5em', 
                                  marginTop: '8px',
                                  width: '88%',
                                  paddingLeft: '65px',
                                  paddingBottom: '10px',
                                  overflowWrap: 'break-word', // Modern CSS property for better word breaking
                                  hyphens: 'auto' // Add hyphenation for better text flow
                                }}>
                                  <span style={{
                                    color: '#eee',
                                    display: 'block', // Changed from inline to block for better wrapping
                                    width: '100%'
                                  }}>
                                    {cleanProfanity(content)}
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            // Collapsed view - Side by side username and content
                            <>
                              <span
                                style={{
                                  fontSize: '20px',
                                  marginRight: '',
                                  borderRadius: '5px',
                                  padding: '3px 6px',

                                  width: 'fit-content',
                                  display: 'inline-block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  flexShrink: 0,
                                  fontWeight: 'bold',
                                  color: 'gold'
                                }}
                              >
                                {renderUserWithBadge(username, commentUserPremiumData[username])}
                              </span>
                              <span style={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                fontSize: '18px',
                                color: 'white',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                {cleanProfanity(content)}
                              </span>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Add comment component - only fully visible when social tab is expanded */}
                {expandedTab === 'social' && (
                  isVariationActive ? (
                    <AddComment
                      moves={variationToComment || moves}
                      // setMoves={setMoves}
                      currentMoveIdx={currentMoveIdx}
                      setCurrentMoveIdx={setCurrentMoveIdx}
                      userId={props?.user?.credentials?.userId}
                      gameId={gameId}
                      showRateLimitError={showRateLimitError}
                      handleAddComment={(comment) => {
                        // Store the current move before submitting to calculate parent later
                        const preSubmissionMoveIdx = currentMoveIdx;
                        
                        handleAddComment(comment).then(() => {
                          
                          // Navigate back to parent move before resetting state
                          if (preSubmissionMoveIdx.includes('|')) {
                            navigateToParentMove(preSubmissionMoveIdx);
                            
                            // Save the parent move to return to when closing social tab
                            const lines = getLines(preSubmissionMoveIdx);
                            if (lines.length > 1) {
                              const parentSegments = lines.slice(0, -1);
                              const parentMoveIdx = parentSegments.length === 0 ? 
                                '-1' : parentSegments.join('|');
                              setCommentPreviewMoves({
                                parentMove: parentMoveIdx
                              });
                            }
                          }
                          
                          // State reset will be handled by AddComment2's submitComment and onVariationCommented
                        }).catch((error) => {
                          console.error('Error in handleAddComment:', error);
                          // Reset state even if there's an error
                          setVariationToComment(null);
                          setIsVariationActive(false);
                        });
                      }}
                      updateContentForMove={updateContentForMove}
                      variationToComment={variationToComment}
                      onVariationCommented={() => {
                        // Reset variation state when AddComment2 requests it
                        setVariationToComment(null);
                        setIsVariationActive(false);
                      }}
                      // Pass the necessary functions and state for the icons
                      handleDeleteCurrentCommentLine={handleDeleteCurrentCommentLine}
                      handleUndoCommentMove={handleUndoCommentMove}
                      isVariationActive={isVariationActive}
                      isUserAuthenticated={isUserAuthenticated}
                      setShowLoginPrompt={setShowLoginPrompt}
                      onInputFocusChange={setIsCommentInputFocused}
                      // NEW: Add function to show delete confirmation popup
                      showDeleteConfirmation={() => {
                        setPendingAction('delete');
                        setShowVariationDeleteConfirm(true);
                      }}
                      key={`addComment-gameTab`} // Fixed key - removed moves dependency that caused remounting
                    />
                  ) : (
                    // Standard comment input for non-variation comments
                    <div className="comment-input"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '5px',
                        marginBottom: '5px',
                        width: '100%',
                        gap: '8px'
                      }}
                    >
                      {/* Move-linking checkbox - only show when user starts typing */}
                      {newComment.trim().length > 0 && (
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          paddingLeft: '5px'
                        }}>
                        <input
                          type="checkbox"
                          id="linkToMove"
                          checked={linkToMove}
                          onChange={(e) => setLinkToMove(e.target.checked)}
                          style={{
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer'
                          }}
                        />
                        <label 
                          htmlFor="linkToMove" 
                          style={{
                            color: '#ccc',
                            fontSize: '14px',
                            cursor: 'pointer',
                            userSelect: 'none'
                          }}
                        >
                                                    Link to current move
                          {linkToMove && (
                            <span style={{ color: '#58b047', marginLeft: '8px' }}>
                              ({(() => {
                                if (currentMoveIdx === '-1') {
                                  return 'Start Position';
                                }
                                const currentMoveObj = getMoveObject(currentMoveIdx);
                                const moveNumber = Math.floor(parseInt(currentMoveIdx.split('|')[0]) / 2) + 1;
                                const isWhite = parseInt(currentMoveIdx.split('|')[0]) % 2 === 0;
                                return `${moveNumber}${isWhite ? '.' : '...'} ${currentMoveObj?.notation || ''}`;
                              })()})
                            </span>
                          )}
                        </label>
                        </div>
                      )}

                      {/* Comment input and send button */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%'
                      }}>
                        <input
                          type="text"
                          placeholder="Start typing a comment..."
                          value={newComment}
                          onChange={(e) => setNewComment(e.target.value)}
                          onFocus={() => {
                            
                            setIsCommentInputFocused(true);
                          }}
                          onBlur={() => {
                            
                            setIsCommentInputFocused(false);
                          }}
                          style={{
                            flex: '1',
                            height: '40px',
                            paddingLeft: '20px',
                            fontSize: '18px',
                            borderRadius: '5px',
                            background: 'transparent',
                            color: 'white',
                            border: '2px solid rgb(255, 165, 0)',
                            outline: 'none'
                          }}
                        />
                        <button
                          style={{
                            height: '48px',
                            minWidth: '95px',
                            backgroundColor: 'transparent',
                            color: 'rgb(255, 165, 0)',
                            borderRadius: '5px',
                            border: '2px solid rgb(255, 165, 0)',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            marginLeft: '5px',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            // Check if user is authenticated
                            if (!isUserAuthenticated()) {
                              setShowLoginPrompt(true);
                              return;
                            }

                            // Rate limiting check
                            const userTier = 'free'; // TODO: Get actual user tier from props/context
                            const config = getRateLimit('COMMENT', userTier);
                            const rateKey = buildRateKey(props?.user?.credentials?.userId, gameId, 'comment');
                            
                            const isLimited = checkRateLimit({
                              key: rateKey,
                              limit: config.limit,
                              windowMs: config.windowMs
                            });

                            if (isLimited) {
                              showRateLimitError();
                              return;
                            }
                            
                            if (newComment.trim()) {
                              // NEW: Capture move data if linking is enabled
                              const moveData = captureMoveData();
                              handleAddComment(newComment, moveData);
                              setNewComment('');
                              setLinkToMove(false); // Reset checkbox after sending
                            }
                          }}
                        >
                          SEND
                        </button>
                      </div>
                    </div>
                  )
                )}

                {/* Remove Variation control icons for Social tab since they're now in AddComment */}
              </div>
              {/* Social action buttons - Now positioned absolutely at the bottom */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-around',
                padding: '10px 0',
                borderTop: '1px solid #333',
                position: 'absolute',
                bottom: '0',
                left: '0',
                right: '0',
                backgroundColor: 'rgb(26, 38, 53)', // Background to ensure buttons are readable
                zIndex: 10 // Ensure buttons stay on top
              }}>
                <button
                  className={`action-btn like ${isLiked ? 'liked' : ''}`}
                  onClick={() => {
                    if (!isUserAuthenticated()) {
                      setShowLoginPrompt(true);
                      return;
                    }
                    handleLikeClick(gameId, gameMetadata);
                  }}
                  style={{
                    background: 'transparent',
                    color: '#ff0050',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 0 12px rgba(255, 51, 102, 0.8)'

                  }}
                  onMouseOver={(e) => {
                    if (!gameMetadata?.likes?.includes(props?.user?.credentials?.userId)) {
                      e.currentTarget.style.color = '#ff0050';
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 51, 102, 0.8)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 51, 102, 1)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!gameMetadata?.likes?.includes(props?.user?.credentials?.userId)) {
                      e.currentTarget.style.color = '#ff0050';
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 51, 102, 0.8)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 51, 102, 0.8)';
                    }
                  }}
                >
                  <i className={gameMetadata?.likes?.includes(props?.user?.credentials?.userId) ? "fa-solid fa-heart" : "fa-regular fa-heart"}></i>
                </button>

                <button
                  className={`action-btn dismiss ${isDisliked ? 'disliked' : ''}`}
                  onClick={() => {
                    if (!isUserAuthenticated()) {
                      setShowLoginPrompt(true);
                      return;
                    }
                    handleDislikeClick(gameId, gameMetadata);
                  }}
                  style={{
                    background: 'transparent',
                    color: gameMetadata?.dislikes?.includes(props?.user?.credentials?.userId) ? '#ff0050' : '#777',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: gameMetadata?.dislikes?.includes(props?.user?.credentials?.userId)
                      ? '0 0 12px rgba(255, 0, 80, 0.8)'
                      : '0 0 8px rgba(80, 80, 80, 0.5)',
                  }}
                  onMouseOver={(e) => {
                    if (!gameMetadata?.dislikes?.includes(props?.user?.credentials?.userId)) {
                      e.currentTarget.style.color = '#ff0050';
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 0, 80, 0.8)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 0, 80, 1)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!gameMetadata?.dislikes?.includes(props?.user?.credentials?.userId)) {
                      e.currentTarget.style.color = '#777';
                      e.currentTarget.style.boxShadow = '0 0 8px rgba(80, 80, 80, 0.5)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 0, 80, 0.8)';
                    }
                  }}
                >
                  <i className={gameMetadata?.dislikes?.includes(props?.user?.credentials?.userId) ? "fa-solid fa-thumbs-down" : "fa-regular fa-thumbs-down"}></i>
                </button>

                <button
                  className="action-btn bookmark"
                  onClick={() => {
                    if (!isUserAuthenticated()) {
                      setShowLoginPrompt(true);
                      return;
                    }
                    
                    if (isBookmarked) {
                      handleRemoveBookmark();
                    } else {
                      setShowBookmarkModal(true);
                    }
                  }}
                  style={{
                    background: 'transparent',
                    color: isBookmarked ? 'gold' : '#777',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: isBookmarked
                      ? '0 0 12px rgba(255, 215, 0, 0.8)'
                      : '0 0 8px rgba(80, 80, 80, 0.5)'
                  }}
                  onMouseOver={(e) => {
                    if (!isBookmarked) {
                      e.currentTarget.style.color = 'gold';
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 215, 0, 0.8)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 215, 0, 1)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isBookmarked) {
                      e.currentTarget.style.color = '#777';
                      e.currentTarget.style.boxShadow = '0 0 8px rgba(80, 80, 80, 0.5)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 215, 0, 0.8)';
                    }
                  }}
                >
                  <i className={isBookmarked ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"}></i>
                </button>

                {/* New toggle button for comments/chess board */}
                <button
                  className="action-btn toggle-view"
                  onClick={() => {
                    // Toggle between game info and social tabs
                    if (expandedTab === 'social') {
                      // We're in social tab, switch back to game info
                      handleSocialTabClose();
                    } else {
                      // We're in game info tab, switch to social tab

                      // Check if there's an active variation to comment on
                      const hasVariation = detectVariationState(gameMetadata?.moves, moves, currentMoveIdx);

                      // If variation exists, set it up for commenting
                      if (hasVariation) {
                        // Set the variation to comment on, just like 'Save For Commenting' does
                        setVariationToComment(moves);
                        setIsVariationActive(true);
                      }

                      // Always switch to social tab, regardless of variation status
                      setExpandedTab('social');
                    }
                  }}
                  style={{
                    background: 'transparent',
                    color: expandedTab === 'social' ? '#58b047' : '#FFA500',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative',
                    boxShadow: expandedTab === 'social'
                      ? '0 0 12px rgba(88, 176, 71, 0.8)'
                      : '0 0 12px rgba(255, 102, 0, 0.8)',
                  }}
                  onMouseOver={(e) => {
                    if (expandedTab === 'social') {
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(88, 176, 71, 1)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 102, 0, 1)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (expandedTab === 'social') {
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(88, 176, 71, 0.8)';
                    } else {
                      e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 102, 0, 0.8)';
                    }
                  }}
                >
                  {expandedTab === 'social' ? (
                    <i className="fa-solid fa-chess-board"></i>
                  ) : (
                    <>
                      <i className="fa-regular fa-comments"></i>
                      {(gameMetadata?.comments?.length > 0) && (
                        <div style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                          background: '#58b047',
                          color: 'white',
                          borderRadius: '50%',
                          width: '22px',
                          height: '22px',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          border: '2px solid black'
                        }}>
                          {gameMetadata?.comments?.length > 9 ? '9+' : gameMetadata?.comments?.length}
                        </div>
                      )}
                    </>
                  )}
                </button>

                <button
                  className="action-btn share"
                  style={{
                    background: 'transparent',
                    color: '#777',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 0 8px rgba(80, 80, 80, 0.5)',
                  }}
                  onClick={() => {
                    setShowShareModal(true);
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#3066be';
                    e.currentTarget.style.boxShadow = '0 0 12px rgba(48, 102, 190, 0.8)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#777';
                    e.currentTarget.style.boxShadow = '0 0 8px rgba(80, 80, 80, 0.5)';
                  }}
                >
                  <i className="fa-regular fa-paper-plane"></i>
                </button>

                <button
                  className="action-btn prev"
                  style={{
                    background: 'transparent',
                    color: '#777',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 0 8px rgba(80, 80, 80, 0.5)',
                  }}
                  onClick={() => {
                    if (!isUserAuthenticated()) {
                      setShowLoginPrompt(true);
                      return;
                    }
                    handlePrevGameClick();
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#3066be';
                    e.currentTarget.style.boxShadow = '0 0 12px rgba(48, 102, 190, 0.8)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#777';
                    e.currentTarget.style.boxShadow = '0 0 8px rgba(80, 80, 80, 0.5)';
                  }}
                >
                  <i className="fa-solid fa-circle-arrow-left"></i>
                </button>

                <button
                  className="action-btn next"
                  style={{
                    background: 'transparent',
                    color: 'gold',
                    border: 'none',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 0 12px rgba(255, 215, 0, 0.8)',
                  }}
                  onClick={() => {
                    if (!isUserAuthenticated()) {
                      setShowLoginPrompt(true);
                      return;
                    }
                    handleNextGameClick();
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#ffcc00';
                    e.currentTarget.style.boxShadow = '0 0 16px rgba(255, 215, 0, 1)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = 'gold';
                    e.currentTarget.style.boxShadow = '0 0 12px rgba(255, 215, 0, 0.8)';
                  }}
                >
                  <i className="fa-solid fa-circle-arrow-right"></i>
                </button>
              </div>
            </div>

            {/* Expanded Annotation Tab */}
            {expandedAnnotation && (
              <div style={{
                position: 'fixed',
                top: '300px',
                left: '0',
                right: '0',
                bottom: '0',
                background: 'red',
                zIndex: 1000,
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                borderTop: '2px solid #3066be',
                width: '90%',
                height: 'calc(100vh - 200px)',
              }}>
                <div
                  className="annotation-header"
                  style={{
                    fontSize: '30px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    textAlign: 'center',
                    borderBottom: '2px solid gold',
                    paddingBottom: '10px',
                    color: 'gold',
                  }}
                >
                  A N N O T A T I O N
                </div>
                <div
                  className="annotation-content"
                  style={{
                    flex: 1,
                    overflow: 'auto',
                    padding: '20px',
                    fontSize: '20px',
                    color: 'white',
                    textAlign: 'left',
                    lineHeight: '1.5',
                    background: 'rgba(0, 0, 0, 0.5)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '5px',
                    margin: '0 auto',
                    width: '90%',
                    maxWidth: '1000px',
                  }}
                >
                                            {cleanProfanity(expandedAnnotationContent || currentMove?.content)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* UndoConfirmModal for variation operations */}
      {
        showUndoConfirmModal && (
          <UndoConfirmModal
            onClose={() => setShowUndoConfirmModal(false)}
            onConfirmUndo={handleEndLineHere}
            onJumpToEnd={handleJumpToLastMove}
          />
        )
      }
      {
        showVariationDeleteConfirm && (
          <VariationDeleteConfirmDialog />
        )
      }
    </div >
  );
};

ViewGame2.propTypes = {
  getScreams: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getScreams })(ViewGame2);



